// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions
} from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { client } from '../client.gen'
import {
  accountChangePasswordConfirmCreate,
  accountChangePasswordRequestCreate,
  accountCreate,
  accountDestroy,
  accountLinkedAuthMethodsRetrieve,
  accountNotificationPreferencesRetrieve,
  accountNotificationPreferencesUpdate,
  accountNotificationsMarkReadCreate,
  accountNotificationsRetrieve,
  accountNotificationsUnreadCountRetrieve,
  accountOrgLinkedMethodsRetrieve,
  accountOrgSocialAccountsDestroy,
  accountPartialUpdate,
  accountPasskeysDestroy,
  accountPasskeysList,
  accountPasskeysPartialUpdate,
  accountPasskeysRegisterStartCreate,
  accountPasskeysRegisterVerifyCreate,
  accountRetrieve,
  accountServicesList,
  accountSessionsDestroy,
  accountSessionsList,
  accountSessionsRevokeAllOthersDestroy,
  accountSignInPolicyPartialUpdate,
  accountSignInPolicyRetrieve,
  accountSignInPolicyUpdate,
  accountSocialAccountsDestroy,
  accountUnlinkPasswordCreate,
  accountUserPartialUpdate,
  applicationsAccessCreate,
  applicationsApplicationsAccessList,
  applicationsApplicationsAccessRetrieve,
  applicationsApplicationsCredentialsCreate,
  applicationsApplicationsCredentialsList,
  applicationsApplicationsCredentialsPartialUpdate,
  applicationsApplicationsCredentialsRetrieve,
  applicationsApplicationsCredentialsRevokeCreate,
  applicationsApplicationsCredentialsRotateCreate,
  applicationsApplicationsList,
  applicationsApplicationsPartialUpdate,
  applicationsApplicationsRepositoriesList,
  applicationsApplicationsRepositoriesRetrieve,
  applicationsApplicationsRetrieve,
  applicationsApplicationsScimPartialUpdate,
  applicationsApplicationsScimRetrieve,
  applicationsApplicationsScimRotateInboundTokenCreate,
  applicationsApplicationsUpdate,
  applicationsApplicationsWebhookConfigClearSecretCreate,
  applicationsApplicationsWebhookConfigPartialUpdate,
  applicationsApplicationsWebhookConfigRetrieve,
  applicationsApplicationsWebhookConfigRotateSecretCreate,
  applicationsCreate,
  applicationsMobileBuildsLatestRetrieve,
  applicationsNetworkingOrganizationsByEmailCreate,
  applicationsNetworkingOrganizationsList,
  applicationsRemoveDestroy,
  applicationsTeamListList,
  applicationsThirdPartyCreate,
  applicationsUserCanAccessRetrieve,
  applicationsUserDetailsRetrieve,
  applicationsUserListList,
  applicationsUserMembershipRetrieve,
  applicationsValidateRetrieve,
  attachmentsCreateAvatarSignedUrlCreate,
  attachmentsCreateSignedUrlCreate,
  attachmentsDestroy,
  attachmentsList,
  attachmentsRetrieve,
  attachmentsVersionDestroy,
  attachmentsVersionRetrieve,
  attachmentsVisibilityPartialUpdate,
  attachmentsWebhookCreate,
  authorizationClientAuthMethodsRetrieve,
  authorizationPasskeyAuthenticateStartCreate,
  authorizationPasskeyAuthenticateVerifyCreate,
  authorizationQrApproveCreate,
  authorizationQrCancelCreate,
  authorizationQrDenyCreate,
  authorizationQrScanCreate,
  authorizationQrStartCreate,
  authorizationQrWaitCreate,
  authorizationSocialAppleConnectCreate,
  authorizationSocialAppleConnectUrlCreate,
  authorizationSocialAppleOrgConnectCreate,
  authorizationSocialAppleOrgConnectUrlCreate,
  authorizationSocialAppleStartClientCreate,
  authorizationSocialAppleStartCreate,
  authorizationSocialAppleStateInfoRetrieve,
  authorizationSocialCustomExchangeCreate,
  authorizationSocialCustomSamlExchangeCreate,
  authorizationSocialCustomStartCreate,
  authorizationSocialEntraidConnectCreate,
  authorizationSocialEntraidConnectUrlCreate,
  authorizationSocialEntraidStartCreate,
  authorizationSocialEntraidStateInfoRetrieve,
  authorizationSocialExchangeClientCreate,
  authorizationSocialExchangeCreate,
  authorizationSocialGoogleClientConnectCreate,
  authorizationSocialGoogleClientConnectUrlCreate,
  authorizationSocialGoogleConnectCreate,
  authorizationSocialGoogleConnectUrlCreate,
  authorizationSocialGoogleStartClientCreate,
  authorizationSocialGoogleStartCreate,
  authorizationSocialGoogleStateInfoRetrieve,
  authorizationTokenClientCreate,
  authorizationTokenCookieRetrieve,
  authorizationTokenCreate,
  authorizationTokenLogoutRetrieve,
  authorizationTokenOtpLinkVerifyCreate,
  authorizationTokenOtpRequestCreate,
  authorizationTokenOtpVerifyCreate,
  authorizationTokenRefreshCreate,
  authorizationTokenServiceVerifyCreate,
  authorizationTokenVerifyCreate,
  authorizationV2ClientsCreate,
  authorizationV2ClientsList,
  authorizationV2ClientsPartialUpdate,
  authorizationV2ClientsRetrieve,
  authorizationV2ClientsRevokeCreate,
  authorizationV2ClientsRotateCreate,
  authorizationV2EmailVerifyCreate,
  authorizationV2InviteAcceptCreate,
  authorizationV2InviteInfoRetrieve,
  authorizationV2InviteRequestCreate,
  authorizationV2PasswordRequestCreate,
  authorizationV2PasswordResetCreate,
  authorizationV2SchemaRetrieve,
  authorizationV2SignupConfirmCreate,
  authorizationV2SignupStartCreate,
  commonCountriesList,
  commonCountriesRetrieve,
  commonHealthRetrieve,
  commonIndustriesList,
  commonIndustriesRetrieve,
  commonProtectedRetrieve,
  integrationApplicationPublishCreate,
  integrationApplicationsDataRetrieve,
  integrationApplicationsList,
  integrationApplicationsNotificationsCreate,
  integrationApplicationsRetrieve,
  integrationApplicationsRolePermissionsCreate,
  integrationApplicationsRolesCreate,
  integrationFeedRetrieve,
  integrationGoogleMailCallbackRetrieve,
  integrationGoogleMailConnectionsDisconnectCreate,
  integrationGoogleMailConnectionsRetrieve,
  integrationGoogleMailConnectStartCreate,
  integrationMicrosoftGraphAvailabilityRetrieve,
  integrationMicrosoftGraphCallbackRetrieve,
  integrationMicrosoftGraphConnectionsDisconnectCreate,
  integrationMicrosoftGraphConnectionsList,
  integrationMicrosoftGraphConnectStartCreate,
  integrationMicrosoftGraphDisconnectCreate,
  integrationMicrosoftGraphStatusRetrieve,
  integrationPermissionMigrationsApplyCreate,
  integrationRpcPresetsList,
  integrationRpcPresetsRetrieve,
  integrationSetupJobsDestroy,
  integrationSetupJobsList,
  integrationSetupJobsRetrieve,
  integrationSetupJobsRetryCreate,
  integrationSyncPermissionsCreate,
  integrationSyncRpcMethodsCreate,
  integrationSyncRpcTemplatesCreate,
  integrationTeamsList,
  integrationTeamsRetrieve,
  integrationUserGroupsList,
  integrationUserGroupsRetrieve,
  integrationUserRetrieve,
  integrationUsersCreate,
  integrationUsersInviteCreate,
  integrationUsersList,
  integrationUsersPartialUpdate,
  integrationUsersRetrieve,
  integrationV2ApplicationPublishCreate,
  integrationV2ApplicationsDataRetrieve,
  integrationV2ApplicationsList,
  integrationV2ApplicationsNotificationsCreate,
  integrationV2ApplicationsRetrieve,
  integrationV2ApplicationsRolePermissionsCreate,
  integrationV2ApplicationsRolesCreate,
  integrationV2AppsRolesCreate,
  integrationV2AppsRolesDestroy,
  integrationV2AppsRolesList,
  integrationV2AppsRolesMembersRetrieve,
  integrationV2AppsRolesMembersUpdate,
  integrationV2AppsRolesPartialUpdate,
  integrationV2AppsRolesRetrieve,
  integrationV2FeedRetrieve,
  integrationV2RpcPresetsList,
  integrationV2RpcPresetsRetrieve,
  integrationV2SetupJobsDestroy,
  integrationV2SetupJobsList,
  integrationV2SetupJobsRetrieve,
  integrationV2SetupJobsRetryCreate,
  integrationV2SyncPermissionsCreate,
  integrationV2SyncRpcMethodsCreate,
  integrationV2TeamsList,
  integrationV2TeamsRetrieve,
  integrationV2UserRetrieve,
  integrationV2UsersCreate,
  integrationV2UsersInviteCreate,
  integrationV2UsersList,
  integrationV2UsersPartialUpdate,
  integrationV2UsersRetrieve,
  internalGoogleMailTokenCreate,
  internalMcpConnectionRetrieve,
  internalMicrosoftGraphTokenCreate,
  internalPublicAccessCredentialsSnapshotRetrieve,
  internalPublicAccessCredentialsUsageCreate,
  mcpConnectionsList,
  mcpConnectionsRevoke,
  mcpConnectionsScopesUpdate,
  mcpConsentApprove,
  mcpConsentDeny,
  mcpConsentRetrieve,
  mcpMyConnectionsList,
  mcpMyConnectionsRevoke,
  mcpMyConnectionsScopesUpdate,
  mcpMyServicesList,
  mcpPersonalTokensCreate,
  mcpPoliciesList,
  mcpPoliciesPartialUpdate,
  mcpToolsCallCreate,
  mcpToolsRetrieve,
  mfaConfigDownloadBackupCodesCreate,
  mfaConfigGenerateBackupCodesCreate,
  mfaConfigPartialUpdate,
  mfaConfigRetrieve,
  mfaConfigUpdate,
  mfaInternalAuditLogsExportCreate,
  mfaInternalAuditLogsList,
  mfaInternalConfigsList,
  mfaInternalConfigsPartialUpdate,
  mfaInternalConfigsRetrieve,
  mfaInternalConfigsUpdate,
  mfaInternalLockoutsDestroy,
  mfaInternalLockoutsList,
  mfaSendOtpCreate,
  mfaTrustedDevicesDeleteAllDestroy,
  mfaTrustedDevicesDestroy,
  mfaTrustedDevicesList,
  mfaVerifyBackupCodeCreate,
  mfaVerifyOtpCreate,
  onboardingInternalStepsCreate,
  onboardingJourneysPartialUpdate,
  onboardingJourneysRetrieve,
  onboardingProfileCreate,
  onboardingProfilePartialUpdate,
  onboardingProfileRetrieve,
  type Options,
  organizationsAccessAddCreate,
  organizationsAccessBlockCreate,
  organizationsAccessDestroy,
  organizationsAccessDisableMfaCreate,
  organizationsAccessImpersonateCreate,
  organizationsAccessList,
  organizationsAccessOrganigramaList,
  organizationsAccessPartialUpdate,
  organizationsAccessRequireMfaCreate,
  organizationsAccessResendInviteCreate,
  organizationsAccessResetMfaCreate,
  organizationsAccessResetPasswordCreate,
  organizationsAccessRetrieve,
  organizationsAccessRevokeInviteCreate,
  organizationsAccessRolesCreate,
  organizationsAccessSessionsDestroy,
  organizationsAccessSessionsList,
  organizationsAccessSessionsRevokeAllCreate,
  organizationsAccessSignInActivityRetrieve,
  organizationsAuditArchivesBulkDeleteDestroy,
  organizationsAuditArchivesCreate,
  organizationsAuditArchivesDestroy,
  organizationsAuditArchivesDownloadRetrieve,
  organizationsAuditArchivesList,
  organizationsAuditArchivesRetrieve,
  organizationsAuditLogsFiltersRetrieve,
  organizationsAuditLogsList,
  organizationsAuditLogsRetrieve,
  organizationsAuditLogsSignInActivityRetrieve,
  organizationsDomainAvailabilityRetrieve,
  organizationsDomainMatchRetrieve,
  organizationsInfoRetrieve,
  organizationsJoinRequestsApproveCreate,
  organizationsJoinRequestsCreate,
  organizationsJoinRequestsList,
  organizationsJoinRequestsRejectCreate,
  organizationsOrganizationsAuthMethodsPartialUpdate,
  organizationsOrganizationsAuthMethodsRetrieve,
  organizationsOrganizationsCreate,
  organizationsOrganizationsCustomAuthProvidersCreate,
  organizationsOrganizationsCustomAuthProvidersDestroy,
  organizationsOrganizationsCustomAuthProvidersList,
  organizationsOrganizationsCustomAuthProvidersPartialUpdate,
  organizationsOrganizationsCustomAuthProvidersRetrieve,
  organizationsOrganizationsDemoDisableCreate,
  organizationsOrganizationsDemoEnableCreate,
  organizationsOrganizationsDestroy,
  organizationsOrganizationsEnvironmentBuildCreate,
  organizationsOrganizationsEnvironmentClearCreate,
  organizationsOrganizationsList,
  organizationsOrganizationsMemberAuthMethodsList,
  organizationsOrganizationsMicrosoftAppRegistrationPartialUpdate,
  organizationsOrganizationsMicrosoftAppRegistrationRetrieve,
  organizationsOrganizationsPartialUpdate,
  organizationsOrganizationsRetrieve,
  organizationsOrganizationsTransferOwnershipCreate,
  organizationsPermissionsUserList,
  organizationsRolesCreate,
  organizationsRolesDestroy,
  organizationsRolesList,
  organizationsRolesPartialUpdate,
  organizationsRolesReplaceCreate,
  organizationsRolesRetrieve,
  organizationsTeamsCreate,
  organizationsTeamsDestroy,
  organizationsTeamsList,
  organizationsTeamsOrganigramList,
  organizationsTeamsPartialUpdate,
  organizationsTeamsRetrieve,
  organizationsTeamUsersCreate,
  organizationsTeamUsersDestroy,
  organizationsTeamUsersList,
  organizationsTeamUsersRetrieve,
  organizationsUserGroupsApplicationsRolesPartialUpdate,
  organizationsUserGroupsCreate,
  organizationsUserGroupsDestroy,
  organizationsUserGroupsList,
  organizationsUserGroupsPartialUpdate,
  organizationsUserGroupsRetrieve,
  organizationsValidateRetrieve,
  organizationsWorkspacePermissionsList,
  organizationsWorkspaceRolesCreate,
  organizationsWorkspaceRolesDestroy,
  organizationsWorkspaceRolesList,
  organizationsWorkspaceRolesPartialUpdate,
  organizationsWorkspaceRolesRetrieve,
  permissionsCreate,
  permissionsDestroy,
  permissionsList,
  permissionsPartialUpdate,
  permissionsRetrieve,
  schemaRetrieve,
  settingsOutboundWebhooksWebhooksCreate,
  settingsOutboundWebhooksWebhooksDestroy,
  settingsOutboundWebhooksWebhooksList,
  settingsOutboundWebhooksWebhooksPartialUpdate,
  settingsOutboundWebhooksWebhooksRetrieve,
  settingsOutboundWebhooksWebhooksRevealSecretCreate,
  settingsOutboundWebhooksWebhooksTestCreate,
  settingsPublicAccessCredentialsCreate,
  settingsPublicAccessCredentialsList,
  settingsPublicAccessCredentialsPartialUpdate,
  settingsPublicAccessCredentialsRetrieve,
  settingsPublicAccessCredentialsRevokeCreate,
  settingsPublicAccessCredentialsRotateCreate,
  staticRetrieve,
  supportReportCreate,
  supportTicketsCommentsCreate,
  supportTicketsCommentsList,
  supportTicketsCreate,
  supportTicketsList,
  supportTicketsRetrieve,
  supportTicketsUnseenCountRetrieve,
  supportTicketsUploadsCreate,
  usersAddInOrganizationCreate,
  usersArchiveCreate,
  usersArchiveDependenciesRetrieve,
  usersArchiveJobsRetrieve,
  usersArchiveReplaceAndArchiveCreate,
  usersEditPartialUpdate,
  usersEditUpdate,
  usersList,
  usersLoginAdminCreate,
  usersLoginUserCreate,
  usersNotificationServiceSyncCreate,
  usersPartialUpdate,
  usersRetrieve,
  usersSyncActiveDirectoryCreate
} from '../sdk.gen'
import type {
  AccountChangePasswordConfirmCreateData,
  AccountChangePasswordConfirmCreateResponse,
  AccountChangePasswordRequestCreateData,
  AccountCreateData,
  AccountCreateResponse,
  AccountDestroyData,
  AccountDestroyResponse,
  AccountLinkedAuthMethodsRetrieveData,
  AccountLinkedAuthMethodsRetrieveResponse,
  AccountNotificationPreferencesRetrieveData,
  AccountNotificationPreferencesRetrieveResponse,
  AccountNotificationPreferencesUpdateData,
  AccountNotificationPreferencesUpdateResponse,
  AccountNotificationsMarkReadCreateData,
  AccountNotificationsMarkReadCreateResponse,
  AccountNotificationsRetrieveData,
  AccountNotificationsRetrieveResponse,
  AccountNotificationsUnreadCountRetrieveData,
  AccountNotificationsUnreadCountRetrieveResponse,
  AccountOrgLinkedMethodsRetrieveData,
  AccountOrgLinkedMethodsRetrieveResponse,
  AccountOrgSocialAccountsDestroyData,
  AccountOrgSocialAccountsDestroyResponse,
  AccountPartialUpdateData,
  AccountPartialUpdateResponse,
  AccountPasskeysDestroyData,
  AccountPasskeysDestroyResponse,
  AccountPasskeysListData,
  AccountPasskeysListResponse,
  AccountPasskeysPartialUpdateData,
  AccountPasskeysPartialUpdateResponse,
  AccountPasskeysRegisterStartCreateData,
  AccountPasskeysRegisterStartCreateResponse,
  AccountPasskeysRegisterVerifyCreateData,
  AccountPasskeysRegisterVerifyCreateResponse,
  AccountRetrieveData,
  AccountRetrieveResponse,
  AccountServicesListData,
  AccountServicesListResponse,
  AccountSessionsDestroyData,
  AccountSessionsDestroyResponse,
  AccountSessionsListData,
  AccountSessionsListResponse,
  AccountSessionsRevokeAllOthersDestroyData,
  AccountSessionsRevokeAllOthersDestroyResponse,
  AccountSignInPolicyPartialUpdateData,
  AccountSignInPolicyPartialUpdateResponse,
  AccountSignInPolicyRetrieveData,
  AccountSignInPolicyRetrieveResponse,
  AccountSignInPolicyUpdateData,
  AccountSignInPolicyUpdateResponse,
  AccountSocialAccountsDestroyData,
  AccountSocialAccountsDestroyResponse,
  AccountUnlinkPasswordCreateData,
  AccountUserPartialUpdateData,
  AccountUserPartialUpdateResponse,
  ApplicationsAccessCreateData,
  ApplicationsAccessCreateResponse,
  ApplicationsApplicationsAccessListData,
  ApplicationsApplicationsAccessListResponse,
  ApplicationsApplicationsAccessRetrieveData,
  ApplicationsApplicationsAccessRetrieveResponse,
  ApplicationsApplicationsCredentialsCreateData,
  ApplicationsApplicationsCredentialsCreateResponse,
  ApplicationsApplicationsCredentialsListData,
  ApplicationsApplicationsCredentialsListResponse,
  ApplicationsApplicationsCredentialsPartialUpdateData,
  ApplicationsApplicationsCredentialsPartialUpdateResponse,
  ApplicationsApplicationsCredentialsRetrieveData,
  ApplicationsApplicationsCredentialsRetrieveResponse,
  ApplicationsApplicationsCredentialsRevokeCreateData,
  ApplicationsApplicationsCredentialsRevokeCreateResponse,
  ApplicationsApplicationsCredentialsRotateCreateData,
  ApplicationsApplicationsCredentialsRotateCreateResponse,
  ApplicationsApplicationsListData,
  ApplicationsApplicationsListResponse,
  ApplicationsApplicationsPartialUpdateData,
  ApplicationsApplicationsPartialUpdateResponse,
  ApplicationsApplicationsRepositoriesListData,
  ApplicationsApplicationsRepositoriesListResponse,
  ApplicationsApplicationsRepositoriesRetrieveData,
  ApplicationsApplicationsRepositoriesRetrieveResponse,
  ApplicationsApplicationsRetrieveData,
  ApplicationsApplicationsRetrieveResponse,
  ApplicationsApplicationsScimPartialUpdateData,
  ApplicationsApplicationsScimPartialUpdateResponse,
  ApplicationsApplicationsScimRetrieveData,
  ApplicationsApplicationsScimRetrieveResponse,
  ApplicationsApplicationsScimRotateInboundTokenCreateData,
  ApplicationsApplicationsScimRotateInboundTokenCreateResponse,
  ApplicationsApplicationsUpdateData,
  ApplicationsApplicationsUpdateResponse,
  ApplicationsApplicationsWebhookConfigClearSecretCreateData,
  ApplicationsApplicationsWebhookConfigClearSecretCreateResponse,
  ApplicationsApplicationsWebhookConfigPartialUpdateData,
  ApplicationsApplicationsWebhookConfigPartialUpdateResponse,
  ApplicationsApplicationsWebhookConfigRetrieveData,
  ApplicationsApplicationsWebhookConfigRetrieveResponse,
  ApplicationsApplicationsWebhookConfigRotateSecretCreateData,
  ApplicationsApplicationsWebhookConfigRotateSecretCreateResponse,
  ApplicationsCreateData,
  ApplicationsCreateResponse,
  ApplicationsMobileBuildsLatestRetrieveData,
  ApplicationsMobileBuildsLatestRetrieveResponse,
  ApplicationsNetworkingOrganizationsByEmailCreateData,
  ApplicationsNetworkingOrganizationsByEmailCreateResponse,
  ApplicationsNetworkingOrganizationsListData,
  ApplicationsNetworkingOrganizationsListResponse,
  ApplicationsRemoveDestroyData,
  ApplicationsRemoveDestroyResponse,
  ApplicationsTeamListListData,
  ApplicationsTeamListListResponse,
  ApplicationsThirdPartyCreateData,
  ApplicationsThirdPartyCreateResponse,
  ApplicationsUserCanAccessRetrieveData,
  ApplicationsUserCanAccessRetrieveError,
  ApplicationsUserCanAccessRetrieveResponse,
  ApplicationsUserDetailsRetrieveData,
  ApplicationsUserDetailsRetrieveResponse,
  ApplicationsUserListListData,
  ApplicationsUserListListResponse,
  ApplicationsUserMembershipRetrieveData,
  ApplicationsUserMembershipRetrieveResponse,
  ApplicationsValidateRetrieveData,
  ApplicationsValidateRetrieveResponse,
  AttachmentsCreateAvatarSignedUrlCreateData,
  AttachmentsCreateAvatarSignedUrlCreateResponse,
  AttachmentsCreateSignedUrlCreateData,
  AttachmentsCreateSignedUrlCreateResponse,
  AttachmentsDestroyData,
  AttachmentsDestroyResponse,
  AttachmentsListData,
  AttachmentsListResponse,
  AttachmentsRetrieveData,
  AttachmentsRetrieveResponse,
  AttachmentsVersionDestroyData,
  AttachmentsVersionDestroyResponse,
  AttachmentsVersionRetrieveData,
  AttachmentsVersionRetrieveResponse,
  AttachmentsVisibilityPartialUpdateData,
  AttachmentsVisibilityPartialUpdateResponse,
  AttachmentsWebhookCreateData,
  AuthorizationClientAuthMethodsRetrieveData,
  AuthorizationClientAuthMethodsRetrieveResponse,
  AuthorizationPasskeyAuthenticateStartCreateData,
  AuthorizationPasskeyAuthenticateStartCreateResponse,
  AuthorizationPasskeyAuthenticateVerifyCreateData,
  AuthorizationPasskeyAuthenticateVerifyCreateResponse,
  AuthorizationQrApproveCreateData,
  AuthorizationQrApproveCreateError,
  AuthorizationQrApproveCreateResponse,
  AuthorizationQrCancelCreateData,
  AuthorizationQrCancelCreateError,
  AuthorizationQrCancelCreateResponse,
  AuthorizationQrDenyCreateData,
  AuthorizationQrDenyCreateError,
  AuthorizationQrDenyCreateResponse,
  AuthorizationQrScanCreateData,
  AuthorizationQrScanCreateError,
  AuthorizationQrScanCreateResponse,
  AuthorizationQrStartCreateData,
  AuthorizationQrStartCreateError,
  AuthorizationQrStartCreateResponse,
  AuthorizationQrWaitCreateData,
  AuthorizationQrWaitCreateError,
  AuthorizationQrWaitCreateResponse,
  AuthorizationSocialAppleConnectCreateData,
  AuthorizationSocialAppleConnectCreateResponse,
  AuthorizationSocialAppleConnectUrlCreateData,
  AuthorizationSocialAppleConnectUrlCreateResponse,
  AuthorizationSocialAppleOrgConnectCreateData,
  AuthorizationSocialAppleOrgConnectCreateResponse,
  AuthorizationSocialAppleOrgConnectUrlCreateData,
  AuthorizationSocialAppleOrgConnectUrlCreateResponse,
  AuthorizationSocialAppleStartClientCreateData,
  AuthorizationSocialAppleStartClientCreateResponse,
  AuthorizationSocialAppleStartCreateData,
  AuthorizationSocialAppleStartCreateResponse,
  AuthorizationSocialAppleStateInfoRetrieveData,
  AuthorizationSocialCustomExchangeCreateData,
  AuthorizationSocialCustomExchangeCreateResponse,
  AuthorizationSocialCustomSamlExchangeCreateData,
  AuthorizationSocialCustomSamlExchangeCreateResponse,
  AuthorizationSocialCustomStartCreateData,
  AuthorizationSocialCustomStartCreateResponse,
  AuthorizationSocialEntraidConnectCreateData,
  AuthorizationSocialEntraidConnectCreateResponse,
  AuthorizationSocialEntraidConnectUrlCreateData,
  AuthorizationSocialEntraidConnectUrlCreateResponse,
  AuthorizationSocialEntraidStartCreateData,
  AuthorizationSocialEntraidStartCreateResponse,
  AuthorizationSocialEntraidStateInfoRetrieveData,
  AuthorizationSocialExchangeClientCreateData,
  AuthorizationSocialExchangeClientCreateResponse,
  AuthorizationSocialExchangeCreateData,
  AuthorizationSocialExchangeCreateResponse,
  AuthorizationSocialGoogleClientConnectCreateData,
  AuthorizationSocialGoogleClientConnectCreateResponse,
  AuthorizationSocialGoogleClientConnectUrlCreateData,
  AuthorizationSocialGoogleClientConnectUrlCreateResponse,
  AuthorizationSocialGoogleConnectCreateData,
  AuthorizationSocialGoogleConnectCreateResponse,
  AuthorizationSocialGoogleConnectUrlCreateData,
  AuthorizationSocialGoogleConnectUrlCreateResponse,
  AuthorizationSocialGoogleStartClientCreateData,
  AuthorizationSocialGoogleStartClientCreateResponse,
  AuthorizationSocialGoogleStartCreateData,
  AuthorizationSocialGoogleStartCreateResponse,
  AuthorizationSocialGoogleStateInfoRetrieveData,
  AuthorizationTokenClientCreateData,
  AuthorizationTokenClientCreateResponse,
  AuthorizationTokenCookieRetrieveData,
  AuthorizationTokenCookieRetrieveResponse,
  AuthorizationTokenCreateData,
  AuthorizationTokenCreateResponse,
  AuthorizationTokenLogoutRetrieveData,
  AuthorizationTokenOtpLinkVerifyCreateData,
  AuthorizationTokenOtpLinkVerifyCreateResponse,
  AuthorizationTokenOtpRequestCreateData,
  AuthorizationTokenOtpRequestCreateResponse,
  AuthorizationTokenOtpVerifyCreateData,
  AuthorizationTokenOtpVerifyCreateResponse,
  AuthorizationTokenRefreshCreateData,
  AuthorizationTokenRefreshCreateResponse,
  AuthorizationTokenServiceVerifyCreateData,
  AuthorizationTokenServiceVerifyCreateResponse,
  AuthorizationTokenVerifyCreateData,
  AuthorizationTokenVerifyCreateResponse,
  AuthorizationV2ClientsCreateData,
  AuthorizationV2ClientsCreateResponse,
  AuthorizationV2ClientsListData,
  AuthorizationV2ClientsListResponse,
  AuthorizationV2ClientsPartialUpdateData,
  AuthorizationV2ClientsPartialUpdateResponse,
  AuthorizationV2ClientsRetrieveData,
  AuthorizationV2ClientsRetrieveResponse,
  AuthorizationV2ClientsRevokeCreateData,
  AuthorizationV2ClientsRevokeCreateResponse,
  AuthorizationV2ClientsRotateCreateData,
  AuthorizationV2ClientsRotateCreateResponse,
  AuthorizationV2EmailVerifyCreateData,
  AuthorizationV2EmailVerifyCreateError,
  AuthorizationV2EmailVerifyCreateResponse,
  AuthorizationV2InviteAcceptCreateData,
  AuthorizationV2InviteAcceptCreateResponse,
  AuthorizationV2InviteInfoRetrieveData,
  AuthorizationV2InviteInfoRetrieveError,
  AuthorizationV2InviteInfoRetrieveResponse,
  AuthorizationV2InviteRequestCreateData,
  AuthorizationV2InviteRequestCreateResponse,
  AuthorizationV2PasswordRequestCreateData,
  AuthorizationV2PasswordRequestCreateResponse,
  AuthorizationV2PasswordResetCreateData,
  AuthorizationV2PasswordResetCreateResponse,
  AuthorizationV2SchemaRetrieveData,
  AuthorizationV2SchemaRetrieveResponse,
  AuthorizationV2SignupConfirmCreateData,
  AuthorizationV2SignupConfirmCreateResponse,
  AuthorizationV2SignupStartCreateData,
  AuthorizationV2SignupStartCreateResponse,
  CommonCountriesListData,
  CommonCountriesListResponse,
  CommonCountriesRetrieveData,
  CommonCountriesRetrieveResponse,
  CommonHealthRetrieveData,
  CommonHealthRetrieveResponse,
  CommonIndustriesListData,
  CommonIndustriesListResponse,
  CommonIndustriesRetrieveData,
  CommonIndustriesRetrieveResponse,
  CommonProtectedRetrieveData,
  CommonProtectedRetrieveResponse,
  IntegrationApplicationPublishCreateData,
  IntegrationApplicationPublishCreateResponse,
  IntegrationApplicationsDataRetrieveData,
  IntegrationApplicationsDataRetrieveResponse,
  IntegrationApplicationsListData,
  IntegrationApplicationsListResponse,
  IntegrationApplicationsNotificationsCreateData,
  IntegrationApplicationsNotificationsCreateResponse,
  IntegrationApplicationsRetrieveData,
  IntegrationApplicationsRetrieveResponse,
  IntegrationApplicationsRolePermissionsCreateData,
  IntegrationApplicationsRolePermissionsCreateResponse,
  IntegrationApplicationsRolesCreateData,
  IntegrationApplicationsRolesCreateResponse,
  IntegrationFeedRetrieveData,
  IntegrationFeedRetrieveResponse,
  IntegrationGoogleMailCallbackRetrieveData,
  IntegrationGoogleMailConnectionsDisconnectCreateData,
  IntegrationGoogleMailConnectionsDisconnectCreateResponse,
  IntegrationGoogleMailConnectionsRetrieveData,
  IntegrationGoogleMailConnectionsRetrieveResponse,
  IntegrationGoogleMailConnectStartCreateData,
  IntegrationGoogleMailConnectStartCreateError,
  IntegrationGoogleMailConnectStartCreateResponse,
  IntegrationMicrosoftGraphAvailabilityRetrieveData,
  IntegrationMicrosoftGraphAvailabilityRetrieveResponse,
  IntegrationMicrosoftGraphCallbackRetrieveData,
  IntegrationMicrosoftGraphConnectionsDisconnectCreateData,
  IntegrationMicrosoftGraphConnectionsDisconnectCreateResponse,
  IntegrationMicrosoftGraphConnectionsListData,
  IntegrationMicrosoftGraphConnectionsListResponse,
  IntegrationMicrosoftGraphConnectStartCreateData,
  IntegrationMicrosoftGraphConnectStartCreateResponse,
  IntegrationMicrosoftGraphDisconnectCreateData,
  IntegrationMicrosoftGraphDisconnectCreateResponse,
  IntegrationMicrosoftGraphStatusRetrieveData,
  IntegrationMicrosoftGraphStatusRetrieveResponse,
  IntegrationPermissionMigrationsApplyCreateData,
  IntegrationPermissionMigrationsApplyCreateResponse,
  IntegrationRpcPresetsListData,
  IntegrationRpcPresetsListResponse,
  IntegrationRpcPresetsRetrieveData,
  IntegrationRpcPresetsRetrieveResponse,
  IntegrationSetupJobsDestroyData,
  IntegrationSetupJobsDestroyResponse,
  IntegrationSetupJobsListData,
  IntegrationSetupJobsListResponse,
  IntegrationSetupJobsRetrieveData,
  IntegrationSetupJobsRetrieveResponse,
  IntegrationSetupJobsRetryCreateData,
  IntegrationSetupJobsRetryCreateResponse,
  IntegrationSyncPermissionsCreateData,
  IntegrationSyncPermissionsCreateResponse,
  IntegrationSyncRpcMethodsCreateData,
  IntegrationSyncRpcMethodsCreateResponse,
  IntegrationSyncRpcTemplatesCreateData,
  IntegrationSyncRpcTemplatesCreateResponse,
  IntegrationTeamsListData,
  IntegrationTeamsListResponse,
  IntegrationTeamsRetrieveData,
  IntegrationTeamsRetrieveResponse,
  IntegrationUserGroupsListData,
  IntegrationUserGroupsListResponse,
  IntegrationUserGroupsRetrieveData,
  IntegrationUserGroupsRetrieveResponse,
  IntegrationUserRetrieveData,
  IntegrationUserRetrieveResponse,
  IntegrationUsersCreateData,
  IntegrationUsersCreateResponse,
  IntegrationUsersInviteCreateData,
  IntegrationUsersInviteCreateResponse,
  IntegrationUsersListData,
  IntegrationUsersListResponse,
  IntegrationUsersPartialUpdateData,
  IntegrationUsersPartialUpdateResponse,
  IntegrationUsersRetrieveData,
  IntegrationUsersRetrieveResponse,
  IntegrationV2ApplicationPublishCreateData,
  IntegrationV2ApplicationPublishCreateResponse,
  IntegrationV2ApplicationsDataRetrieveData,
  IntegrationV2ApplicationsDataRetrieveResponse,
  IntegrationV2ApplicationsListData,
  IntegrationV2ApplicationsListResponse,
  IntegrationV2ApplicationsNotificationsCreateData,
  IntegrationV2ApplicationsNotificationsCreateResponse,
  IntegrationV2ApplicationsRetrieveData,
  IntegrationV2ApplicationsRetrieveResponse,
  IntegrationV2ApplicationsRolePermissionsCreateData,
  IntegrationV2ApplicationsRolePermissionsCreateResponse,
  IntegrationV2ApplicationsRolesCreateData,
  IntegrationV2ApplicationsRolesCreateResponse,
  IntegrationV2AppsRolesCreateData,
  IntegrationV2AppsRolesCreateResponse,
  IntegrationV2AppsRolesDestroyData,
  IntegrationV2AppsRolesDestroyResponse,
  IntegrationV2AppsRolesListData,
  IntegrationV2AppsRolesListResponse,
  IntegrationV2AppsRolesMembersRetrieveData,
  IntegrationV2AppsRolesMembersRetrieveResponse,
  IntegrationV2AppsRolesMembersUpdateData,
  IntegrationV2AppsRolesMembersUpdateResponse,
  IntegrationV2AppsRolesPartialUpdateData,
  IntegrationV2AppsRolesPartialUpdateResponse,
  IntegrationV2AppsRolesRetrieveData,
  IntegrationV2AppsRolesRetrieveResponse,
  IntegrationV2FeedRetrieveData,
  IntegrationV2FeedRetrieveResponse,
  IntegrationV2RpcPresetsListData,
  IntegrationV2RpcPresetsListResponse,
  IntegrationV2RpcPresetsRetrieveData,
  IntegrationV2RpcPresetsRetrieveResponse,
  IntegrationV2SetupJobsDestroyData,
  IntegrationV2SetupJobsDestroyResponse,
  IntegrationV2SetupJobsListData,
  IntegrationV2SetupJobsListResponse,
  IntegrationV2SetupJobsRetrieveData,
  IntegrationV2SetupJobsRetrieveResponse,
  IntegrationV2SetupJobsRetryCreateData,
  IntegrationV2SetupJobsRetryCreateResponse,
  IntegrationV2SyncPermissionsCreateData,
  IntegrationV2SyncPermissionsCreateResponse,
  IntegrationV2SyncRpcMethodsCreateData,
  IntegrationV2SyncRpcMethodsCreateResponse,
  IntegrationV2TeamsListData,
  IntegrationV2TeamsListResponse,
  IntegrationV2TeamsRetrieveData,
  IntegrationV2TeamsRetrieveResponse,
  IntegrationV2UserRetrieveData,
  IntegrationV2UserRetrieveResponse,
  IntegrationV2UsersCreateData,
  IntegrationV2UsersCreateResponse,
  IntegrationV2UsersInviteCreateData,
  IntegrationV2UsersInviteCreateResponse,
  IntegrationV2UsersListData,
  IntegrationV2UsersListResponse,
  IntegrationV2UsersPartialUpdateData,
  IntegrationV2UsersPartialUpdateResponse,
  IntegrationV2UsersRetrieveData,
  IntegrationV2UsersRetrieveResponse,
  InternalGoogleMailTokenCreateData,
  InternalGoogleMailTokenCreateError,
  InternalGoogleMailTokenCreateResponse,
  InternalMcpConnectionRetrieveData,
  InternalMcpConnectionRetrieveResponse,
  InternalMicrosoftGraphTokenCreateData,
  InternalMicrosoftGraphTokenCreateError,
  InternalMicrosoftGraphTokenCreateResponse,
  InternalPublicAccessCredentialsSnapshotRetrieveData,
  InternalPublicAccessCredentialsSnapshotRetrieveResponse,
  InternalPublicAccessCredentialsUsageCreateData,
  InternalPublicAccessCredentialsUsageCreateResponse,
  McpConnectionsListData,
  McpConnectionsListResponse,
  McpConnectionsRevokeData,
  McpConnectionsRevokeResponse,
  McpConnectionsScopesUpdateData,
  McpConnectionsScopesUpdateResponse,
  McpConsentApproveData,
  McpConsentApproveResponse,
  McpConsentDenyData,
  McpConsentDenyResponse,
  McpConsentRetrieveData,
  McpConsentRetrieveResponse,
  McpMyConnectionsListData,
  McpMyConnectionsListResponse,
  McpMyConnectionsRevokeData,
  McpMyConnectionsRevokeResponse,
  McpMyConnectionsScopesUpdateData,
  McpMyConnectionsScopesUpdateResponse,
  McpMyServicesListData,
  McpMyServicesListResponse,
  McpPersonalTokensCreateData,
  McpPersonalTokensCreateResponse,
  McpPoliciesListData,
  McpPoliciesListResponse,
  McpPoliciesPartialUpdateData,
  McpPoliciesPartialUpdateResponse,
  McpToolsCallCreateData,
  McpToolsRetrieveData,
  MfaConfigDownloadBackupCodesCreateData,
  MfaConfigDownloadBackupCodesCreateResponse,
  MfaConfigGenerateBackupCodesCreateData,
  MfaConfigGenerateBackupCodesCreateResponse,
  MfaConfigPartialUpdateData,
  MfaConfigPartialUpdateResponse,
  MfaConfigRetrieveData,
  MfaConfigRetrieveResponse,
  MfaConfigUpdateData,
  MfaConfigUpdateResponse,
  MfaInternalAuditLogsExportCreateData,
  MfaInternalAuditLogsExportCreateResponse,
  MfaInternalAuditLogsListData,
  MfaInternalAuditLogsListResponse,
  MfaInternalConfigsListData,
  MfaInternalConfigsListResponse,
  MfaInternalConfigsPartialUpdateData,
  MfaInternalConfigsPartialUpdateResponse,
  MfaInternalConfigsRetrieveData,
  MfaInternalConfigsRetrieveResponse,
  MfaInternalConfigsUpdateData,
  MfaInternalConfigsUpdateResponse,
  MfaInternalLockoutsDestroyData,
  MfaInternalLockoutsDestroyResponse,
  MfaInternalLockoutsListData,
  MfaInternalLockoutsListResponse,
  MfaSendOtpCreateData,
  MfaSendOtpCreateResponse,
  MfaTrustedDevicesDeleteAllDestroyData,
  MfaTrustedDevicesDeleteAllDestroyResponse,
  MfaTrustedDevicesDestroyData,
  MfaTrustedDevicesDestroyResponse,
  MfaTrustedDevicesListData,
  MfaTrustedDevicesListResponse,
  MfaVerifyBackupCodeCreateData,
  MfaVerifyBackupCodeCreateResponse,
  MfaVerifyOtpCreateData,
  MfaVerifyOtpCreateResponse,
  OnboardingInternalStepsCreateData,
  OnboardingInternalStepsCreateResponse,
  OnboardingJourneysPartialUpdateData,
  OnboardingJourneysPartialUpdateResponse,
  OnboardingJourneysRetrieveData,
  OnboardingJourneysRetrieveResponse,
  OnboardingProfileCreateData,
  OnboardingProfileCreateError,
  OnboardingProfileCreateResponse,
  OnboardingProfilePartialUpdateData,
  OnboardingProfilePartialUpdateResponse,
  OnboardingProfileRetrieveData,
  OnboardingProfileRetrieveResponse,
  OrganizationsAccessAddCreateData,
  OrganizationsAccessAddCreateResponse,
  OrganizationsAccessBlockCreateData,
  OrganizationsAccessBlockCreateResponse,
  OrganizationsAccessDestroyData,
  OrganizationsAccessDestroyResponse,
  OrganizationsAccessDisableMfaCreateData,
  OrganizationsAccessDisableMfaCreateResponse,
  OrganizationsAccessImpersonateCreateData,
  OrganizationsAccessImpersonateCreateResponse,
  OrganizationsAccessListData,
  OrganizationsAccessListResponse,
  OrganizationsAccessOrganigramaListData,
  OrganizationsAccessOrganigramaListResponse,
  OrganizationsAccessPartialUpdateData,
  OrganizationsAccessPartialUpdateResponse,
  OrganizationsAccessRequireMfaCreateData,
  OrganizationsAccessRequireMfaCreateResponse,
  OrganizationsAccessResendInviteCreateData,
  OrganizationsAccessResendInviteCreateResponse,
  OrganizationsAccessResetMfaCreateData,
  OrganizationsAccessResetMfaCreateResponse,
  OrganizationsAccessResetPasswordCreateData,
  OrganizationsAccessResetPasswordCreateResponse,
  OrganizationsAccessRetrieveData,
  OrganizationsAccessRetrieveResponse,
  OrganizationsAccessRevokeInviteCreateData,
  OrganizationsAccessRevokeInviteCreateResponse,
  OrganizationsAccessRolesCreateData,
  OrganizationsAccessRolesCreateResponse,
  OrganizationsAccessSessionsDestroyData,
  OrganizationsAccessSessionsDestroyResponse,
  OrganizationsAccessSessionsListData,
  OrganizationsAccessSessionsListResponse,
  OrganizationsAccessSessionsRevokeAllCreateData,
  OrganizationsAccessSessionsRevokeAllCreateResponse,
  OrganizationsAccessSignInActivityRetrieveData,
  OrganizationsAccessSignInActivityRetrieveResponse,
  OrganizationsAuditArchivesBulkDeleteDestroyData,
  OrganizationsAuditArchivesBulkDeleteDestroyResponse,
  OrganizationsAuditArchivesCreateData,
  OrganizationsAuditArchivesCreateResponse,
  OrganizationsAuditArchivesDestroyData,
  OrganizationsAuditArchivesDestroyResponse,
  OrganizationsAuditArchivesDownloadRetrieveData,
  OrganizationsAuditArchivesDownloadRetrieveError,
  OrganizationsAuditArchivesDownloadRetrieveResponse,
  OrganizationsAuditArchivesListData,
  OrganizationsAuditArchivesListResponse,
  OrganizationsAuditArchivesRetrieveData,
  OrganizationsAuditArchivesRetrieveResponse,
  OrganizationsAuditLogsFiltersRetrieveData,
  OrganizationsAuditLogsFiltersRetrieveResponse,
  OrganizationsAuditLogsListData,
  OrganizationsAuditLogsListResponse,
  OrganizationsAuditLogsRetrieveData,
  OrganizationsAuditLogsRetrieveResponse,
  OrganizationsAuditLogsSignInActivityRetrieveData,
  OrganizationsAuditLogsSignInActivityRetrieveResponse,
  OrganizationsDomainAvailabilityRetrieveData,
  OrganizationsDomainAvailabilityRetrieveResponse,
  OrganizationsDomainMatchRetrieveData,
  OrganizationsDomainMatchRetrieveResponse,
  OrganizationsInfoRetrieveData,
  OrganizationsInfoRetrieveResponse,
  OrganizationsJoinRequestsApproveCreateData,
  OrganizationsJoinRequestsApproveCreateResponse,
  OrganizationsJoinRequestsCreateData,
  OrganizationsJoinRequestsCreateResponse,
  OrganizationsJoinRequestsListData,
  OrganizationsJoinRequestsListResponse,
  OrganizationsJoinRequestsRejectCreateData,
  OrganizationsJoinRequestsRejectCreateResponse,
  OrganizationsOrganizationsAuthMethodsPartialUpdateData,
  OrganizationsOrganizationsAuthMethodsPartialUpdateResponse,
  OrganizationsOrganizationsAuthMethodsRetrieveData,
  OrganizationsOrganizationsAuthMethodsRetrieveResponse,
  OrganizationsOrganizationsCreateData,
  OrganizationsOrganizationsCreateResponse,
  OrganizationsOrganizationsCustomAuthProvidersCreateData,
  OrganizationsOrganizationsCustomAuthProvidersCreateResponse,
  OrganizationsOrganizationsCustomAuthProvidersDestroyData,
  OrganizationsOrganizationsCustomAuthProvidersDestroyResponse,
  OrganizationsOrganizationsCustomAuthProvidersListData,
  OrganizationsOrganizationsCustomAuthProvidersListResponse,
  OrganizationsOrganizationsCustomAuthProvidersPartialUpdateData,
  OrganizationsOrganizationsCustomAuthProvidersPartialUpdateResponse,
  OrganizationsOrganizationsCustomAuthProvidersRetrieveData,
  OrganizationsOrganizationsCustomAuthProvidersRetrieveResponse,
  OrganizationsOrganizationsDemoDisableCreateData,
  OrganizationsOrganizationsDemoDisableCreateResponse,
  OrganizationsOrganizationsDemoEnableCreateData,
  OrganizationsOrganizationsDestroyData,
  OrganizationsOrganizationsDestroyResponse,
  OrganizationsOrganizationsEnvironmentBuildCreateData,
  OrganizationsOrganizationsEnvironmentBuildCreateResponse,
  OrganizationsOrganizationsEnvironmentClearCreateData,
  OrganizationsOrganizationsEnvironmentClearCreateResponse,
  OrganizationsOrganizationsListData,
  OrganizationsOrganizationsListResponse,
  OrganizationsOrganizationsMemberAuthMethodsListData,
  OrganizationsOrganizationsMemberAuthMethodsListResponse,
  OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateData,
  OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateResponse,
  OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveData,
  OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveResponse,
  OrganizationsOrganizationsPartialUpdateData,
  OrganizationsOrganizationsPartialUpdateResponse,
  OrganizationsOrganizationsRetrieveData,
  OrganizationsOrganizationsRetrieveResponse,
  OrganizationsOrganizationsTransferOwnershipCreateData,
  OrganizationsOrganizationsTransferOwnershipCreateResponse,
  OrganizationsPermissionsUserListData,
  OrganizationsPermissionsUserListResponse,
  OrganizationsRolesCreateData,
  OrganizationsRolesCreateResponse,
  OrganizationsRolesDestroyData,
  OrganizationsRolesDestroyResponse,
  OrganizationsRolesListData,
  OrganizationsRolesListResponse,
  OrganizationsRolesPartialUpdateData,
  OrganizationsRolesPartialUpdateResponse,
  OrganizationsRolesReplaceCreateData,
  OrganizationsRolesReplaceCreateResponse,
  OrganizationsRolesRetrieveData,
  OrganizationsRolesRetrieveResponse,
  OrganizationsTeamsCreateData,
  OrganizationsTeamsCreateResponse,
  OrganizationsTeamsDestroyData,
  OrganizationsTeamsDestroyResponse,
  OrganizationsTeamsListData,
  OrganizationsTeamsListResponse,
  OrganizationsTeamsOrganigramListData,
  OrganizationsTeamsOrganigramListResponse,
  OrganizationsTeamsPartialUpdateData,
  OrganizationsTeamsPartialUpdateResponse,
  OrganizationsTeamsRetrieveData,
  OrganizationsTeamsRetrieveResponse,
  OrganizationsTeamUsersCreateData,
  OrganizationsTeamUsersCreateResponse,
  OrganizationsTeamUsersDestroyData,
  OrganizationsTeamUsersDestroyResponse,
  OrganizationsTeamUsersListData,
  OrganizationsTeamUsersListResponse,
  OrganizationsTeamUsersRetrieveData,
  OrganizationsTeamUsersRetrieveResponse,
  OrganizationsUserGroupsApplicationsRolesPartialUpdateData,
  OrganizationsUserGroupsApplicationsRolesPartialUpdateResponse,
  OrganizationsUserGroupsCreateData,
  OrganizationsUserGroupsCreateResponse,
  OrganizationsUserGroupsDestroyData,
  OrganizationsUserGroupsDestroyResponse,
  OrganizationsUserGroupsListData,
  OrganizationsUserGroupsListResponse,
  OrganizationsUserGroupsPartialUpdateData,
  OrganizationsUserGroupsPartialUpdateResponse,
  OrganizationsUserGroupsRetrieveData,
  OrganizationsUserGroupsRetrieveResponse,
  OrganizationsValidateRetrieveData,
  OrganizationsValidateRetrieveResponse,
  OrganizationsWorkspacePermissionsListData,
  OrganizationsWorkspacePermissionsListResponse,
  OrganizationsWorkspaceRolesCreateData,
  OrganizationsWorkspaceRolesCreateResponse,
  OrganizationsWorkspaceRolesDestroyData,
  OrganizationsWorkspaceRolesDestroyResponse,
  OrganizationsWorkspaceRolesListData,
  OrganizationsWorkspaceRolesListResponse,
  OrganizationsWorkspaceRolesPartialUpdateData,
  OrganizationsWorkspaceRolesPartialUpdateResponse,
  OrganizationsWorkspaceRolesRetrieveData,
  OrganizationsWorkspaceRolesRetrieveResponse,
  PermissionsCreateData,
  PermissionsCreateResponse,
  PermissionsDestroyData,
  PermissionsDestroyResponse,
  PermissionsListData,
  PermissionsListResponse,
  PermissionsPartialUpdateData,
  PermissionsPartialUpdateResponse,
  PermissionsRetrieveData,
  PermissionsRetrieveResponse,
  SchemaRetrieveData,
  SchemaRetrieveResponse,
  SettingsOutboundWebhooksWebhooksCreateData,
  SettingsOutboundWebhooksWebhooksCreateResponse,
  SettingsOutboundWebhooksWebhooksDestroyData,
  SettingsOutboundWebhooksWebhooksDestroyResponse,
  SettingsOutboundWebhooksWebhooksListData,
  SettingsOutboundWebhooksWebhooksListResponse,
  SettingsOutboundWebhooksWebhooksPartialUpdateData,
  SettingsOutboundWebhooksWebhooksPartialUpdateResponse,
  SettingsOutboundWebhooksWebhooksRetrieveData,
  SettingsOutboundWebhooksWebhooksRetrieveResponse,
  SettingsOutboundWebhooksWebhooksRevealSecretCreateData,
  SettingsOutboundWebhooksWebhooksRevealSecretCreateResponse,
  SettingsOutboundWebhooksWebhooksTestCreateData,
  SettingsOutboundWebhooksWebhooksTestCreateResponse,
  SettingsPublicAccessCredentialsCreateData,
  SettingsPublicAccessCredentialsCreateResponse,
  SettingsPublicAccessCredentialsListData,
  SettingsPublicAccessCredentialsListResponse,
  SettingsPublicAccessCredentialsPartialUpdateData,
  SettingsPublicAccessCredentialsPartialUpdateResponse,
  SettingsPublicAccessCredentialsRetrieveData,
  SettingsPublicAccessCredentialsRetrieveResponse,
  SettingsPublicAccessCredentialsRevokeCreateData,
  SettingsPublicAccessCredentialsRevokeCreateResponse,
  SettingsPublicAccessCredentialsRotateCreateData,
  SettingsPublicAccessCredentialsRotateCreateResponse,
  StaticRetrieveData,
  StaticRetrieveResponse,
  SupportReportCreateData,
  SupportReportCreateResponse,
  SupportTicketsCommentsCreateData,
  SupportTicketsCommentsCreateResponse,
  SupportTicketsCommentsListData,
  SupportTicketsCommentsListResponse,
  SupportTicketsCreateData,
  SupportTicketsCreateResponse,
  SupportTicketsListData,
  SupportTicketsListResponse,
  SupportTicketsRetrieveData,
  SupportTicketsRetrieveResponse,
  SupportTicketsUnseenCountRetrieveData,
  SupportTicketsUnseenCountRetrieveResponse,
  SupportTicketsUploadsCreateData,
  SupportTicketsUploadsCreateResponse,
  UsersAddInOrganizationCreateData,
  UsersAddInOrganizationCreateResponse,
  UsersArchiveCreateData,
  UsersArchiveCreateError,
  UsersArchiveCreateResponse,
  UsersArchiveDependenciesRetrieveData,
  UsersArchiveDependenciesRetrieveError,
  UsersArchiveDependenciesRetrieveResponse,
  UsersArchiveJobsRetrieveData,
  UsersArchiveJobsRetrieveResponse,
  UsersArchiveReplaceAndArchiveCreateData,
  UsersArchiveReplaceAndArchiveCreateError,
  UsersArchiveReplaceAndArchiveCreateResponse,
  UsersEditPartialUpdateData,
  UsersEditPartialUpdateResponse,
  UsersEditUpdateData,
  UsersEditUpdateResponse,
  UsersListData,
  UsersListResponse,
  UsersLoginAdminCreateData,
  UsersLoginAdminCreateResponse,
  UsersLoginUserCreateData,
  UsersLoginUserCreateResponse,
  UsersNotificationServiceSyncCreateData,
  UsersNotificationServiceSyncCreateResponse,
  UsersPartialUpdateData,
  UsersPartialUpdateResponse,
  UsersRetrieveData,
  UsersRetrieveResponse,
  UsersSyncActiveDirectoryCreateData,
  UsersSyncActiveDirectoryCreateResponse
} from '../types.gen'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  }
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const accountRetrieveQueryKey = (
  options?: Options<AccountRetrieveData>
) => createQueryKey('accountRetrieve', options)

/**
 * List / create service accounts for current user.
 */
export const accountRetrieveOptions = (
  options?: Options<AccountRetrieveData>
) =>
  queryOptions<
    AccountRetrieveResponse,
    AxiosError<DefaultError>,
    AccountRetrieveResponse,
    ReturnType<typeof accountRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountRetrieveQueryKey(options)
  })

/**
 * List / create service accounts for current user.
 */
export const accountCreateMutation = (
  options?: Partial<Options<AccountCreateData>>
): UseMutationOptions<
  AccountCreateResponse,
  AxiosError<DefaultError>,
  Options<AccountCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountCreateResponse,
    AxiosError<DefaultError>,
    Options<AccountCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Edit or delete a service account.
 */
export const accountDestroyMutation = (
  options?: Partial<Options<AccountDestroyData>>
): UseMutationOptions<
  AccountDestroyResponse,
  AxiosError<DefaultError>,
  Options<AccountDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountDestroyResponse,
    AxiosError<DefaultError>,
    Options<AccountDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Edit or delete a service account.
 */
export const accountPartialUpdateMutation = (
  options?: Partial<Options<AccountPartialUpdateData>>
): UseMutationOptions<
  AccountPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<AccountPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<AccountPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Confirm password change (requires ChangePassword JWT).
 */
export const accountChangePasswordConfirmCreateMutation = (
  options?: Partial<Options<AccountChangePasswordConfirmCreateData>>
): UseMutationOptions<
  AccountChangePasswordConfirmCreateResponse,
  AxiosError<DefaultError>,
  Options<AccountChangePasswordConfirmCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountChangePasswordConfirmCreateResponse,
    AxiosError<DefaultError>,
    Options<AccountChangePasswordConfirmCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountChangePasswordConfirmCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Request MFA-authenticated password change.
 */
export const accountChangePasswordRequestCreateMutation = (
  options?: Partial<Options<AccountChangePasswordRequestCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<AccountChangePasswordRequestCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<AccountChangePasswordRequestCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountChangePasswordRequestCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const accountLinkedAuthMethodsRetrieveQueryKey = (
  options?: Options<AccountLinkedAuthMethodsRetrieveData>
) => createQueryKey('accountLinkedAuthMethodsRetrieve', options)

/**
 * Return current user's linked auth methods (password + social providers).
 */
export const accountLinkedAuthMethodsRetrieveOptions = (
  options?: Options<AccountLinkedAuthMethodsRetrieveData>
) =>
  queryOptions<
    AccountLinkedAuthMethodsRetrieveResponse,
    AxiosError<DefaultError>,
    AccountLinkedAuthMethodsRetrieveResponse,
    ReturnType<typeof accountLinkedAuthMethodsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountLinkedAuthMethodsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountLinkedAuthMethodsRetrieveQueryKey(options)
  })

export const accountNotificationPreferencesRetrieveQueryKey = (
  options?: Options<AccountNotificationPreferencesRetrieveData>
) => createQueryKey('accountNotificationPreferencesRetrieve', options)

/**
 * Get notification preferences
 *
 * Returns the current user's global per-app/category/channel preferences matrix.
 */
export const accountNotificationPreferencesRetrieveOptions = (
  options?: Options<AccountNotificationPreferencesRetrieveData>
) =>
  queryOptions<
    AccountNotificationPreferencesRetrieveResponse,
    AxiosError<DefaultError>,
    AccountNotificationPreferencesRetrieveResponse,
    ReturnType<typeof accountNotificationPreferencesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountNotificationPreferencesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountNotificationPreferencesRetrieveQueryKey(options)
  })

/**
 * Update notification preferences
 *
 * Replaces the current user's global per-app/category/channel preferences matrix.
 */
export const accountNotificationPreferencesUpdateMutation = (
  options?: Partial<Options<AccountNotificationPreferencesUpdateData>>
): UseMutationOptions<
  AccountNotificationPreferencesUpdateResponse,
  AxiosError<DefaultError>,
  Options<AccountNotificationPreferencesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountNotificationPreferencesUpdateResponse,
    AxiosError<DefaultError>,
    Options<AccountNotificationPreferencesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountNotificationPreferencesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const accountNotificationsRetrieveQueryKey = (
  options?: Options<AccountNotificationsRetrieveData>
) => createQueryKey('accountNotificationsRetrieve', options)

/**
 * List in-app notifications
 *
 * Proxy to the Notification service: paginated list of in-app notifications.
 */
export const accountNotificationsRetrieveOptions = (
  options?: Options<AccountNotificationsRetrieveData>
) =>
  queryOptions<
    AccountNotificationsRetrieveResponse,
    AxiosError<DefaultError>,
    AccountNotificationsRetrieveResponse,
    ReturnType<typeof accountNotificationsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountNotificationsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountNotificationsRetrieveQueryKey(options)
  })

/**
 * Mark in-app notifications as read
 *
 * Proxy: mark in-app notifications as read; mark all if ``ids`` is empty/null.
 */
export const accountNotificationsMarkReadCreateMutation = (
  options?: Partial<Options<AccountNotificationsMarkReadCreateData>>
): UseMutationOptions<
  AccountNotificationsMarkReadCreateResponse,
  AxiosError<DefaultError>,
  Options<AccountNotificationsMarkReadCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountNotificationsMarkReadCreateResponse,
    AxiosError<DefaultError>,
    Options<AccountNotificationsMarkReadCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountNotificationsMarkReadCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const accountNotificationsUnreadCountRetrieveQueryKey = (
  options?: Options<AccountNotificationsUnreadCountRetrieveData>
) => createQueryKey('accountNotificationsUnreadCountRetrieve', options)

/**
 * Unread in-app notifications count
 *
 * Proxy: unread in-app notifications count for the current user.
 */
export const accountNotificationsUnreadCountRetrieveOptions = (
  options?: Options<AccountNotificationsUnreadCountRetrieveData>
) =>
  queryOptions<
    AccountNotificationsUnreadCountRetrieveResponse,
    AxiosError<DefaultError>,
    AccountNotificationsUnreadCountRetrieveResponse,
    ReturnType<typeof accountNotificationsUnreadCountRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountNotificationsUnreadCountRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountNotificationsUnreadCountRetrieveQueryKey(options)
  })

export const accountOrgLinkedMethodsRetrieveQueryKey = (
  options: Options<AccountOrgLinkedMethodsRetrieveData>
) => createQueryKey('accountOrgLinkedMethodsRetrieve', options)

/**
 * Return current user's org-scoped linked auth methods (e.g. org Google).
 */
export const accountOrgLinkedMethodsRetrieveOptions = (
  options: Options<AccountOrgLinkedMethodsRetrieveData>
) =>
  queryOptions<
    AccountOrgLinkedMethodsRetrieveResponse,
    AxiosError<DefaultError>,
    AccountOrgLinkedMethodsRetrieveResponse,
    ReturnType<typeof accountOrgLinkedMethodsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountOrgLinkedMethodsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountOrgLinkedMethodsRetrieveQueryKey(options)
  })

/**
 * Disconnect a social provider from the current user (org links + global social account).
 */
export const accountOrgSocialAccountsDestroyMutation = (
  options?: Partial<Options<AccountOrgSocialAccountsDestroyData>>
): UseMutationOptions<
  AccountOrgSocialAccountsDestroyResponse,
  AxiosError<DefaultError>,
  Options<AccountOrgSocialAccountsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountOrgSocialAccountsDestroyResponse,
    AxiosError<DefaultError>,
    Options<AccountOrgSocialAccountsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountOrgSocialAccountsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const accountPasskeysListQueryKey = (
  options?: Options<AccountPasskeysListData>
) => createQueryKey('accountPasskeysList', options)

/**
 * List passkeys for the authenticated user.
 */
export const accountPasskeysListOptions = (
  options?: Options<AccountPasskeysListData>
) =>
  queryOptions<
    AccountPasskeysListResponse,
    AxiosError<DefaultError>,
    AccountPasskeysListResponse,
    ReturnType<typeof accountPasskeysListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountPasskeysList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountPasskeysListQueryKey(options)
  })

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = { ...queryKey[0] }
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any)
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any)
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any)
    }
  }
  return params as unknown as typeof page
}

export const accountPasskeysListInfiniteQueryKey = (
  options?: Options<AccountPasskeysListData>
): QueryKey<Options<AccountPasskeysListData>> =>
  createQueryKey('accountPasskeysList', options, true)

/**
 * List passkeys for the authenticated user.
 */
export const accountPasskeysListInfiniteOptions = (
  options?: Options<AccountPasskeysListData>
) => {
  const opts = infiniteQueryOptions<
    AccountPasskeysListResponse,
    AxiosError<DefaultError>,
    InfiniteData<AccountPasskeysListResponse>,
    QueryKey<Options<AccountPasskeysListData>>,
    | number
    | Pick<
        QueryKey<Options<AccountPasskeysListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AccountPasskeysListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await accountPasskeysList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: accountPasskeysListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Delete or rename a single passkey.
 */
export const accountPasskeysDestroyMutation = (
  options?: Partial<Options<AccountPasskeysDestroyData>>
): UseMutationOptions<
  AccountPasskeysDestroyResponse,
  AxiosError<DefaultError>,
  Options<AccountPasskeysDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountPasskeysDestroyResponse,
    AxiosError<DefaultError>,
    Options<AccountPasskeysDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountPasskeysDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Delete or rename a single passkey.
 */
export const accountPasskeysPartialUpdateMutation = (
  options?: Partial<Options<AccountPasskeysPartialUpdateData>>
): UseMutationOptions<
  AccountPasskeysPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<AccountPasskeysPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountPasskeysPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<AccountPasskeysPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountPasskeysPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Generate WebAuthn registration options (challenge).
 */
export const accountPasskeysRegisterStartCreateMutation = (
  options?: Partial<Options<AccountPasskeysRegisterStartCreateData>>
): UseMutationOptions<
  AccountPasskeysRegisterStartCreateResponse,
  AxiosError<DefaultError>,
  Options<AccountPasskeysRegisterStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountPasskeysRegisterStartCreateResponse,
    AxiosError<DefaultError>,
    Options<AccountPasskeysRegisterStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountPasskeysRegisterStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Verify WebAuthn attestation and store the credential.
 */
export const accountPasskeysRegisterVerifyCreateMutation = (
  options?: Partial<Options<AccountPasskeysRegisterVerifyCreateData>>
): UseMutationOptions<
  AccountPasskeysRegisterVerifyCreateResponse,
  AxiosError<DefaultError>,
  Options<AccountPasskeysRegisterVerifyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountPasskeysRegisterVerifyCreateResponse,
    AxiosError<DefaultError>,
    Options<AccountPasskeysRegisterVerifyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountPasskeysRegisterVerifyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const accountServicesListQueryKey = (
  options?: Options<AccountServicesListData>
) => createQueryKey('accountServicesList', options)

/**
 * List all services.
 */
export const accountServicesListOptions = (
  options?: Options<AccountServicesListData>
) =>
  queryOptions<
    AccountServicesListResponse,
    AxiosError<DefaultError>,
    AccountServicesListResponse,
    ReturnType<typeof accountServicesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountServicesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountServicesListQueryKey(options)
  })

export const accountServicesListInfiniteQueryKey = (
  options?: Options<AccountServicesListData>
): QueryKey<Options<AccountServicesListData>> =>
  createQueryKey('accountServicesList', options, true)

/**
 * List all services.
 */
export const accountServicesListInfiniteOptions = (
  options?: Options<AccountServicesListData>
) => {
  const opts = infiniteQueryOptions<
    AccountServicesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<AccountServicesListResponse>,
    QueryKey<Options<AccountServicesListData>>,
    | number
    | Pick<
        QueryKey<Options<AccountServicesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AccountServicesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await accountServicesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: accountServicesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const accountSessionsListQueryKey = (
  options?: Options<AccountSessionsListData>
) => createQueryKey('accountSessionsList', options)

/**
 * Active sign-in sessions for the requesting user.
 *
 * One row per active refresh token. DELETE blacklists the whole session chain
 * (refresh + every access token issued from it) via :func:`revoke_session`.
 */
export const accountSessionsListOptions = (
  options?: Options<AccountSessionsListData>
) =>
  queryOptions<
    AccountSessionsListResponse,
    AxiosError<DefaultError>,
    AccountSessionsListResponse,
    ReturnType<typeof accountSessionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountSessionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountSessionsListQueryKey(options)
  })

export const accountSessionsListInfiniteQueryKey = (
  options?: Options<AccountSessionsListData>
): QueryKey<Options<AccountSessionsListData>> =>
  createQueryKey('accountSessionsList', options, true)

/**
 * Active sign-in sessions for the requesting user.
 *
 * One row per active refresh token. DELETE blacklists the whole session chain
 * (refresh + every access token issued from it) via :func:`revoke_session`.
 */
export const accountSessionsListInfiniteOptions = (
  options?: Options<AccountSessionsListData>
) => {
  const opts = infiniteQueryOptions<
    AccountSessionsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<AccountSessionsListResponse>,
    QueryKey<Options<AccountSessionsListData>>,
    | number
    | Pick<
        QueryKey<Options<AccountSessionsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AccountSessionsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await accountSessionsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: accountSessionsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Active sign-in sessions for the requesting user.
 *
 * One row per active refresh token. DELETE blacklists the whole session chain
 * (refresh + every access token issued from it) via :func:`revoke_session`.
 */
export const accountSessionsDestroyMutation = (
  options?: Partial<Options<AccountSessionsDestroyData>>
): UseMutationOptions<
  AccountSessionsDestroyResponse,
  AxiosError<DefaultError>,
  Options<AccountSessionsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountSessionsDestroyResponse,
    AxiosError<DefaultError>,
    Options<AccountSessionsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountSessionsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Active sign-in sessions for the requesting user.
 *
 * One row per active refresh token. DELETE blacklists the whole session chain
 * (refresh + every access token issued from it) via :func:`revoke_session`.
 */
export const accountSessionsRevokeAllOthersDestroyMutation = (
  options?: Partial<Options<AccountSessionsRevokeAllOthersDestroyData>>
): UseMutationOptions<
  AccountSessionsRevokeAllOthersDestroyResponse,
  AxiosError<DefaultError>,
  Options<AccountSessionsRevokeAllOthersDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountSessionsRevokeAllOthersDestroyResponse,
    AxiosError<DefaultError>,
    Options<AccountSessionsRevokeAllOthersDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountSessionsRevokeAllOthersDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const accountSignInPolicyRetrieveQueryKey = (
  options?: Options<AccountSignInPolicyRetrieveData>
) => createQueryKey('accountSignInPolicyRetrieve', options)

/**
 * Per-user sign-in policy — singleton for request.user.
 */
export const accountSignInPolicyRetrieveOptions = (
  options?: Options<AccountSignInPolicyRetrieveData>
) =>
  queryOptions<
    AccountSignInPolicyRetrieveResponse,
    AxiosError<DefaultError>,
    AccountSignInPolicyRetrieveResponse,
    ReturnType<typeof accountSignInPolicyRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountSignInPolicyRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: accountSignInPolicyRetrieveQueryKey(options)
  })

/**
 * Per-user sign-in policy — singleton for request.user.
 */
export const accountSignInPolicyPartialUpdateMutation = (
  options?: Partial<Options<AccountSignInPolicyPartialUpdateData>>
): UseMutationOptions<
  AccountSignInPolicyPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<AccountSignInPolicyPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountSignInPolicyPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<AccountSignInPolicyPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountSignInPolicyPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Per-user sign-in policy — singleton for request.user.
 */
export const accountSignInPolicyUpdateMutation = (
  options?: Partial<Options<AccountSignInPolicyUpdateData>>
): UseMutationOptions<
  AccountSignInPolicyUpdateResponse,
  AxiosError<DefaultError>,
  Options<AccountSignInPolicyUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountSignInPolicyUpdateResponse,
    AxiosError<DefaultError>,
    Options<AccountSignInPolicyUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountSignInPolicyUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Disconnect a social provider from the current user. Requires at least one auth method left.
 */
export const accountSocialAccountsDestroyMutation = (
  options?: Partial<Options<AccountSocialAccountsDestroyData>>
): UseMutationOptions<
  AccountSocialAccountsDestroyResponse,
  AxiosError<DefaultError>,
  Options<AccountSocialAccountsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountSocialAccountsDestroyResponse,
    AxiosError<DefaultError>,
    Options<AccountSocialAccountsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountSocialAccountsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Remove password from the current user. Requires at least one social provider linked.
 */
export const accountUnlinkPasswordCreateMutation = (
  options?: Partial<Options<AccountUnlinkPasswordCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<AccountUnlinkPasswordCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<AccountUnlinkPasswordCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountUnlinkPasswordCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Edit authenticated user's password and/or email.
 */
export const accountUserPartialUpdateMutation = (
  options?: Partial<Options<AccountUserPartialUpdateData>>
): UseMutationOptions<
  AccountUserPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<AccountUserPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AccountUserPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<AccountUserPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await accountUserPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsCreateMutation = (
  options?: Partial<Options<ApplicationsCreateData>>
): UseMutationOptions<
  ApplicationsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Set each member's application access to exactly the requested apps/roles.
 *
 * Reconciled as a diff (not delete-all + recreate), so unchanged access is left alone and emits no spurious webhooks. ApplicationAccess is a legacy materialization row; the canonical member-role workflow owns the business audit event. Atomic, so a mid-request failure can't leave a member with wiped access.
 *
 * Requires workspace permission: `applications.access`.
 */
export const applicationsAccessCreateMutation = (
  options?: Partial<Options<ApplicationsAccessCreateData>>
): UseMutationOptions<
  ApplicationsAccessCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsAccessCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsAccessCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsAccessCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsAccessCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const applicationsApplicationsListQueryKey = (
  options?: Options<ApplicationsApplicationsListData>
) => createQueryKey('applicationsApplicationsList', options)

export const applicationsApplicationsListOptions = (
  options?: Options<ApplicationsApplicationsListData>
) =>
  queryOptions<
    ApplicationsApplicationsListResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsListResponse,
    ReturnType<typeof applicationsApplicationsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsListQueryKey(options)
  })

export const applicationsApplicationsListInfiniteQueryKey = (
  options?: Options<ApplicationsApplicationsListData>
): QueryKey<Options<ApplicationsApplicationsListData>> =>
  createQueryKey('applicationsApplicationsList', options, true)

export const applicationsApplicationsListInfiniteOptions = (
  options?: Options<ApplicationsApplicationsListData>
) => {
  const opts = infiniteQueryOptions<
    ApplicationsApplicationsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApplicationsApplicationsListResponse>,
    QueryKey<Options<ApplicationsApplicationsListData>>,
    | number
    | Pick<
        QueryKey<Options<ApplicationsApplicationsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApplicationsApplicationsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await applicationsApplicationsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: applicationsApplicationsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const applicationsApplicationsAccessListQueryKey = (
  options?: Options<ApplicationsApplicationsAccessListData>
) => createQueryKey('applicationsApplicationsAccessList', options)

/**
 * Returns access rows from workspaces where the caller has `applications.access`.
 */
export const applicationsApplicationsAccessListOptions = (
  options?: Options<ApplicationsApplicationsAccessListData>
) =>
  queryOptions<
    ApplicationsApplicationsAccessListResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsAccessListResponse,
    ReturnType<typeof applicationsApplicationsAccessListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsAccessList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsAccessListQueryKey(options)
  })

export const applicationsApplicationsAccessListInfiniteQueryKey = (
  options?: Options<ApplicationsApplicationsAccessListData>
): QueryKey<Options<ApplicationsApplicationsAccessListData>> =>
  createQueryKey('applicationsApplicationsAccessList', options, true)

/**
 * Returns access rows from workspaces where the caller has `applications.access`.
 */
export const applicationsApplicationsAccessListInfiniteOptions = (
  options?: Options<ApplicationsApplicationsAccessListData>
) => {
  const opts = infiniteQueryOptions<
    ApplicationsApplicationsAccessListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApplicationsApplicationsAccessListResponse>,
    QueryKey<Options<ApplicationsApplicationsAccessListData>>,
    | number
    | Pick<
        QueryKey<Options<ApplicationsApplicationsAccessListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApplicationsApplicationsAccessListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await applicationsApplicationsAccessList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: applicationsApplicationsAccessListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const applicationsApplicationsAccessRetrieveQueryKey = (
  options: Options<ApplicationsApplicationsAccessRetrieveData>
) => createQueryKey('applicationsApplicationsAccessRetrieve', options)

/**
 * Requires workspace permission: `applications.access` for the row's workspace.
 */
export const applicationsApplicationsAccessRetrieveOptions = (
  options: Options<ApplicationsApplicationsAccessRetrieveData>
) =>
  queryOptions<
    ApplicationsApplicationsAccessRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsAccessRetrieveResponse,
    ReturnType<typeof applicationsApplicationsAccessRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsAccessRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsAccessRetrieveQueryKey(options)
  })

export const applicationsApplicationsRepositoriesListQueryKey = (
  options?: Options<ApplicationsApplicationsRepositoriesListData>
) => createQueryKey('applicationsApplicationsRepositoriesList', options)

/**
 * No workspace permission is required unless the `organization` filter is used; that filter requires `applications.view` for the selected workspace.
 */
export const applicationsApplicationsRepositoriesListOptions = (
  options?: Options<ApplicationsApplicationsRepositoriesListData>
) =>
  queryOptions<
    ApplicationsApplicationsRepositoriesListResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsRepositoriesListResponse,
    ReturnType<typeof applicationsApplicationsRepositoriesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsRepositoriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsRepositoriesListQueryKey(options)
  })

export const applicationsApplicationsRepositoriesListInfiniteQueryKey = (
  options?: Options<ApplicationsApplicationsRepositoriesListData>
): QueryKey<Options<ApplicationsApplicationsRepositoriesListData>> =>
  createQueryKey('applicationsApplicationsRepositoriesList', options, true)

/**
 * No workspace permission is required unless the `organization` filter is used; that filter requires `applications.view` for the selected workspace.
 */
export const applicationsApplicationsRepositoriesListInfiniteOptions = (
  options?: Options<ApplicationsApplicationsRepositoriesListData>
) => {
  const opts = infiniteQueryOptions<
    ApplicationsApplicationsRepositoriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApplicationsApplicationsRepositoriesListResponse>,
    QueryKey<Options<ApplicationsApplicationsRepositoriesListData>>,
    | number
    | Pick<
        QueryKey<Options<ApplicationsApplicationsRepositoriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApplicationsApplicationsRepositoriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await applicationsApplicationsRepositoriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey:
        applicationsApplicationsRepositoriesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const applicationsApplicationsRepositoriesRetrieveQueryKey = (
  options: Options<ApplicationsApplicationsRepositoriesRetrieveData>
) => createQueryKey('applicationsApplicationsRepositoriesRetrieve', options)

/**
 * No workspace permission is required.
 */
export const applicationsApplicationsRepositoriesRetrieveOptions = (
  options: Options<ApplicationsApplicationsRepositoriesRetrieveData>
) =>
  queryOptions<
    ApplicationsApplicationsRepositoriesRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsRepositoriesRetrieveResponse,
    ReturnType<typeof applicationsApplicationsRepositoriesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsRepositoriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsRepositoriesRetrieveQueryKey(options)
  })

export const applicationsApplicationsCredentialsListQueryKey = (
  options: Options<ApplicationsApplicationsCredentialsListData>
) => createQueryKey('applicationsApplicationsCredentialsList', options)

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsListOptions = (
  options: Options<ApplicationsApplicationsCredentialsListData>
) =>
  queryOptions<
    ApplicationsApplicationsCredentialsListResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsCredentialsListResponse,
    ReturnType<typeof applicationsApplicationsCredentialsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsCredentialsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsCredentialsListQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsCreateMutation = (
  options?: Partial<Options<ApplicationsApplicationsCredentialsCreateData>>
): UseMutationOptions<
  ApplicationsApplicationsCredentialsCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsCredentialsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsCredentialsCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsCredentialsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsCredentialsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const applicationsApplicationsCredentialsRetrieveQueryKey = (
  options: Options<ApplicationsApplicationsCredentialsRetrieveData>
) => createQueryKey('applicationsApplicationsCredentialsRetrieve', options)

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsRetrieveOptions = (
  options: Options<ApplicationsApplicationsCredentialsRetrieveData>
) =>
  queryOptions<
    ApplicationsApplicationsCredentialsRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsCredentialsRetrieveResponse,
    ReturnType<typeof applicationsApplicationsCredentialsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsCredentialsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsCredentialsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsPartialUpdateMutation = (
  options?: Partial<
    Options<ApplicationsApplicationsCredentialsPartialUpdateData>
  >
): UseMutationOptions<
  ApplicationsApplicationsCredentialsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsCredentialsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsCredentialsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsCredentialsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsCredentialsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsRevokeCreateMutation = (
  options?: Partial<
    Options<ApplicationsApplicationsCredentialsRevokeCreateData>
  >
): UseMutationOptions<
  ApplicationsApplicationsCredentialsRevokeCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsCredentialsRevokeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsCredentialsRevokeCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsCredentialsRevokeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsCredentialsRevokeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsCredentialsRotateCreateMutation = (
  options?: Partial<
    Options<ApplicationsApplicationsCredentialsRotateCreateData>
  >
): UseMutationOptions<
  ApplicationsApplicationsCredentialsRotateCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsCredentialsRotateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsCredentialsRotateCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsCredentialsRotateCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsCredentialsRotateCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const applicationsApplicationsScimRetrieveQueryKey = (
  options: Options<ApplicationsApplicationsScimRetrieveData>
) => createQueryKey('applicationsApplicationsScimRetrieve', options)

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsScimRetrieveOptions = (
  options: Options<ApplicationsApplicationsScimRetrieveData>
) =>
  queryOptions<
    ApplicationsApplicationsScimRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsScimRetrieveResponse,
    ReturnType<typeof applicationsApplicationsScimRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsScimRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsScimRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsScimPartialUpdateMutation = (
  options?: Partial<Options<ApplicationsApplicationsScimPartialUpdateData>>
): UseMutationOptions<
  ApplicationsApplicationsScimPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsScimPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsScimPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsScimPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsScimPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsScimRotateInboundTokenCreateMutation = (
  options?: Partial<
    Options<ApplicationsApplicationsScimRotateInboundTokenCreateData>
  >
): UseMutationOptions<
  ApplicationsApplicationsScimRotateInboundTokenCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsScimRotateInboundTokenCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsScimRotateInboundTokenCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsScimRotateInboundTokenCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await applicationsApplicationsScimRotateInboundTokenCreate({
          ...options,
          ...fnOptions,
          throwOnError: true
        })
      return data
    }
  }
  return mutationOptions
}

export const applicationsApplicationsWebhookConfigRetrieveQueryKey = (
  options: Options<ApplicationsApplicationsWebhookConfigRetrieveData>
) => createQueryKey('applicationsApplicationsWebhookConfigRetrieve', options)

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigRetrieveOptions = (
  options: Options<ApplicationsApplicationsWebhookConfigRetrieveData>
) =>
  queryOptions<
    ApplicationsApplicationsWebhookConfigRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsWebhookConfigRetrieveResponse,
    ReturnType<typeof applicationsApplicationsWebhookConfigRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsWebhookConfigRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsWebhookConfigRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigPartialUpdateMutation = (
  options?: Partial<
    Options<ApplicationsApplicationsWebhookConfigPartialUpdateData>
  >
): UseMutationOptions<
  ApplicationsApplicationsWebhookConfigPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsWebhookConfigPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsWebhookConfigPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsWebhookConfigPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsWebhookConfigPartialUpdate(
        {
          ...options,
          ...fnOptions,
          throwOnError: true
        }
      )
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigClearSecretCreateMutation = (
  options?: Partial<
    Options<ApplicationsApplicationsWebhookConfigClearSecretCreateData>
  >
): UseMutationOptions<
  ApplicationsApplicationsWebhookConfigClearSecretCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsWebhookConfigClearSecretCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsWebhookConfigClearSecretCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsWebhookConfigClearSecretCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await applicationsApplicationsWebhookConfigClearSecretCreate({
          ...options,
          ...fnOptions,
          throwOnError: true
        })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsWebhookConfigRotateSecretCreateMutation = (
  options?: Partial<
    Options<ApplicationsApplicationsWebhookConfigRotateSecretCreateData>
  >
): UseMutationOptions<
  ApplicationsApplicationsWebhookConfigRotateSecretCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsWebhookConfigRotateSecretCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsWebhookConfigRotateSecretCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsWebhookConfigRotateSecretCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await applicationsApplicationsWebhookConfigRotateSecretCreate({
          ...options,
          ...fnOptions,
          throwOnError: true
        })
      return data
    }
  }
  return mutationOptions
}

export const applicationsApplicationsRetrieveQueryKey = (
  options: Options<ApplicationsApplicationsRetrieveData>
) => createQueryKey('applicationsApplicationsRetrieve', options)

export const applicationsApplicationsRetrieveOptions = (
  options: Options<ApplicationsApplicationsRetrieveData>
) =>
  queryOptions<
    ApplicationsApplicationsRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsApplicationsRetrieveResponse,
    ReturnType<typeof applicationsApplicationsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsApplicationsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsApplicationsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsPartialUpdateMutation = (
  options?: Partial<Options<ApplicationsApplicationsPartialUpdateData>>
): UseMutationOptions<
  ApplicationsApplicationsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsApplicationsUpdateMutation = (
  options?: Partial<Options<ApplicationsApplicationsUpdateData>>
): UseMutationOptions<
  ApplicationsApplicationsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsApplicationsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsApplicationsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsApplicationsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsApplicationsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const applicationsMobileBuildsLatestRetrieveQueryKey = (
  options: Options<ApplicationsMobileBuildsLatestRetrieveData>
) => createQueryKey('applicationsMobileBuildsLatestRetrieve', options)

/**
 * The latest active build of the app: the highest `version_code` staff have published and not withdrawn. `download_url` is presigned and expires, so request it when the user is about to download rather than caching it.
 */
export const applicationsMobileBuildsLatestRetrieveOptions = (
  options: Options<ApplicationsMobileBuildsLatestRetrieveData>
) =>
  queryOptions<
    ApplicationsMobileBuildsLatestRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsMobileBuildsLatestRetrieveResponse,
    ReturnType<typeof applicationsMobileBuildsLatestRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsMobileBuildsLatestRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsMobileBuildsLatestRetrieveQueryKey(options)
  })

export const applicationsNetworkingOrganizationsListQueryKey = (
  options?: Options<ApplicationsNetworkingOrganizationsListData>
) => createQueryKey('applicationsNetworkingOrganizationsList', options)

/**
 * @deprecated
 */
export const applicationsNetworkingOrganizationsListOptions = (
  options?: Options<ApplicationsNetworkingOrganizationsListData>
) =>
  queryOptions<
    ApplicationsNetworkingOrganizationsListResponse,
    AxiosError<DefaultError>,
    ApplicationsNetworkingOrganizationsListResponse,
    ReturnType<typeof applicationsNetworkingOrganizationsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsNetworkingOrganizationsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsNetworkingOrganizationsListQueryKey(options)
  })

export const applicationsNetworkingOrganizationsListInfiniteQueryKey = (
  options?: Options<ApplicationsNetworkingOrganizationsListData>
): QueryKey<Options<ApplicationsNetworkingOrganizationsListData>> =>
  createQueryKey('applicationsNetworkingOrganizationsList', options, true)

/**
 * @deprecated
 */
export const applicationsNetworkingOrganizationsListInfiniteOptions = (
  options?: Options<ApplicationsNetworkingOrganizationsListData>
) => {
  const opts = infiniteQueryOptions<
    ApplicationsNetworkingOrganizationsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApplicationsNetworkingOrganizationsListResponse>,
    QueryKey<Options<ApplicationsNetworkingOrganizationsListData>>,
    | number
    | Pick<
        QueryKey<Options<ApplicationsNetworkingOrganizationsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApplicationsNetworkingOrganizationsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await applicationsNetworkingOrganizationsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: applicationsNetworkingOrganizationsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const applicationsNetworkingOrganizationsByEmailCreateMutation = (
  options?: Partial<
    Options<ApplicationsNetworkingOrganizationsByEmailCreateData>
  >
): UseMutationOptions<
  ApplicationsNetworkingOrganizationsByEmailCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsNetworkingOrganizationsByEmailCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsNetworkingOrganizationsByEmailCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsNetworkingOrganizationsByEmailCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsNetworkingOrganizationsByEmailCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsRemoveDestroyMutation = (
  options?: Partial<Options<ApplicationsRemoveDestroyData>>
): UseMutationOptions<
  ApplicationsRemoveDestroyResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsRemoveDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsRemoveDestroyResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsRemoveDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsRemoveDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const applicationsTeamListListQueryKey = (
  options: Options<ApplicationsTeamListListData>
) => createQueryKey('applicationsTeamListList', options)

export const applicationsTeamListListOptions = (
  options: Options<ApplicationsTeamListListData>
) =>
  queryOptions<
    ApplicationsTeamListListResponse,
    AxiosError<DefaultError>,
    ApplicationsTeamListListResponse,
    ReturnType<typeof applicationsTeamListListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsTeamListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsTeamListListQueryKey(options)
  })

export const applicationsTeamListListInfiniteQueryKey = (
  options: Options<ApplicationsTeamListListData>
): QueryKey<Options<ApplicationsTeamListListData>> =>
  createQueryKey('applicationsTeamListList', options, true)

export const applicationsTeamListListInfiniteOptions = (
  options: Options<ApplicationsTeamListListData>
) => {
  const opts = infiniteQueryOptions<
    ApplicationsTeamListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApplicationsTeamListListResponse>,
    QueryKey<Options<ApplicationsTeamListListData>>,
    | number
    | Pick<
        QueryKey<Options<ApplicationsTeamListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApplicationsTeamListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await applicationsTeamListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: applicationsTeamListListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const applicationsThirdPartyCreateMutation = (
  options?: Partial<Options<ApplicationsThirdPartyCreateData>>
): UseMutationOptions<
  ApplicationsThirdPartyCreateResponse,
  AxiosError<DefaultError>,
  Options<ApplicationsThirdPartyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ApplicationsThirdPartyCreateResponse,
    AxiosError<DefaultError>,
    Options<ApplicationsThirdPartyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await applicationsThirdPartyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const applicationsUserCanAccessRetrieveQueryKey = (
  options: Options<ApplicationsUserCanAccessRetrieveData>
) => createQueryKey('applicationsUserCanAccessRetrieve', options)

export const applicationsUserCanAccessRetrieveOptions = (
  options: Options<ApplicationsUserCanAccessRetrieveData>
) =>
  queryOptions<
    ApplicationsUserCanAccessRetrieveResponse,
    AxiosError<ApplicationsUserCanAccessRetrieveError>,
    ApplicationsUserCanAccessRetrieveResponse,
    ReturnType<typeof applicationsUserCanAccessRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsUserCanAccessRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsUserCanAccessRetrieveQueryKey(options)
  })

export const applicationsUserDetailsRetrieveQueryKey = (
  options: Options<ApplicationsUserDetailsRetrieveData>
) => createQueryKey('applicationsUserDetailsRetrieve', options)

export const applicationsUserDetailsRetrieveOptions = (
  options: Options<ApplicationsUserDetailsRetrieveData>
) =>
  queryOptions<
    ApplicationsUserDetailsRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsUserDetailsRetrieveResponse,
    ReturnType<typeof applicationsUserDetailsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsUserDetailsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsUserDetailsRetrieveQueryKey(options)
  })

export const applicationsUserListListQueryKey = (
  options: Options<ApplicationsUserListListData>
) => createQueryKey('applicationsUserListList', options)

export const applicationsUserListListOptions = (
  options: Options<ApplicationsUserListListData>
) =>
  queryOptions<
    ApplicationsUserListListResponse,
    AxiosError<DefaultError>,
    ApplicationsUserListListResponse,
    ReturnType<typeof applicationsUserListListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsUserListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsUserListListQueryKey(options)
  })

export const applicationsUserListListInfiniteQueryKey = (
  options: Options<ApplicationsUserListListData>
): QueryKey<Options<ApplicationsUserListListData>> =>
  createQueryKey('applicationsUserListList', options, true)

export const applicationsUserListListInfiniteOptions = (
  options: Options<ApplicationsUserListListData>
) => {
  const opts = infiniteQueryOptions<
    ApplicationsUserListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ApplicationsUserListListResponse>,
    QueryKey<Options<ApplicationsUserListListData>>,
    | number
    | Pick<
        QueryKey<Options<ApplicationsUserListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ApplicationsUserListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await applicationsUserListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: applicationsUserListListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const applicationsUserMembershipRetrieveQueryKey = (
  options: Options<ApplicationsUserMembershipRetrieveData>
) => createQueryKey('applicationsUserMembershipRetrieve', options)

/**
 * Is the caller an active member of the workspace that owns this application?
 *
 * For services that serve every member of a workspace, not only those granted the app
 * itself (Squad's org-home chat), so it must not depend on an app grant the way
 * ``details`` and ``can-access`` do. Blocked and archived memberships do not count.
 *
 * Always 200 for an authenticated caller, an unknown token included: a 404 is left to
 * mean the route does not exist, so a caller can tell an older Core from a non-member.
 */
export const applicationsUserMembershipRetrieveOptions = (
  options: Options<ApplicationsUserMembershipRetrieveData>
) =>
  queryOptions<
    ApplicationsUserMembershipRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsUserMembershipRetrieveResponse,
    ReturnType<typeof applicationsUserMembershipRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsUserMembershipRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsUserMembershipRetrieveQueryKey(options)
  })

export const applicationsValidateRetrieveQueryKey = (
  options: Options<ApplicationsValidateRetrieveData>
) => createQueryKey('applicationsValidateRetrieve', options)

export const applicationsValidateRetrieveOptions = (
  options: Options<ApplicationsValidateRetrieveData>
) =>
  queryOptions<
    ApplicationsValidateRetrieveResponse,
    AxiosError<DefaultError>,
    ApplicationsValidateRetrieveResponse,
    ReturnType<typeof applicationsValidateRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await applicationsValidateRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: applicationsValidateRetrieveQueryKey(options)
  })

export const attachmentsListQueryKey = (
  options?: Options<AttachmentsListData>
) => createQueryKey('attachmentsList', options)

/**
 * Workspace attachments require `attachments.view`; callers may also list their own workspace-less uploads without a workspace permission.
 */
export const attachmentsListOptions = (
  options?: Options<AttachmentsListData>
) =>
  queryOptions<
    AttachmentsListResponse,
    AxiosError<DefaultError>,
    AttachmentsListResponse,
    ReturnType<typeof attachmentsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: attachmentsListQueryKey(options)
  })

export const attachmentsListInfiniteQueryKey = (
  options?: Options<AttachmentsListData>
): QueryKey<Options<AttachmentsListData>> =>
  createQueryKey('attachmentsList', options, true)

/**
 * Workspace attachments require `attachments.view`; callers may also list their own workspace-less uploads without a workspace permission.
 */
export const attachmentsListInfiniteOptions = (
  options?: Options<AttachmentsListData>
) => {
  const opts = infiniteQueryOptions<
    AttachmentsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<AttachmentsListResponse>,
    QueryKey<Options<AttachmentsListData>>,
    | number
    | Pick<
        QueryKey<Options<AttachmentsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AttachmentsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await attachmentsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: attachmentsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Workspace attachments require `attachments.delete`; callers may also delete their own workspace-less uploads without a workspace permission.
 */
export const attachmentsDestroyMutation = (
  options?: Partial<Options<AttachmentsDestroyData>>
): UseMutationOptions<
  AttachmentsDestroyResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsDestroyResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await attachmentsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const attachmentsRetrieveQueryKey = (
  options: Options<AttachmentsRetrieveData>
) => createQueryKey('attachmentsRetrieve', options)

/**
 * Workspace attachments require `attachments.view`; callers may also retrieve their own workspace-less uploads without a workspace permission.
 */
export const attachmentsRetrieveOptions = (
  options: Options<AttachmentsRetrieveData>
) =>
  queryOptions<
    AttachmentsRetrieveResponse,
    AxiosError<DefaultError>,
    AttachmentsRetrieveResponse,
    ReturnType<typeof attachmentsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: attachmentsRetrieveQueryKey(options)
  })

/**
 * For workspace attachments, GET requires `attachments.view` and DELETE requires `attachments.delete`. Callers may access versions of their own workspace-less uploads without a workspace permission.
 */
export const attachmentsVersionDestroyMutation = (
  options?: Partial<Options<AttachmentsVersionDestroyData>>
): UseMutationOptions<
  AttachmentsVersionDestroyResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsVersionDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsVersionDestroyResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsVersionDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await attachmentsVersionDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const attachmentsVersionRetrieveQueryKey = (
  options: Options<AttachmentsVersionRetrieveData>
) => createQueryKey('attachmentsVersionRetrieve', options)

/**
 * For workspace attachments, GET requires `attachments.view` and DELETE requires `attachments.delete`. Callers may access versions of their own workspace-less uploads without a workspace permission.
 */
export const attachmentsVersionRetrieveOptions = (
  options: Options<AttachmentsVersionRetrieveData>
) =>
  queryOptions<
    AttachmentsVersionRetrieveResponse,
    AxiosError<DefaultError>,
    AttachmentsVersionRetrieveResponse,
    ReturnType<typeof attachmentsVersionRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsVersionRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: attachmentsVersionRetrieveQueryKey(options)
  })

/**
 * Set attachment visibility
 *
 * Toggle an attachment between public and private. Moves the underlying object between the public and private buckets so its URL stays valid. Workspace attachments require `attachments.upload`; callers may also update their own workspace-less uploads.
 */
export const attachmentsVisibilityPartialUpdateMutation = (
  options?: Partial<Options<AttachmentsVisibilityPartialUpdateData>>
): UseMutationOptions<
  AttachmentsVisibilityPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsVisibilityPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsVisibilityPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsVisibilityPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await attachmentsVisibilityPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Create avatar upload URL
 *
 * Create a presigned URL for a personal avatar without workspace ownership. The PUT must send `Content-Type` equal to the returned `content_type`: it is part of the signature, so a different or missing header is rejected by the storage. No workspace permission is required.
 */
export const attachmentsCreateAvatarSignedUrlCreateMutation = (
  options?: Partial<Options<AttachmentsCreateAvatarSignedUrlCreateData>>
): UseMutationOptions<
  AttachmentsCreateAvatarSignedUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsCreateAvatarSignedUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsCreateAvatarSignedUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsCreateAvatarSignedUrlCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await attachmentsCreateAvatarSignedUrlCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Create workspace attachment upload URL
 *
 * Create a presigned URL for uploading an attachment owned by a workspace. The PUT must send `Content-Type` equal to the returned `content_type`: it is part of the signature, so a different or missing header is rejected by the storage. Requires workspace permission: `attachments.upload`.
 */
export const attachmentsCreateSignedUrlCreateMutation = (
  options?: Partial<Options<AttachmentsCreateSignedUrlCreateData>>
): UseMutationOptions<
  AttachmentsCreateSignedUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsCreateSignedUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsCreateSignedUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsCreateSignedUrlCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await attachmentsCreateSignedUrlCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Webhook for S3 events
 *
 * Handle S3 put and delete events webhook. No workspace permission is required.
 */
export const attachmentsWebhookCreateMutation = (
  options?: Partial<Options<AttachmentsWebhookCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<AttachmentsWebhookCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<AttachmentsWebhookCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await attachmentsWebhookCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationClientAuthMethodsRetrieveQueryKey = (
  options?: Options<AuthorizationClientAuthMethodsRetrieveData>
) => createQueryKey('authorizationClientAuthMethodsRetrieve', options)

export const authorizationClientAuthMethodsRetrieveOptions = (
  options?: Options<AuthorizationClientAuthMethodsRetrieveData>
) =>
  queryOptions<
    AuthorizationClientAuthMethodsRetrieveResponse,
    AxiosError<DefaultError>,
    AuthorizationClientAuthMethodsRetrieveResponse,
    ReturnType<typeof authorizationClientAuthMethodsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationClientAuthMethodsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationClientAuthMethodsRetrieveQueryKey(options)
  })

/**
 * Generate WebAuthn authentication options (challenge).
 *
 * Client-level (no organization context). The ``domain_name`` and
 * ``service_token`` fields are accepted for forward-compatibility with
 * per-organization passkey support but are currently ignored.
 */
export const authorizationPasskeyAuthenticateStartCreateMutation = (
  options?: Partial<Options<AuthorizationPasskeyAuthenticateStartCreateData>>
): UseMutationOptions<
  AuthorizationPasskeyAuthenticateStartCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationPasskeyAuthenticateStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationPasskeyAuthenticateStartCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationPasskeyAuthenticateStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationPasskeyAuthenticateStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Verify WebAuthn assertion and issue JWT tokens.
 *
 * Client-level authentication (no organization context). Skips MFA
 * because WebAuthn is inherently multi-factor (possession + biometric/PIN).
 *
 * The ``domain_name`` and ``service_token`` fields are accepted for
 * forward-compatibility with per-organization passkey support but are
 * currently ignored.
 */
export const authorizationPasskeyAuthenticateVerifyCreateMutation = (
  options?: Partial<Options<AuthorizationPasskeyAuthenticateVerifyCreateData>>
): UseMutationOptions<
  AuthorizationPasskeyAuthenticateVerifyCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationPasskeyAuthenticateVerifyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationPasskeyAuthenticateVerifyCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationPasskeyAuthenticateVerifyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationPasskeyAuthenticateVerifyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationQrApproveCreateMutation = (
  options?: Partial<Options<AuthorizationQrApproveCreateData>>
): UseMutationOptions<
  AuthorizationQrApproveCreateResponse,
  AxiosError<AuthorizationQrApproveCreateError>,
  Options<AuthorizationQrApproveCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationQrApproveCreateResponse,
    AxiosError<AuthorizationQrApproveCreateError>,
    Options<AuthorizationQrApproveCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationQrApproveCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationQrCancelCreateMutation = (
  options?: Partial<Options<AuthorizationQrCancelCreateData>>
): UseMutationOptions<
  AuthorizationQrCancelCreateResponse,
  AxiosError<AuthorizationQrCancelCreateError>,
  Options<AuthorizationQrCancelCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationQrCancelCreateResponse,
    AxiosError<AuthorizationQrCancelCreateError>,
    Options<AuthorizationQrCancelCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationQrCancelCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationQrDenyCreateMutation = (
  options?: Partial<Options<AuthorizationQrDenyCreateData>>
): UseMutationOptions<
  AuthorizationQrDenyCreateResponse,
  AxiosError<AuthorizationQrDenyCreateError>,
  Options<AuthorizationQrDenyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationQrDenyCreateResponse,
    AxiosError<AuthorizationQrDenyCreateError>,
    Options<AuthorizationQrDenyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationQrDenyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationQrScanCreateMutation = (
  options?: Partial<Options<AuthorizationQrScanCreateData>>
): UseMutationOptions<
  AuthorizationQrScanCreateResponse,
  AxiosError<AuthorizationQrScanCreateError>,
  Options<AuthorizationQrScanCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationQrScanCreateResponse,
    AxiosError<AuthorizationQrScanCreateError>,
    Options<AuthorizationQrScanCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationQrScanCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationQrStartCreateMutation = (
  options?: Partial<Options<AuthorizationQrStartCreateData>>
): UseMutationOptions<
  AuthorizationQrStartCreateResponse,
  AxiosError<AuthorizationQrStartCreateError>,
  Options<AuthorizationQrStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationQrStartCreateResponse,
    AxiosError<AuthorizationQrStartCreateError>,
    Options<AuthorizationQrStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationQrStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationQrWaitCreateMutation = (
  options?: Partial<Options<AuthorizationQrWaitCreateData>>
): UseMutationOptions<
  AuthorizationQrWaitCreateResponse,
  AxiosError<AuthorizationQrWaitCreateError>,
  Options<AuthorizationQrWaitCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationQrWaitCreateResponse,
    AxiosError<AuthorizationQrWaitCreateError>,
    Options<AuthorizationQrWaitCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationQrWaitCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Exchange Apple OAuth code and link Apple to the current user
 * (account-level / client connect flow). Uses platform-wide Apple credentials.
 */
export const authorizationSocialAppleConnectCreateMutation = (
  options?: Partial<Options<AuthorizationSocialAppleConnectCreateData>>
): UseMutationOptions<
  AuthorizationSocialAppleConnectCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialAppleConnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialAppleConnectCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialAppleConnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialAppleConnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Apple OAuth URL for linking Apple to the current user
 * (account-level / client connect flow). Uses platform-wide settings,
 * not per-organization Apple credentials.
 */
export const authorizationSocialAppleConnectUrlCreateMutation = (
  options?: Partial<Options<AuthorizationSocialAppleConnectUrlCreateData>>
): UseMutationOptions<
  AuthorizationSocialAppleConnectUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialAppleConnectUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialAppleConnectUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialAppleConnectUrlCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialAppleConnectUrlCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Exchange Apple OAuth code and link org-specific Apple to the current user.
 */
export const authorizationSocialAppleOrgConnectCreateMutation = (
  options?: Partial<Options<AuthorizationSocialAppleOrgConnectCreateData>>
): UseMutationOptions<
  AuthorizationSocialAppleOrgConnectCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialAppleOrgConnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialAppleOrgConnectCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialAppleOrgConnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialAppleOrgConnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Apple OAuth URL for linking org-specific Apple to the current user.
 */
export const authorizationSocialAppleOrgConnectUrlCreateMutation = (
  options?: Partial<Options<AuthorizationSocialAppleOrgConnectUrlCreateData>>
): UseMutationOptions<
  AuthorizationSocialAppleOrgConnectUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialAppleOrgConnectUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialAppleOrgConnectUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialAppleOrgConnectUrlCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialAppleOrgConnectUrlCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Apple Sign In OAuth URL for org-scoped login.
 */
export const authorizationSocialAppleStartCreateMutation = (
  options?: Partial<Options<AuthorizationSocialAppleStartCreateData>>
): UseMutationOptions<
  AuthorizationSocialAppleStartCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialAppleStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialAppleStartCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialAppleStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialAppleStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Apple Sign In OAuth URL for account-level (client) login.
 */
export const authorizationSocialAppleStartClientCreateMutation = (
  options?: Partial<Options<AuthorizationSocialAppleStartClientCreateData>>
): UseMutationOptions<
  AuthorizationSocialAppleStartClientCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialAppleStartClientCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialAppleStartClientCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialAppleStartClientCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialAppleStartClientCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationSocialAppleStateInfoRetrieveQueryKey = (
  options?: Options<AuthorizationSocialAppleStateInfoRetrieveData>
) => createQueryKey('authorizationSocialAppleStateInfoRetrieve', options)

/**
 * Public endpoint to read return_origin from signed Apple social state.
 */
export const authorizationSocialAppleStateInfoRetrieveOptions = (
  options?: Options<AuthorizationSocialAppleStateInfoRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof authorizationSocialAppleStateInfoRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationSocialAppleStateInfoRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationSocialAppleStateInfoRetrieveQueryKey(options)
  })

/**
 * Build an IdP-side authorize URL and return it to the SPA.
 */
export const authorizationSocialCustomStartCreateMutation = (
  options?: Partial<Options<AuthorizationSocialCustomStartCreateData>>
): UseMutationOptions<
  AuthorizationSocialCustomStartCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialCustomStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialCustomStartCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialCustomStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialCustomStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Exchange ``code`` for an authenticated JWT pair (OIDC / OAuth2 only).
 */
export const authorizationSocialCustomExchangeCreateMutation = (
  options?: Partial<Options<AuthorizationSocialCustomExchangeCreateData>>
): UseMutationOptions<
  AuthorizationSocialCustomExchangeCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialCustomExchangeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialCustomExchangeCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialCustomExchangeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialCustomExchangeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Trade a SAML handoff token for the JWT pair.
 */
export const authorizationSocialCustomSamlExchangeCreateMutation = (
  options?: Partial<Options<AuthorizationSocialCustomSamlExchangeCreateData>>
): UseMutationOptions<
  AuthorizationSocialCustomSamlExchangeCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialCustomSamlExchangeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialCustomSamlExchangeCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialCustomSamlExchangeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialCustomSamlExchangeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Exchange Microsoft Entra ID OAuth code and link Microsoft to the current user (connect flow).
 */
export const authorizationSocialEntraidConnectCreateMutation = (
  options?: Partial<Options<AuthorizationSocialEntraidConnectCreateData>>
): UseMutationOptions<
  AuthorizationSocialEntraidConnectCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialEntraidConnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialEntraidConnectCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialEntraidConnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialEntraidConnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Microsoft Entra ID OAuth URL for linking Microsoft to the current user (connect flow).
 */
export const authorizationSocialEntraidConnectUrlCreateMutation = (
  options?: Partial<Options<AuthorizationSocialEntraidConnectUrlCreateData>>
): UseMutationOptions<
  AuthorizationSocialEntraidConnectUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialEntraidConnectUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialEntraidConnectUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialEntraidConnectUrlCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialEntraidConnectUrlCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Microsoft Entra ID OAuth URL for org-scoped login.
 */
export const authorizationSocialEntraidStartCreateMutation = (
  options?: Partial<Options<AuthorizationSocialEntraidStartCreateData>>
): UseMutationOptions<
  AuthorizationSocialEntraidStartCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialEntraidStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialEntraidStartCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialEntraidStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialEntraidStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationSocialEntraidStateInfoRetrieveQueryKey = (
  options?: Options<AuthorizationSocialEntraidStateInfoRetrieveData>
) => createQueryKey('authorizationSocialEntraidStateInfoRetrieve', options)

/**
 * Public endpoint to read return_origin from signed Entra ID social state (for relay).
 */
export const authorizationSocialEntraidStateInfoRetrieveOptions = (
  options?: Options<AuthorizationSocialEntraidStateInfoRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof authorizationSocialEntraidStateInfoRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationSocialEntraidStateInfoRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationSocialEntraidStateInfoRetrieveQueryKey(options)
  })

export const authorizationSocialExchangeCreateMutation = (
  options?: Partial<Options<AuthorizationSocialExchangeCreateData>>
): UseMutationOptions<
  AuthorizationSocialExchangeCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialExchangeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialExchangeCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialExchangeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialExchangeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationSocialExchangeClientCreateMutation = (
  options?: Partial<Options<AuthorizationSocialExchangeClientCreateData>>
): UseMutationOptions<
  AuthorizationSocialExchangeClientCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialExchangeClientCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialExchangeClientCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialExchangeClientCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialExchangeClientCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Exchange Google OAuth code and link Google to the current user (connect flow).
 */
export const authorizationSocialGoogleClientConnectCreateMutation = (
  options?: Partial<Options<AuthorizationSocialGoogleClientConnectCreateData>>
): UseMutationOptions<
  AuthorizationSocialGoogleClientConnectCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialGoogleClientConnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialGoogleClientConnectCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialGoogleClientConnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialGoogleClientConnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Google OAuth URL for linking Google to the current user (connect flow).
 */
export const authorizationSocialGoogleClientConnectUrlCreateMutation = (
  options?: Partial<
    Options<AuthorizationSocialGoogleClientConnectUrlCreateData>
  >
): UseMutationOptions<
  AuthorizationSocialGoogleClientConnectUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialGoogleClientConnectUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialGoogleClientConnectUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialGoogleClientConnectUrlCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialGoogleClientConnectUrlCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Exchange Google OAuth code and link org-specific Google to the current user.
 */
export const authorizationSocialGoogleConnectCreateMutation = (
  options?: Partial<Options<AuthorizationSocialGoogleConnectCreateData>>
): UseMutationOptions<
  AuthorizationSocialGoogleConnectCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialGoogleConnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialGoogleConnectCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialGoogleConnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialGoogleConnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Return Google OAuth URL for linking org-specific Google to the current user.
 */
export const authorizationSocialGoogleConnectUrlCreateMutation = (
  options?: Partial<Options<AuthorizationSocialGoogleConnectUrlCreateData>>
): UseMutationOptions<
  AuthorizationSocialGoogleConnectUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialGoogleConnectUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialGoogleConnectUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialGoogleConnectUrlCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialGoogleConnectUrlCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Start Google sign-in for a workspace, on the workspace's own client or the platform's.
 */
export const authorizationSocialGoogleStartCreateMutation = (
  options?: Partial<Options<AuthorizationSocialGoogleStartCreateData>>
): UseMutationOptions<
  AuthorizationSocialGoogleStartCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialGoogleStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialGoogleStartCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialGoogleStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialGoogleStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationSocialGoogleStartClientCreateMutation = (
  options?: Partial<Options<AuthorizationSocialGoogleStartClientCreateData>>
): UseMutationOptions<
  AuthorizationSocialGoogleStartClientCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationSocialGoogleStartClientCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationSocialGoogleStartClientCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationSocialGoogleStartClientCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationSocialGoogleStartClientCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationSocialGoogleStateInfoRetrieveQueryKey = (
  options?: Options<AuthorizationSocialGoogleStateInfoRetrieveData>
) => createQueryKey('authorizationSocialGoogleStateInfoRetrieve', options)

/**
 * Public endpoint to read return_origin and redirect_uri from signed Google social state.
 */
export const authorizationSocialGoogleStateInfoRetrieveOptions = (
  options?: Options<AuthorizationSocialGoogleStateInfoRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof authorizationSocialGoogleStateInfoRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationSocialGoogleStateInfoRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationSocialGoogleStateInfoRetrieveQueryKey(options)
  })

/**
 * Obtain JWT access and refresh tokens under organization password policy.
 */
export const authorizationTokenCreateMutation = (
  options?: Partial<Options<AuthorizationTokenCreateData>>
): UseMutationOptions<
  AuthorizationTokenCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Obtain JWT token pair for client flow (without domain context).
 */
export const authorizationTokenClientCreateMutation = (
  options?: Partial<Options<AuthorizationTokenClientCreateData>>
): UseMutationOptions<
  AuthorizationTokenClientCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenClientCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenClientCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenClientCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenClientCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationTokenCookieRetrieveQueryKey = (
  options?: Options<AuthorizationTokenCookieRetrieveData>
) => createQueryKey('authorizationTokenCookieRetrieve', options)

/**
 * Get access token using refresh token from cookie.
 *
 * Reads the refresh token from (in priority order):
 * 1. The ``cookie_token`` cookie
 * 2. The ``refresh`` query parameter (fallback for cross-origin local dev)
 */
export const authorizationTokenCookieRetrieveOptions = (
  options?: Options<AuthorizationTokenCookieRetrieveData>
) =>
  queryOptions<
    AuthorizationTokenCookieRetrieveResponse,
    AxiosError<DefaultError>,
    AuthorizationTokenCookieRetrieveResponse,
    ReturnType<typeof authorizationTokenCookieRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationTokenCookieRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationTokenCookieRetrieveQueryKey(options)
  })

export const authorizationTokenLogoutRetrieveQueryKey = (
  options?: Options<AuthorizationTokenLogoutRetrieveData>
) => createQueryKey('authorizationTokenLogoutRetrieve', options)

/**
 * Logout user, blacklist the whole session, and clear the refresh cookie.
 */
export const authorizationTokenLogoutRetrieveOptions = (
  options?: Options<AuthorizationTokenLogoutRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof authorizationTokenLogoutRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationTokenLogoutRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationTokenLogoutRetrieveQueryKey(options)
  })

/**
 * Verify a magic-link token from the email-OTP login email.
 *
 * Unlike ``EmailOTPVerifyView``, the link itself is the credential — no
 * bearer ``otp_access_token`` is required since the link travels in the
 * email, which proves email ownership. Marks the underlying ``OTPCode`` as
 * USED so the 6-digit code path is invalidated in lockstep.
 */
export const authorizationTokenOtpLinkVerifyCreateMutation = (
  options?: Partial<Options<AuthorizationTokenOtpLinkVerifyCreateData>>
): UseMutationOptions<
  AuthorizationTokenOtpLinkVerifyCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenOtpLinkVerifyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenOtpLinkVerifyCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenOtpLinkVerifyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenOtpLinkVerifyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Start passwordless email-OTP sign-in.
 *
 * Always returns a uniform success shape to prevent user enumeration. An OTP
 * is dispatched and an access token is returned only when:
 * * ``settings.EMAIL_OTP_LOGIN_ENABLED`` is True
 * * If ``domain_name`` is provided, the resolved organization has the
 * ``email_otp`` method enabled.
 * * The submitted email matches an existing active user.
 */
export const authorizationTokenOtpRequestCreateMutation = (
  options?: Partial<Options<AuthorizationTokenOtpRequestCreateData>>
): UseMutationOptions<
  AuthorizationTokenOtpRequestCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenOtpRequestCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenOtpRequestCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenOtpRequestCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenOtpRequestCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Verify an email-OTP code and issue full access+refresh tokens.
 *
 * Unlike ``UserTokenObtainPairView``, this flow **skips** the MFA gate because
 * ownership of the email was already proven by the OTP itself.
 */
export const authorizationTokenOtpVerifyCreateMutation = (
  options?: Partial<Options<AuthorizationTokenOtpVerifyCreateData>>
): UseMutationOptions<
  AuthorizationTokenOtpVerifyCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenOtpVerifyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenOtpVerifyCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenOtpVerifyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenOtpVerifyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Takes a refresh type JSON web token and returns an access type JSON web
 * token if the refresh token is valid.
 */
export const authorizationTokenRefreshCreateMutation = (
  options?: Partial<Options<AuthorizationTokenRefreshCreateData>>
): UseMutationOptions<
  AuthorizationTokenRefreshCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenRefreshCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenRefreshCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenRefreshCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenRefreshCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationTokenServiceVerifyCreateMutation = (
  options?: Partial<Options<AuthorizationTokenServiceVerifyCreateData>>
): UseMutationOptions<
  AuthorizationTokenServiceVerifyCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenServiceVerifyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenServiceVerifyCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenServiceVerifyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenServiceVerifyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationTokenVerifyCreateMutation = (
  options?: Partial<Options<AuthorizationTokenVerifyCreateData>>
): UseMutationOptions<
  AuthorizationTokenVerifyCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationTokenVerifyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationTokenVerifyCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationTokenVerifyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationTokenVerifyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationV2ClientsListQueryKey = (
  options?: Options<AuthorizationV2ClientsListData>
) => createQueryKey('authorizationV2ClientsList', options)

/**
 * Requires workspace permission: `applications.view`.
 */
export const authorizationV2ClientsListOptions = (
  options?: Options<AuthorizationV2ClientsListData>
) =>
  queryOptions<
    AuthorizationV2ClientsListResponse,
    AxiosError<DefaultError>,
    AuthorizationV2ClientsListResponse,
    ReturnType<typeof authorizationV2ClientsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationV2ClientsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationV2ClientsListQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsCreateMutation = (
  options?: Partial<Options<AuthorizationV2ClientsCreateData>>
): UseMutationOptions<
  AuthorizationV2ClientsCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2ClientsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2ClientsCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2ClientsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2ClientsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationV2ClientsRetrieveQueryKey = (
  options: Options<AuthorizationV2ClientsRetrieveData>
) => createQueryKey('authorizationV2ClientsRetrieve', options)

/**
 * Requires workspace permission: `applications.view`.
 */
export const authorizationV2ClientsRetrieveOptions = (
  options: Options<AuthorizationV2ClientsRetrieveData>
) =>
  queryOptions<
    AuthorizationV2ClientsRetrieveResponse,
    AxiosError<DefaultError>,
    AuthorizationV2ClientsRetrieveResponse,
    ReturnType<typeof authorizationV2ClientsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationV2ClientsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationV2ClientsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsPartialUpdateMutation = (
  options?: Partial<Options<AuthorizationV2ClientsPartialUpdateData>>
): UseMutationOptions<
  AuthorizationV2ClientsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2ClientsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2ClientsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2ClientsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2ClientsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsRevokeCreateMutation = (
  options?: Partial<Options<AuthorizationV2ClientsRevokeCreateData>>
): UseMutationOptions<
  AuthorizationV2ClientsRevokeCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2ClientsRevokeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2ClientsRevokeCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2ClientsRevokeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2ClientsRevokeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const authorizationV2ClientsRotateCreateMutation = (
  options?: Partial<Options<AuthorizationV2ClientsRotateCreateData>>
): UseMutationOptions<
  AuthorizationV2ClientsRotateCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2ClientsRotateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2ClientsRotateCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2ClientsRotateCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2ClientsRotateCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Allauth-backed email verification endpoint.
 */
export const authorizationV2EmailVerifyCreateMutation = (
  options?: Partial<Options<AuthorizationV2EmailVerifyCreateData>>
): UseMutationOptions<
  AuthorizationV2EmailVerifyCreateResponse,
  AxiosError<AuthorizationV2EmailVerifyCreateError>,
  Options<AuthorizationV2EmailVerifyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2EmailVerifyCreateResponse,
    AxiosError<AuthorizationV2EmailVerifyCreateError>,
    Options<AuthorizationV2EmailVerifyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2EmailVerifyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationV2InviteAcceptCreateMutation = (
  options?: Partial<Options<AuthorizationV2InviteAcceptCreateData>>
): UseMutationOptions<
  AuthorizationV2InviteAcceptCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2InviteAcceptCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2InviteAcceptCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2InviteAcceptCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2InviteAcceptCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationV2InviteInfoRetrieveQueryKey = (
  options: Options<AuthorizationV2InviteInfoRetrieveData>
) => createQueryKey('authorizationV2InviteInfoRetrieve', options)

/**
 * Resolve invite metadata so the UI can branch on whether the user already has a password.
 */
export const authorizationV2InviteInfoRetrieveOptions = (
  options: Options<AuthorizationV2InviteInfoRetrieveData>
) =>
  queryOptions<
    AuthorizationV2InviteInfoRetrieveResponse,
    AxiosError<AuthorizationV2InviteInfoRetrieveError>,
    AuthorizationV2InviteInfoRetrieveResponse,
    ReturnType<typeof authorizationV2InviteInfoRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationV2InviteInfoRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationV2InviteInfoRetrieveQueryKey(options)
  })

export const authorizationV2InviteRequestCreateMutation = (
  options?: Partial<Options<AuthorizationV2InviteRequestCreateData>>
): UseMutationOptions<
  AuthorizationV2InviteRequestCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2InviteRequestCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2InviteRequestCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2InviteRequestCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2InviteRequestCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mcpConsentRetrieveQueryKey = (
  options: Options<McpConsentRetrieveData>
) => createQueryKey('mcpConsentRetrieve', options)

/**
 * 404 when the request expired or was opened by another user.
 */
export const mcpConsentRetrieveOptions = (
  options: Options<McpConsentRetrieveData>
) =>
  queryOptions<
    McpConsentRetrieveResponse,
    AxiosError<DefaultError>,
    McpConsentRetrieveResponse,
    ReturnType<typeof mcpConsentRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mcpConsentRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mcpConsentRetrieveQueryKey(options)
  })

export const mcpConsentApproveMutation = (
  options?: Partial<Options<McpConsentApproveData>>
): UseMutationOptions<
  McpConsentApproveResponse,
  AxiosError<DefaultError>,
  Options<McpConsentApproveData>
> => {
  const mutationOptions: UseMutationOptions<
    McpConsentApproveResponse,
    AxiosError<DefaultError>,
    Options<McpConsentApproveData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpConsentApprove({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mcpConsentDenyMutation = (
  options?: Partial<Options<McpConsentDenyData>>
): UseMutationOptions<
  McpConsentDenyResponse,
  AxiosError<DefaultError>,
  Options<McpConsentDenyData>
> => {
  const mutationOptions: UseMutationOptions<
    McpConsentDenyResponse,
    AxiosError<DefaultError>,
    Options<McpConsentDenyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpConsentDeny({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Allauth-backed password reset request endpoint.
 */
export const authorizationV2PasswordRequestCreateMutation = (
  options?: Partial<Options<AuthorizationV2PasswordRequestCreateData>>
): UseMutationOptions<
  AuthorizationV2PasswordRequestCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2PasswordRequestCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2PasswordRequestCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2PasswordRequestCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2PasswordRequestCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Allauth-backed password reset confirmation endpoint.
 */
export const authorizationV2PasswordResetCreateMutation = (
  options?: Partial<Options<AuthorizationV2PasswordResetCreateData>>
): UseMutationOptions<
  AuthorizationV2PasswordResetCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2PasswordResetCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2PasswordResetCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2PasswordResetCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2PasswordResetCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const authorizationV2SchemaRetrieveQueryKey = (
  options?: Options<AuthorizationV2SchemaRetrieveData>
) => createQueryKey('authorizationV2SchemaRetrieve', options)

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const authorizationV2SchemaRetrieveOptions = (
  options?: Options<AuthorizationV2SchemaRetrieveData>
) =>
  queryOptions<
    AuthorizationV2SchemaRetrieveResponse,
    AxiosError<DefaultError>,
    AuthorizationV2SchemaRetrieveResponse,
    ReturnType<typeof authorizationV2SchemaRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await authorizationV2SchemaRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: authorizationV2SchemaRetrieveQueryKey(options)
  })

/**
 * Two-step simple registration. Confirm.
 */
export const authorizationV2SignupConfirmCreateMutation = (
  options?: Partial<Options<AuthorizationV2SignupConfirmCreateData>>
): UseMutationOptions<
  AuthorizationV2SignupConfirmCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2SignupConfirmCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2SignupConfirmCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2SignupConfirmCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2SignupConfirmCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Two-step simple registration. Start.
 */
export const authorizationV2SignupStartCreateMutation = (
  options?: Partial<Options<AuthorizationV2SignupStartCreateData>>
): UseMutationOptions<
  AuthorizationV2SignupStartCreateResponse,
  AxiosError<DefaultError>,
  Options<AuthorizationV2SignupStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AuthorizationV2SignupStartCreateResponse,
    AxiosError<DefaultError>,
    Options<AuthorizationV2SignupStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await authorizationV2SignupStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const commonCountriesListQueryKey = (
  options?: Options<CommonCountriesListData>
) => createQueryKey('commonCountriesList', options)

export const commonCountriesListOptions = (
  options?: Options<CommonCountriesListData>
) =>
  queryOptions<
    CommonCountriesListResponse,
    AxiosError<DefaultError>,
    CommonCountriesListResponse,
    ReturnType<typeof commonCountriesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commonCountriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: commonCountriesListQueryKey(options)
  })

export const commonCountriesListInfiniteQueryKey = (
  options?: Options<CommonCountriesListData>
): QueryKey<Options<CommonCountriesListData>> =>
  createQueryKey('commonCountriesList', options, true)

export const commonCountriesListInfiniteOptions = (
  options?: Options<CommonCountriesListData>
) => {
  const opts = infiniteQueryOptions<
    CommonCountriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CommonCountriesListResponse>,
    QueryKey<Options<CommonCountriesListData>>,
    | number
    | Pick<
        QueryKey<Options<CommonCountriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CommonCountriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await commonCountriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: commonCountriesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const commonCountriesRetrieveQueryKey = (
  options: Options<CommonCountriesRetrieveData>
) => createQueryKey('commonCountriesRetrieve', options)

export const commonCountriesRetrieveOptions = (
  options: Options<CommonCountriesRetrieveData>
) =>
  queryOptions<
    CommonCountriesRetrieveResponse,
    AxiosError<DefaultError>,
    CommonCountriesRetrieveResponse,
    ReturnType<typeof commonCountriesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commonCountriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: commonCountriesRetrieveQueryKey(options)
  })

export const commonHealthRetrieveQueryKey = (
  options?: Options<CommonHealthRetrieveData>
) => createQueryKey('commonHealthRetrieve', options)

export const commonHealthRetrieveOptions = (
  options?: Options<CommonHealthRetrieveData>
) =>
  queryOptions<
    CommonHealthRetrieveResponse,
    AxiosError<DefaultError>,
    CommonHealthRetrieveResponse,
    ReturnType<typeof commonHealthRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commonHealthRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: commonHealthRetrieveQueryKey(options)
  })

export const commonIndustriesListQueryKey = (
  options?: Options<CommonIndustriesListData>
) => createQueryKey('commonIndustriesList', options)

export const commonIndustriesListOptions = (
  options?: Options<CommonIndustriesListData>
) =>
  queryOptions<
    CommonIndustriesListResponse,
    AxiosError<DefaultError>,
    CommonIndustriesListResponse,
    ReturnType<typeof commonIndustriesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commonIndustriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: commonIndustriesListQueryKey(options)
  })

export const commonIndustriesListInfiniteQueryKey = (
  options?: Options<CommonIndustriesListData>
): QueryKey<Options<CommonIndustriesListData>> =>
  createQueryKey('commonIndustriesList', options, true)

export const commonIndustriesListInfiniteOptions = (
  options?: Options<CommonIndustriesListData>
) => {
  const opts = infiniteQueryOptions<
    CommonIndustriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CommonIndustriesListResponse>,
    QueryKey<Options<CommonIndustriesListData>>,
    | number
    | Pick<
        QueryKey<Options<CommonIndustriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CommonIndustriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await commonIndustriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: commonIndustriesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const commonIndustriesRetrieveQueryKey = (
  options: Options<CommonIndustriesRetrieveData>
) => createQueryKey('commonIndustriesRetrieve', options)

export const commonIndustriesRetrieveOptions = (
  options: Options<CommonIndustriesRetrieveData>
) =>
  queryOptions<
    CommonIndustriesRetrieveResponse,
    AxiosError<DefaultError>,
    CommonIndustriesRetrieveResponse,
    ReturnType<typeof commonIndustriesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commonIndustriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: commonIndustriesRetrieveQueryKey(options)
  })

export const commonProtectedRetrieveQueryKey = (
  options?: Options<CommonProtectedRetrieveData>
) => createQueryKey('commonProtectedRetrieve', options)

export const commonProtectedRetrieveOptions = (
  options?: Options<CommonProtectedRetrieveData>
) =>
  queryOptions<
    CommonProtectedRetrieveResponse,
    AxiosError<DefaultError>,
    CommonProtectedRetrieveResponse,
    ReturnType<typeof commonProtectedRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await commonProtectedRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: commonProtectedRetrieveQueryKey(options)
  })

export const integrationApplicationPublishCreateMutation = (
  options?: Partial<Options<IntegrationApplicationPublishCreateData>>
): UseMutationOptions<
  IntegrationApplicationPublishCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationApplicationPublishCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationApplicationPublishCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationApplicationPublishCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationApplicationPublishCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationApplicationsListQueryKey = (
  options?: Options<IntegrationApplicationsListData>
) => createQueryKey('integrationApplicationsList', options)

export const integrationApplicationsListOptions = (
  options?: Options<IntegrationApplicationsListData>
) =>
  queryOptions<
    IntegrationApplicationsListResponse,
    AxiosError<DefaultError>,
    IntegrationApplicationsListResponse,
    ReturnType<typeof integrationApplicationsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationApplicationsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationApplicationsListQueryKey(options)
  })

export const integrationApplicationsListInfiniteQueryKey = (
  options?: Options<IntegrationApplicationsListData>
): QueryKey<Options<IntegrationApplicationsListData>> =>
  createQueryKey('integrationApplicationsList', options, true)

export const integrationApplicationsListInfiniteOptions = (
  options?: Options<IntegrationApplicationsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationApplicationsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationApplicationsListResponse>,
    QueryKey<Options<IntegrationApplicationsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationApplicationsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationApplicationsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationApplicationsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationApplicationsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationApplicationsRetrieveQueryKey = (
  options: Options<IntegrationApplicationsRetrieveData>
) => createQueryKey('integrationApplicationsRetrieve', options)

export const integrationApplicationsRetrieveOptions = (
  options: Options<IntegrationApplicationsRetrieveData>
) =>
  queryOptions<
    IntegrationApplicationsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationApplicationsRetrieveResponse,
    ReturnType<typeof integrationApplicationsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationApplicationsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationApplicationsRetrieveQueryKey(options)
  })

export const integrationApplicationsDataRetrieveQueryKey = (
  options?: Options<IntegrationApplicationsDataRetrieveData>
) => createQueryKey('integrationApplicationsDataRetrieve', options)

/**
 * Get application data by Saas-App-Token
 */
export const integrationApplicationsDataRetrieveOptions = (
  options?: Options<IntegrationApplicationsDataRetrieveData>
) =>
  queryOptions<
    IntegrationApplicationsDataRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationApplicationsDataRetrieveResponse,
    ReturnType<typeof integrationApplicationsDataRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationApplicationsDataRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationApplicationsDataRetrieveQueryKey(options)
  })

/**
 * Set Notification categories from apps
 */
export const integrationApplicationsNotificationsCreateMutation = (
  options?: Partial<Options<IntegrationApplicationsNotificationsCreateData>>
): UseMutationOptions<
  IntegrationApplicationsNotificationsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationApplicationsNotificationsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationApplicationsNotificationsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationApplicationsNotificationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationApplicationsNotificationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Set Team role permissions from apps
 *
 * @deprecated
 */
export const integrationApplicationsRolePermissionsCreateMutation = (
  options?: Partial<Options<IntegrationApplicationsRolePermissionsCreateData>>
): UseMutationOptions<
  IntegrationApplicationsRolePermissionsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationApplicationsRolePermissionsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationApplicationsRolePermissionsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationApplicationsRolePermissionsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationApplicationsRolePermissionsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationApplicationsRolesCreateMutation = (
  options?: Partial<Options<IntegrationApplicationsRolesCreateData>>
): UseMutationOptions<
  IntegrationApplicationsRolesCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationApplicationsRolesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationApplicationsRolesCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationApplicationsRolesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationApplicationsRolesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationFeedRetrieveQueryKey = (
  options?: Options<IntegrationFeedRetrieveData>
) => createQueryKey('integrationFeedRetrieve', options)

/**
 * Legacy compatibility endpoint. It keeps the old integration audit-feed response shape, but the data is now read from the shared Mongo-backed audit log. Consumers should migrate to the primary organization audit logs endpoint at `/organizations/{organization_id}/audit-logs/` and this endpoint should be removed after confirming that no integration clients still depend on it.
 *
 * @deprecated
 */
export const integrationFeedRetrieveOptions = (
  options?: Options<IntegrationFeedRetrieveData>
) =>
  queryOptions<
    IntegrationFeedRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationFeedRetrieveResponse,
    ReturnType<typeof integrationFeedRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationFeedRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationFeedRetrieveQueryKey(options)
  })

export const integrationGoogleMailCallbackRetrieveQueryKey = (
  options?: Options<IntegrationGoogleMailCallbackRetrieveData>
) => createQueryKey('integrationGoogleMailCallbackRetrieve', options)

export const integrationGoogleMailCallbackRetrieveOptions = (
  options?: Options<IntegrationGoogleMailCallbackRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof integrationGoogleMailCallbackRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationGoogleMailCallbackRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationGoogleMailCallbackRetrieveQueryKey(options)
  })

export const integrationGoogleMailConnectStartCreateMutation = (
  options?: Partial<Options<IntegrationGoogleMailConnectStartCreateData>>
): UseMutationOptions<
  IntegrationGoogleMailConnectStartCreateResponse,
  AxiosError<IntegrationGoogleMailConnectStartCreateError>,
  Options<IntegrationGoogleMailConnectStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationGoogleMailConnectStartCreateResponse,
    AxiosError<IntegrationGoogleMailConnectStartCreateError>,
    Options<IntegrationGoogleMailConnectStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationGoogleMailConnectStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationGoogleMailConnectionsRetrieveQueryKey = (
  options: Options<IntegrationGoogleMailConnectionsRetrieveData>
) => createQueryKey('integrationGoogleMailConnectionsRetrieve', options)

/**
 * The caller's connected Gmail mailboxes in one workspace, and whether Gmail is available at all.
 */
export const integrationGoogleMailConnectionsRetrieveOptions = (
  options: Options<IntegrationGoogleMailConnectionsRetrieveData>
) =>
  queryOptions<
    IntegrationGoogleMailConnectionsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationGoogleMailConnectionsRetrieveResponse,
    ReturnType<typeof integrationGoogleMailConnectionsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationGoogleMailConnectionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationGoogleMailConnectionsRetrieveQueryKey(options)
  })

/**
 * Disconnect one Gmail mailbox, leaving the user's other mailboxes alone.
 */
export const integrationGoogleMailConnectionsDisconnectCreateMutation = (
  options?: Partial<
    Options<IntegrationGoogleMailConnectionsDisconnectCreateData>
  >
): UseMutationOptions<
  IntegrationGoogleMailConnectionsDisconnectCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationGoogleMailConnectionsDisconnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationGoogleMailConnectionsDisconnectCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationGoogleMailConnectionsDisconnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationGoogleMailConnectionsDisconnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationMicrosoftGraphAvailabilityRetrieveQueryKey = (
  options: Options<IntegrationMicrosoftGraphAvailabilityRetrieveData>
) => createQueryKey('integrationMicrosoftGraphAvailabilityRetrieve', options)

/**
 * Which Entra apps can connect an Outlook mailbox here, so the UI offers only what works.
 */
export const integrationMicrosoftGraphAvailabilityRetrieveOptions = (
  options: Options<IntegrationMicrosoftGraphAvailabilityRetrieveData>
) =>
  queryOptions<
    IntegrationMicrosoftGraphAvailabilityRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationMicrosoftGraphAvailabilityRetrieveResponse,
    ReturnType<typeof integrationMicrosoftGraphAvailabilityRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationMicrosoftGraphAvailabilityRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationMicrosoftGraphAvailabilityRetrieveQueryKey(options)
  })

export const integrationMicrosoftGraphCallbackRetrieveQueryKey = (
  options?: Options<IntegrationMicrosoftGraphCallbackRetrieveData>
) => createQueryKey('integrationMicrosoftGraphCallbackRetrieve', options)

export const integrationMicrosoftGraphCallbackRetrieveOptions = (
  options?: Options<IntegrationMicrosoftGraphCallbackRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof integrationMicrosoftGraphCallbackRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationMicrosoftGraphCallbackRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationMicrosoftGraphCallbackRetrieveQueryKey(options)
  })

export const integrationMicrosoftGraphConnectStartCreateMutation = (
  options?: Partial<Options<IntegrationMicrosoftGraphConnectStartCreateData>>
): UseMutationOptions<
  IntegrationMicrosoftGraphConnectStartCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationMicrosoftGraphConnectStartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationMicrosoftGraphConnectStartCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationMicrosoftGraphConnectStartCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationMicrosoftGraphConnectStartCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationMicrosoftGraphConnectionsListQueryKey = (
  options: Options<IntegrationMicrosoftGraphConnectionsListData>
) => createQueryKey('integrationMicrosoftGraphConnectionsList', options)

/**
 * The caller's connected mailboxes, for the settings screen.
 */
export const integrationMicrosoftGraphConnectionsListOptions = (
  options: Options<IntegrationMicrosoftGraphConnectionsListData>
) =>
  queryOptions<
    IntegrationMicrosoftGraphConnectionsListResponse,
    AxiosError<DefaultError>,
    IntegrationMicrosoftGraphConnectionsListResponse,
    ReturnType<typeof integrationMicrosoftGraphConnectionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationMicrosoftGraphConnectionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationMicrosoftGraphConnectionsListQueryKey(options)
  })

/**
 * Disconnect one mailbox, leaving the user's other mailboxes alone.
 */
export const integrationMicrosoftGraphConnectionsDisconnectCreateMutation = (
  options?: Partial<
    Options<IntegrationMicrosoftGraphConnectionsDisconnectCreateData>
  >
): UseMutationOptions<
  IntegrationMicrosoftGraphConnectionsDisconnectCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationMicrosoftGraphConnectionsDisconnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationMicrosoftGraphConnectionsDisconnectCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationMicrosoftGraphConnectionsDisconnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await integrationMicrosoftGraphConnectionsDisconnectCreate({
          ...options,
          ...fnOptions,
          throwOnError: true
        })
      return data
    }
  }
  return mutationOptions
}

/**
 * Disconnects every mailbox of the caller at once. Use POST /integration/microsoft/graph/connections/{connection_id}/disconnect/.
 *
 * @deprecated
 */
export const integrationMicrosoftGraphDisconnectCreateMutation = (
  options?: Partial<Options<IntegrationMicrosoftGraphDisconnectCreateData>>
): UseMutationOptions<
  IntegrationMicrosoftGraphDisconnectCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationMicrosoftGraphDisconnectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationMicrosoftGraphDisconnectCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationMicrosoftGraphDisconnectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationMicrosoftGraphDisconnectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationMicrosoftGraphStatusRetrieveQueryKey = (
  options: Options<IntegrationMicrosoftGraphStatusRetrieveData>
) => createQueryKey('integrationMicrosoftGraphStatusRetrieve', options)

/**
 * Reports a single connection, so it cannot describe a user with several mailboxes. Use GET /integration/microsoft/graph/connections/.
 *
 * @deprecated
 */
export const integrationMicrosoftGraphStatusRetrieveOptions = (
  options: Options<IntegrationMicrosoftGraphStatusRetrieveData>
) =>
  queryOptions<
    IntegrationMicrosoftGraphStatusRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationMicrosoftGraphStatusRetrieveResponse,
    ReturnType<typeof integrationMicrosoftGraphStatusRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationMicrosoftGraphStatusRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationMicrosoftGraphStatusRetrieveQueryKey(options)
  })

/**
 * Apply a single permission migration (rename/merge) for the scoped repository.
 *
 * Auth: same ``Saas-Secret-Token`` flow as :class:`ApplicationPermissionSyncView` —
 * the ``ApplicationRepository`` is resolved from the token, not the payload, so the
 * caller never picks the scope. Idempotency is enforced via
 * ``unique(application_repository, name)`` on ``IntegrationPermissionMigration``:
 * a previously-applied migration returns ``applied=true, skipped=true`` without
 * touching permissions.
 */
export const integrationPermissionMigrationsApplyCreateMutation = (
  options?: Partial<Options<IntegrationPermissionMigrationsApplyCreateData>>
): UseMutationOptions<
  IntegrationPermissionMigrationsApplyCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationPermissionMigrationsApplyCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationPermissionMigrationsApplyCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationPermissionMigrationsApplyCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationPermissionMigrationsApplyCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationRpcPresetsListQueryKey = (
  options?: Options<IntegrationRpcPresetsListData>
) => createQueryKey('integrationRpcPresetsList', options)

export const integrationRpcPresetsListOptions = (
  options?: Options<IntegrationRpcPresetsListData>
) =>
  queryOptions<
    IntegrationRpcPresetsListResponse,
    AxiosError<DefaultError>,
    IntegrationRpcPresetsListResponse,
    ReturnType<typeof integrationRpcPresetsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationRpcPresetsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationRpcPresetsListQueryKey(options)
  })

export const integrationRpcPresetsListInfiniteQueryKey = (
  options?: Options<IntegrationRpcPresetsListData>
): QueryKey<Options<IntegrationRpcPresetsListData>> =>
  createQueryKey('integrationRpcPresetsList', options, true)

export const integrationRpcPresetsListInfiniteOptions = (
  options?: Options<IntegrationRpcPresetsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationRpcPresetsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationRpcPresetsListResponse>,
    QueryKey<Options<IntegrationRpcPresetsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationRpcPresetsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationRpcPresetsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationRpcPresetsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationRpcPresetsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationRpcPresetsRetrieveQueryKey = (
  options: Options<IntegrationRpcPresetsRetrieveData>
) => createQueryKey('integrationRpcPresetsRetrieve', options)

export const integrationRpcPresetsRetrieveOptions = (
  options: Options<IntegrationRpcPresetsRetrieveData>
) =>
  queryOptions<
    IntegrationRpcPresetsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationRpcPresetsRetrieveResponse,
    ReturnType<typeof integrationRpcPresetsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationRpcPresetsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationRpcPresetsRetrieveQueryKey(options)
  })

export const integrationSetupJobsListQueryKey = (
  options?: Options<IntegrationSetupJobsListData>
) => createQueryKey('integrationSetupJobsList', options)

export const integrationSetupJobsListOptions = (
  options?: Options<IntegrationSetupJobsListData>
) =>
  queryOptions<
    IntegrationSetupJobsListResponse,
    AxiosError<DefaultError>,
    IntegrationSetupJobsListResponse,
    ReturnType<typeof integrationSetupJobsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationSetupJobsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationSetupJobsListQueryKey(options)
  })

export const integrationSetupJobsListInfiniteQueryKey = (
  options?: Options<IntegrationSetupJobsListData>
): QueryKey<Options<IntegrationSetupJobsListData>> =>
  createQueryKey('integrationSetupJobsList', options, true)

export const integrationSetupJobsListInfiniteOptions = (
  options?: Options<IntegrationSetupJobsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationSetupJobsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationSetupJobsListResponse>,
    QueryKey<Options<IntegrationSetupJobsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationSetupJobsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationSetupJobsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationSetupJobsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationSetupJobsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationSetupJobsDestroyMutation = (
  options?: Partial<Options<IntegrationSetupJobsDestroyData>>
): UseMutationOptions<
  IntegrationSetupJobsDestroyResponse,
  AxiosError<DefaultError>,
  Options<IntegrationSetupJobsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationSetupJobsDestroyResponse,
    AxiosError<DefaultError>,
    Options<IntegrationSetupJobsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationSetupJobsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationSetupJobsRetrieveQueryKey = (
  options: Options<IntegrationSetupJobsRetrieveData>
) => createQueryKey('integrationSetupJobsRetrieve', options)

export const integrationSetupJobsRetrieveOptions = (
  options: Options<IntegrationSetupJobsRetrieveData>
) =>
  queryOptions<
    IntegrationSetupJobsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationSetupJobsRetrieveResponse,
    ReturnType<typeof integrationSetupJobsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationSetupJobsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationSetupJobsRetrieveQueryKey(options)
  })

export const integrationSetupJobsRetryCreateMutation = (
  options?: Partial<Options<IntegrationSetupJobsRetryCreateData>>
): UseMutationOptions<
  IntegrationSetupJobsRetryCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationSetupJobsRetryCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationSetupJobsRetryCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationSetupJobsRetryCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationSetupJobsRetryCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Sync permissions from the applications.
 */
export const integrationSyncPermissionsCreateMutation = (
  options?: Partial<Options<IntegrationSyncPermissionsCreateData>>
): UseMutationOptions<
  IntegrationSyncPermissionsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationSyncPermissionsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationSyncPermissionsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationSyncPermissionsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationSyncPermissionsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Sync rpc methods from the applications.
 */
export const integrationSyncRpcMethodsCreateMutation = (
  options?: Partial<Options<IntegrationSyncRpcMethodsCreateData>>
): UseMutationOptions<
  IntegrationSyncRpcMethodsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationSyncRpcMethodsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationSyncRpcMethodsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationSyncRpcMethodsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationSyncRpcMethodsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Sync RPC method templates and pipeline steps from the applications.
 */
export const integrationSyncRpcTemplatesCreateMutation = (
  options?: Partial<Options<IntegrationSyncRpcTemplatesCreateData>>
): UseMutationOptions<
  IntegrationSyncRpcTemplatesCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationSyncRpcTemplatesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationSyncRpcTemplatesCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationSyncRpcTemplatesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationSyncRpcTemplatesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationTeamsListQueryKey = (
  options?: Options<IntegrationTeamsListData>
) => createQueryKey('integrationTeamsList', options)

/**
 * Team
 */
export const integrationTeamsListOptions = (
  options?: Options<IntegrationTeamsListData>
) =>
  queryOptions<
    IntegrationTeamsListResponse,
    AxiosError<DefaultError>,
    IntegrationTeamsListResponse,
    ReturnType<typeof integrationTeamsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationTeamsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationTeamsListQueryKey(options)
  })

export const integrationTeamsListInfiniteQueryKey = (
  options?: Options<IntegrationTeamsListData>
): QueryKey<Options<IntegrationTeamsListData>> =>
  createQueryKey('integrationTeamsList', options, true)

/**
 * Team
 */
export const integrationTeamsListInfiniteOptions = (
  options?: Options<IntegrationTeamsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationTeamsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationTeamsListResponse>,
    QueryKey<Options<IntegrationTeamsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationTeamsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationTeamsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationTeamsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationTeamsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationTeamsRetrieveQueryKey = (
  options: Options<IntegrationTeamsRetrieveData>
) => createQueryKey('integrationTeamsRetrieve', options)

/**
 * Team
 */
export const integrationTeamsRetrieveOptions = (
  options: Options<IntegrationTeamsRetrieveData>
) =>
  queryOptions<
    IntegrationTeamsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationTeamsRetrieveResponse,
    ReturnType<typeof integrationTeamsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationTeamsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationTeamsRetrieveQueryKey(options)
  })

export const integrationUserGroupsListQueryKey = (
  options?: Options<IntegrationUserGroupsListData>
) => createQueryKey('integrationUserGroupsList', options)

/**
 * UserGroup
 */
export const integrationUserGroupsListOptions = (
  options?: Options<IntegrationUserGroupsListData>
) =>
  queryOptions<
    IntegrationUserGroupsListResponse,
    AxiosError<DefaultError>,
    IntegrationUserGroupsListResponse,
    ReturnType<typeof integrationUserGroupsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationUserGroupsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationUserGroupsListQueryKey(options)
  })

export const integrationUserGroupsListInfiniteQueryKey = (
  options?: Options<IntegrationUserGroupsListData>
): QueryKey<Options<IntegrationUserGroupsListData>> =>
  createQueryKey('integrationUserGroupsList', options, true)

/**
 * UserGroup
 */
export const integrationUserGroupsListInfiniteOptions = (
  options?: Options<IntegrationUserGroupsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationUserGroupsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationUserGroupsListResponse>,
    QueryKey<Options<IntegrationUserGroupsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationUserGroupsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationUserGroupsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationUserGroupsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationUserGroupsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationUserGroupsRetrieveQueryKey = (
  options: Options<IntegrationUserGroupsRetrieveData>
) => createQueryKey('integrationUserGroupsRetrieve', options)

/**
 * UserGroup
 */
export const integrationUserGroupsRetrieveOptions = (
  options: Options<IntegrationUserGroupsRetrieveData>
) =>
  queryOptions<
    IntegrationUserGroupsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationUserGroupsRetrieveResponse,
    ReturnType<typeof integrationUserGroupsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationUserGroupsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationUserGroupsRetrieveQueryKey(options)
  })

export const integrationUserRetrieveQueryKey = (
  options: Options<IntegrationUserRetrieveData>
) => createQueryKey('integrationUserRetrieve', options)

/**
 * For Saas-secret-token
 */
export const integrationUserRetrieveOptions = (
  options: Options<IntegrationUserRetrieveData>
) =>
  queryOptions<
    IntegrationUserRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationUserRetrieveResponse,
    ReturnType<typeof integrationUserRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationUserRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationUserRetrieveQueryKey(options)
  })

export const integrationUsersListQueryKey = (
  options?: Options<IntegrationUsersListData>
) => createQueryKey('integrationUsersList', options)

/**
 * User
 */
export const integrationUsersListOptions = (
  options?: Options<IntegrationUsersListData>
) =>
  queryOptions<
    IntegrationUsersListResponse,
    AxiosError<DefaultError>,
    IntegrationUsersListResponse,
    ReturnType<typeof integrationUsersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationUsersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationUsersListQueryKey(options)
  })

export const integrationUsersListInfiniteQueryKey = (
  options?: Options<IntegrationUsersListData>
): QueryKey<Options<IntegrationUsersListData>> =>
  createQueryKey('integrationUsersList', options, true)

/**
 * User
 */
export const integrationUsersListInfiniteOptions = (
  options?: Options<IntegrationUsersListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationUsersListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationUsersListResponse>,
    QueryKey<Options<IntegrationUsersListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationUsersListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationUsersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationUsersList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationUsersListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * User
 */
export const integrationUsersCreateMutation = (
  options?: Partial<Options<IntegrationUsersCreateData>>
): UseMutationOptions<
  IntegrationUsersCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationUsersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationUsersCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationUsersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationUsersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationUsersRetrieveQueryKey = (
  options: Options<IntegrationUsersRetrieveData>
) => createQueryKey('integrationUsersRetrieve', options)

/**
 * User
 */
export const integrationUsersRetrieveOptions = (
  options: Options<IntegrationUsersRetrieveData>
) =>
  queryOptions<
    IntegrationUsersRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationUsersRetrieveResponse,
    ReturnType<typeof integrationUsersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationUsersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationUsersRetrieveQueryKey(options)
  })

/**
 * User
 */
export const integrationUsersPartialUpdateMutation = (
  options?: Partial<Options<IntegrationUsersPartialUpdateData>>
): UseMutationOptions<
  IntegrationUsersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationUsersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationUsersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationUsersPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationUsersPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Invite users into the organization of the application making the call.
 */
export const integrationUsersInviteCreateMutation = (
  options?: Partial<Options<IntegrationUsersInviteCreateData>>
): UseMutationOptions<
  IntegrationUsersInviteCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationUsersInviteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationUsersInviteCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationUsersInviteCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationUsersInviteCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2ApplicationPublishCreateMutation = (
  options?: Partial<Options<IntegrationV2ApplicationPublishCreateData>>
): UseMutationOptions<
  IntegrationV2ApplicationPublishCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2ApplicationPublishCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2ApplicationPublishCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2ApplicationPublishCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2ApplicationPublishCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2ApplicationsListQueryKey = (
  options?: Options<IntegrationV2ApplicationsListData>
) => createQueryKey('integrationV2ApplicationsList', options)

export const integrationV2ApplicationsListOptions = (
  options?: Options<IntegrationV2ApplicationsListData>
) =>
  queryOptions<
    IntegrationV2ApplicationsListResponse,
    AxiosError<DefaultError>,
    IntegrationV2ApplicationsListResponse,
    ReturnType<typeof integrationV2ApplicationsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2ApplicationsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2ApplicationsListQueryKey(options)
  })

export const integrationV2ApplicationsListInfiniteQueryKey = (
  options?: Options<IntegrationV2ApplicationsListData>
): QueryKey<Options<IntegrationV2ApplicationsListData>> =>
  createQueryKey('integrationV2ApplicationsList', options, true)

export const integrationV2ApplicationsListInfiniteOptions = (
  options?: Options<IntegrationV2ApplicationsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationV2ApplicationsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationV2ApplicationsListResponse>,
    QueryKey<Options<IntegrationV2ApplicationsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationV2ApplicationsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationV2ApplicationsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationV2ApplicationsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationV2ApplicationsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationV2ApplicationsRetrieveQueryKey = (
  options: Options<IntegrationV2ApplicationsRetrieveData>
) => createQueryKey('integrationV2ApplicationsRetrieve', options)

export const integrationV2ApplicationsRetrieveOptions = (
  options: Options<IntegrationV2ApplicationsRetrieveData>
) =>
  queryOptions<
    IntegrationV2ApplicationsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2ApplicationsRetrieveResponse,
    ReturnType<typeof integrationV2ApplicationsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2ApplicationsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2ApplicationsRetrieveQueryKey(options)
  })

export const integrationV2ApplicationsDataRetrieveQueryKey = (
  options?: Options<IntegrationV2ApplicationsDataRetrieveData>
) => createQueryKey('integrationV2ApplicationsDataRetrieve', options)

/**
 * Get application data by Saas-App-Token
 */
export const integrationV2ApplicationsDataRetrieveOptions = (
  options?: Options<IntegrationV2ApplicationsDataRetrieveData>
) =>
  queryOptions<
    IntegrationV2ApplicationsDataRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2ApplicationsDataRetrieveResponse,
    ReturnType<typeof integrationV2ApplicationsDataRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2ApplicationsDataRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2ApplicationsDataRetrieveQueryKey(options)
  })

/**
 * Set Notification categories from apps
 */
export const integrationV2ApplicationsNotificationsCreateMutation = (
  options?: Partial<Options<IntegrationV2ApplicationsNotificationsCreateData>>
): UseMutationOptions<
  IntegrationV2ApplicationsNotificationsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2ApplicationsNotificationsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2ApplicationsNotificationsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2ApplicationsNotificationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2ApplicationsNotificationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Set Team role permissions from apps
 *
 * @deprecated
 */
export const integrationV2ApplicationsRolePermissionsCreateMutation = (
  options?: Partial<Options<IntegrationV2ApplicationsRolePermissionsCreateData>>
): UseMutationOptions<
  IntegrationV2ApplicationsRolePermissionsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2ApplicationsRolePermissionsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2ApplicationsRolePermissionsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2ApplicationsRolePermissionsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2ApplicationsRolePermissionsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2ApplicationsRolesCreateMutation = (
  options?: Partial<Options<IntegrationV2ApplicationsRolesCreateData>>
): UseMutationOptions<
  IntegrationV2ApplicationsRolesCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2ApplicationsRolesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2ApplicationsRolesCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2ApplicationsRolesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2ApplicationsRolesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2AppsRolesListQueryKey = (
  options: Options<IntegrationV2AppsRolesListData>
) => createQueryKey('integrationV2AppsRolesList', options)

/**
 * Requires workspace permission: `applications.view`.
 */
export const integrationV2AppsRolesListOptions = (
  options: Options<IntegrationV2AppsRolesListData>
) =>
  queryOptions<
    IntegrationV2AppsRolesListResponse,
    AxiosError<DefaultError>,
    IntegrationV2AppsRolesListResponse,
    ReturnType<typeof integrationV2AppsRolesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2AppsRolesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2AppsRolesListQueryKey(options)
  })

export const integrationV2AppsRolesListInfiniteQueryKey = (
  options: Options<IntegrationV2AppsRolesListData>
): QueryKey<Options<IntegrationV2AppsRolesListData>> =>
  createQueryKey('integrationV2AppsRolesList', options, true)

/**
 * Requires workspace permission: `applications.view`.
 */
export const integrationV2AppsRolesListInfiniteOptions = (
  options: Options<IntegrationV2AppsRolesListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationV2AppsRolesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationV2AppsRolesListResponse>,
    QueryKey<Options<IntegrationV2AppsRolesListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationV2AppsRolesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationV2AppsRolesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationV2AppsRolesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationV2AppsRolesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const integrationV2AppsRolesCreateMutation = (
  options?: Partial<Options<IntegrationV2AppsRolesCreateData>>
): UseMutationOptions<
  IntegrationV2AppsRolesCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2AppsRolesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2AppsRolesCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2AppsRolesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2AppsRolesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const integrationV2AppsRolesDestroyMutation = (
  options?: Partial<Options<IntegrationV2AppsRolesDestroyData>>
): UseMutationOptions<
  IntegrationV2AppsRolesDestroyResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2AppsRolesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2AppsRolesDestroyResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2AppsRolesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2AppsRolesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2AppsRolesRetrieveQueryKey = (
  options: Options<IntegrationV2AppsRolesRetrieveData>
) => createQueryKey('integrationV2AppsRolesRetrieve', options)

/**
 * Requires workspace permission: `applications.view`.
 */
export const integrationV2AppsRolesRetrieveOptions = (
  options: Options<IntegrationV2AppsRolesRetrieveData>
) =>
  queryOptions<
    IntegrationV2AppsRolesRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2AppsRolesRetrieveResponse,
    ReturnType<typeof integrationV2AppsRolesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2AppsRolesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2AppsRolesRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const integrationV2AppsRolesPartialUpdateMutation = (
  options?: Partial<Options<IntegrationV2AppsRolesPartialUpdateData>>
): UseMutationOptions<
  IntegrationV2AppsRolesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2AppsRolesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2AppsRolesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2AppsRolesPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2AppsRolesPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2AppsRolesMembersRetrieveQueryKey = (
  options: Options<IntegrationV2AppsRolesMembersRetrieveData>
) => createQueryKey('integrationV2AppsRolesMembersRetrieve', options)

/**
 * Requires workspace permission: `applications.access`.
 */
export const integrationV2AppsRolesMembersRetrieveOptions = (
  options: Options<IntegrationV2AppsRolesMembersRetrieveData>
) =>
  queryOptions<
    IntegrationV2AppsRolesMembersRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2AppsRolesMembersRetrieveResponse,
    ReturnType<typeof integrationV2AppsRolesMembersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2AppsRolesMembersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2AppsRolesMembersRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.access`.
 */
export const integrationV2AppsRolesMembersUpdateMutation = (
  options?: Partial<Options<IntegrationV2AppsRolesMembersUpdateData>>
): UseMutationOptions<
  IntegrationV2AppsRolesMembersUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2AppsRolesMembersUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2AppsRolesMembersUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2AppsRolesMembersUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2AppsRolesMembersUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2FeedRetrieveQueryKey = (
  options?: Options<IntegrationV2FeedRetrieveData>
) => createQueryKey('integrationV2FeedRetrieve', options)

/**
 * Legacy compatibility endpoint. It keeps the old integration audit-feed response shape, but the data is now read from the shared Mongo-backed audit log. Consumers should migrate to the primary organization audit logs endpoint at `/organizations/{organization_id}/audit-logs/` and this endpoint should be removed after confirming that no integration clients still depend on it.
 *
 * @deprecated
 */
export const integrationV2FeedRetrieveOptions = (
  options?: Options<IntegrationV2FeedRetrieveData>
) =>
  queryOptions<
    IntegrationV2FeedRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2FeedRetrieveResponse,
    ReturnType<typeof integrationV2FeedRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2FeedRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2FeedRetrieveQueryKey(options)
  })

export const integrationV2RpcPresetsListQueryKey = (
  options?: Options<IntegrationV2RpcPresetsListData>
) => createQueryKey('integrationV2RpcPresetsList', options)

export const integrationV2RpcPresetsListOptions = (
  options?: Options<IntegrationV2RpcPresetsListData>
) =>
  queryOptions<
    IntegrationV2RpcPresetsListResponse,
    AxiosError<DefaultError>,
    IntegrationV2RpcPresetsListResponse,
    ReturnType<typeof integrationV2RpcPresetsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2RpcPresetsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2RpcPresetsListQueryKey(options)
  })

export const integrationV2RpcPresetsListInfiniteQueryKey = (
  options?: Options<IntegrationV2RpcPresetsListData>
): QueryKey<Options<IntegrationV2RpcPresetsListData>> =>
  createQueryKey('integrationV2RpcPresetsList', options, true)

export const integrationV2RpcPresetsListInfiniteOptions = (
  options?: Options<IntegrationV2RpcPresetsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationV2RpcPresetsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationV2RpcPresetsListResponse>,
    QueryKey<Options<IntegrationV2RpcPresetsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationV2RpcPresetsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationV2RpcPresetsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationV2RpcPresetsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationV2RpcPresetsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationV2RpcPresetsRetrieveQueryKey = (
  options: Options<IntegrationV2RpcPresetsRetrieveData>
) => createQueryKey('integrationV2RpcPresetsRetrieve', options)

export const integrationV2RpcPresetsRetrieveOptions = (
  options: Options<IntegrationV2RpcPresetsRetrieveData>
) =>
  queryOptions<
    IntegrationV2RpcPresetsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2RpcPresetsRetrieveResponse,
    ReturnType<typeof integrationV2RpcPresetsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2RpcPresetsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2RpcPresetsRetrieveQueryKey(options)
  })

export const integrationV2SetupJobsListQueryKey = (
  options?: Options<IntegrationV2SetupJobsListData>
) => createQueryKey('integrationV2SetupJobsList', options)

export const integrationV2SetupJobsListOptions = (
  options?: Options<IntegrationV2SetupJobsListData>
) =>
  queryOptions<
    IntegrationV2SetupJobsListResponse,
    AxiosError<DefaultError>,
    IntegrationV2SetupJobsListResponse,
    ReturnType<typeof integrationV2SetupJobsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2SetupJobsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2SetupJobsListQueryKey(options)
  })

export const integrationV2SetupJobsListInfiniteQueryKey = (
  options?: Options<IntegrationV2SetupJobsListData>
): QueryKey<Options<IntegrationV2SetupJobsListData>> =>
  createQueryKey('integrationV2SetupJobsList', options, true)

export const integrationV2SetupJobsListInfiniteOptions = (
  options?: Options<IntegrationV2SetupJobsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationV2SetupJobsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationV2SetupJobsListResponse>,
    QueryKey<Options<IntegrationV2SetupJobsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationV2SetupJobsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationV2SetupJobsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationV2SetupJobsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationV2SetupJobsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationV2SetupJobsDestroyMutation = (
  options?: Partial<Options<IntegrationV2SetupJobsDestroyData>>
): UseMutationOptions<
  IntegrationV2SetupJobsDestroyResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2SetupJobsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2SetupJobsDestroyResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2SetupJobsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2SetupJobsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2SetupJobsRetrieveQueryKey = (
  options: Options<IntegrationV2SetupJobsRetrieveData>
) => createQueryKey('integrationV2SetupJobsRetrieve', options)

export const integrationV2SetupJobsRetrieveOptions = (
  options: Options<IntegrationV2SetupJobsRetrieveData>
) =>
  queryOptions<
    IntegrationV2SetupJobsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2SetupJobsRetrieveResponse,
    ReturnType<typeof integrationV2SetupJobsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2SetupJobsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2SetupJobsRetrieveQueryKey(options)
  })

export const integrationV2SetupJobsRetryCreateMutation = (
  options?: Partial<Options<IntegrationV2SetupJobsRetryCreateData>>
): UseMutationOptions<
  IntegrationV2SetupJobsRetryCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2SetupJobsRetryCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2SetupJobsRetryCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2SetupJobsRetryCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2SetupJobsRetryCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Sync permissions from the applications.
 */
export const integrationV2SyncPermissionsCreateMutation = (
  options?: Partial<Options<IntegrationV2SyncPermissionsCreateData>>
): UseMutationOptions<
  IntegrationV2SyncPermissionsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2SyncPermissionsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2SyncPermissionsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2SyncPermissionsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2SyncPermissionsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Sync rpc methods from the applications.
 */
export const integrationV2SyncRpcMethodsCreateMutation = (
  options?: Partial<Options<IntegrationV2SyncRpcMethodsCreateData>>
): UseMutationOptions<
  IntegrationV2SyncRpcMethodsCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2SyncRpcMethodsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2SyncRpcMethodsCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2SyncRpcMethodsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2SyncRpcMethodsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2TeamsListQueryKey = (
  options?: Options<IntegrationV2TeamsListData>
) => createQueryKey('integrationV2TeamsList', options)

/**
 * Team
 */
export const integrationV2TeamsListOptions = (
  options?: Options<IntegrationV2TeamsListData>
) =>
  queryOptions<
    IntegrationV2TeamsListResponse,
    AxiosError<DefaultError>,
    IntegrationV2TeamsListResponse,
    ReturnType<typeof integrationV2TeamsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2TeamsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2TeamsListQueryKey(options)
  })

export const integrationV2TeamsListInfiniteQueryKey = (
  options?: Options<IntegrationV2TeamsListData>
): QueryKey<Options<IntegrationV2TeamsListData>> =>
  createQueryKey('integrationV2TeamsList', options, true)

/**
 * Team
 */
export const integrationV2TeamsListInfiniteOptions = (
  options?: Options<IntegrationV2TeamsListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationV2TeamsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationV2TeamsListResponse>,
    QueryKey<Options<IntegrationV2TeamsListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationV2TeamsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationV2TeamsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationV2TeamsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationV2TeamsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const integrationV2TeamsRetrieveQueryKey = (
  options: Options<IntegrationV2TeamsRetrieveData>
) => createQueryKey('integrationV2TeamsRetrieve', options)

/**
 * Team
 */
export const integrationV2TeamsRetrieveOptions = (
  options: Options<IntegrationV2TeamsRetrieveData>
) =>
  queryOptions<
    IntegrationV2TeamsRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2TeamsRetrieveResponse,
    ReturnType<typeof integrationV2TeamsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2TeamsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2TeamsRetrieveQueryKey(options)
  })

export const integrationV2UserRetrieveQueryKey = (
  options: Options<IntegrationV2UserRetrieveData>
) => createQueryKey('integrationV2UserRetrieve', options)

/**
 * For Saas-secret-token
 */
export const integrationV2UserRetrieveOptions = (
  options: Options<IntegrationV2UserRetrieveData>
) =>
  queryOptions<
    IntegrationV2UserRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2UserRetrieveResponse,
    ReturnType<typeof integrationV2UserRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2UserRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2UserRetrieveQueryKey(options)
  })

export const integrationV2UsersListQueryKey = (
  options?: Options<IntegrationV2UsersListData>
) => createQueryKey('integrationV2UsersList', options)

/**
 * User
 */
export const integrationV2UsersListOptions = (
  options?: Options<IntegrationV2UsersListData>
) =>
  queryOptions<
    IntegrationV2UsersListResponse,
    AxiosError<DefaultError>,
    IntegrationV2UsersListResponse,
    ReturnType<typeof integrationV2UsersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2UsersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2UsersListQueryKey(options)
  })

export const integrationV2UsersListInfiniteQueryKey = (
  options?: Options<IntegrationV2UsersListData>
): QueryKey<Options<IntegrationV2UsersListData>> =>
  createQueryKey('integrationV2UsersList', options, true)

/**
 * User
 */
export const integrationV2UsersListInfiniteOptions = (
  options?: Options<IntegrationV2UsersListData>
) => {
  const opts = infiniteQueryOptions<
    IntegrationV2UsersListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationV2UsersListResponse>,
    QueryKey<Options<IntegrationV2UsersListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationV2UsersListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationV2UsersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationV2UsersList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: integrationV2UsersListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * User
 */
export const integrationV2UsersCreateMutation = (
  options?: Partial<Options<IntegrationV2UsersCreateData>>
): UseMutationOptions<
  IntegrationV2UsersCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2UsersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2UsersCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2UsersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2UsersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const integrationV2UsersRetrieveQueryKey = (
  options: Options<IntegrationV2UsersRetrieveData>
) => createQueryKey('integrationV2UsersRetrieve', options)

/**
 * User
 */
export const integrationV2UsersRetrieveOptions = (
  options: Options<IntegrationV2UsersRetrieveData>
) =>
  queryOptions<
    IntegrationV2UsersRetrieveResponse,
    AxiosError<DefaultError>,
    IntegrationV2UsersRetrieveResponse,
    ReturnType<typeof integrationV2UsersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationV2UsersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: integrationV2UsersRetrieveQueryKey(options)
  })

/**
 * User
 */
export const integrationV2UsersPartialUpdateMutation = (
  options?: Partial<Options<IntegrationV2UsersPartialUpdateData>>
): UseMutationOptions<
  IntegrationV2UsersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2UsersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2UsersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2UsersPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2UsersPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Invite users into the organization of the application making the call.
 */
export const integrationV2UsersInviteCreateMutation = (
  options?: Partial<Options<IntegrationV2UsersInviteCreateData>>
): UseMutationOptions<
  IntegrationV2UsersInviteCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationV2UsersInviteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationV2UsersInviteCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationV2UsersInviteCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await integrationV2UsersInviteCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const internalGoogleMailTokenCreateMutation = (
  options?: Partial<Options<InternalGoogleMailTokenCreateData>>
): UseMutationOptions<
  InternalGoogleMailTokenCreateResponse,
  AxiosError<InternalGoogleMailTokenCreateError>,
  Options<InternalGoogleMailTokenCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalGoogleMailTokenCreateResponse,
    AxiosError<InternalGoogleMailTokenCreateError>,
    Options<InternalGoogleMailTokenCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalGoogleMailTokenCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const internalMcpConnectionRetrieveQueryKey = (
  options: Options<InternalMcpConnectionRetrieveData>
) => createQueryKey('internalMcpConnectionRetrieve', options)

export const internalMcpConnectionRetrieveOptions = (
  options: Options<InternalMcpConnectionRetrieveData>
) =>
  queryOptions<
    InternalMcpConnectionRetrieveResponse,
    AxiosError<DefaultError>,
    InternalMcpConnectionRetrieveResponse,
    ReturnType<typeof internalMcpConnectionRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalMcpConnectionRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: internalMcpConnectionRetrieveQueryKey(options)
  })

export const internalMicrosoftGraphTokenCreateMutation = (
  options?: Partial<Options<InternalMicrosoftGraphTokenCreateData>>
): UseMutationOptions<
  InternalMicrosoftGraphTokenCreateResponse,
  AxiosError<InternalMicrosoftGraphTokenCreateError>,
  Options<InternalMicrosoftGraphTokenCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalMicrosoftGraphTokenCreateResponse,
    AxiosError<InternalMicrosoftGraphTokenCreateError>,
    Options<InternalMicrosoftGraphTokenCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalMicrosoftGraphTokenCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const internalPublicAccessCredentialsSnapshotRetrieveQueryKey = (
  options: Options<InternalPublicAccessCredentialsSnapshotRetrieveData>
) => createQueryKey('internalPublicAccessCredentialsSnapshotRetrieve', options)

export const internalPublicAccessCredentialsSnapshotRetrieveOptions = (
  options: Options<InternalPublicAccessCredentialsSnapshotRetrieveData>
) =>
  queryOptions<
    InternalPublicAccessCredentialsSnapshotRetrieveResponse,
    AxiosError<DefaultError>,
    InternalPublicAccessCredentialsSnapshotRetrieveResponse,
    ReturnType<typeof internalPublicAccessCredentialsSnapshotRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalPublicAccessCredentialsSnapshotRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: internalPublicAccessCredentialsSnapshotRetrieveQueryKey(options)
  })

export const internalPublicAccessCredentialsUsageCreateMutation = (
  options?: Partial<Options<InternalPublicAccessCredentialsUsageCreateData>>
): UseMutationOptions<
  InternalPublicAccessCredentialsUsageCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalPublicAccessCredentialsUsageCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalPublicAccessCredentialsUsageCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalPublicAccessCredentialsUsageCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await internalPublicAccessCredentialsUsageCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mcpMyConnectionsListQueryKey = (
  options: Options<McpMyConnectionsListData>
) => createQueryKey('mcpMyConnectionsList', options)

/**
 * The caller's own connections in the organization, of every status, newest first.
 */
export const mcpMyConnectionsListOptions = (
  options: Options<McpMyConnectionsListData>
) =>
  queryOptions<
    McpMyConnectionsListResponse,
    AxiosError<DefaultError>,
    McpMyConnectionsListResponse,
    ReturnType<typeof mcpMyConnectionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mcpMyConnectionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mcpMyConnectionsListQueryKey(options)
  })

export const mcpMyConnectionsRevokeMutation = (
  options?: Partial<Options<McpMyConnectionsRevokeData>>
): UseMutationOptions<
  McpMyConnectionsRevokeResponse,
  AxiosError<DefaultError>,
  Options<McpMyConnectionsRevokeData>
> => {
  const mutationOptions: UseMutationOptions<
    McpMyConnectionsRevokeResponse,
    AxiosError<DefaultError>,
    Options<McpMyConnectionsRevokeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpMyConnectionsRevoke({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Replaces the scopes of one of the caller's active connections.
 */
export const mcpMyConnectionsScopesUpdateMutation = (
  options?: Partial<Options<McpMyConnectionsScopesUpdateData>>
): UseMutationOptions<
  McpMyConnectionsScopesUpdateResponse,
  AxiosError<DefaultError>,
  Options<McpMyConnectionsScopesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    McpMyConnectionsScopesUpdateResponse,
    AxiosError<DefaultError>,
    Options<McpMyConnectionsScopesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpMyConnectionsScopesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mcpMyServicesListQueryKey = (
  options: Options<McpMyServicesListData>
) => createQueryKey('mcpMyServicesList', options)

/**
 * Services the caller can access in the organization; `can_manage` gates Account's admin tabs.
 */
export const mcpMyServicesListOptions = (
  options: Options<McpMyServicesListData>
) =>
  queryOptions<
    McpMyServicesListResponse,
    AxiosError<DefaultError>,
    McpMyServicesListResponse,
    ReturnType<typeof mcpMyServicesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mcpMyServicesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mcpMyServicesListQueryKey(options)
  })

/**
 * Allowed on every enabled service the caller can access. The token is returned once.
 */
export const mcpPersonalTokensCreateMutation = (
  options?: Partial<Options<McpPersonalTokensCreateData>>
): UseMutationOptions<
  McpPersonalTokensCreateResponse,
  AxiosError<DefaultError>,
  Options<McpPersonalTokensCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    McpPersonalTokensCreateResponse,
    AxiosError<DefaultError>,
    Options<McpPersonalTokensCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpPersonalTokensCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mcpToolsRetrieveQueryKey = (
  options?: Options<McpToolsRetrieveData>
) => createQueryKey('mcpToolsRetrieve', options)

/**
 * ``GET /mcp/tools/`` — list of tool descriptors for ai-service.
 *
 * For an agent-originated (delegated) token the list is filtered to the tools
 * the agent∩user intersection would actually allow, so the agent's toolset
 * reflects its capabilities. A direct user call is unfiltered.
 */
export const mcpToolsRetrieveOptions = (
  options?: Options<McpToolsRetrieveData>
) =>
  queryOptions<
    unknown,
    AxiosError<DefaultError>,
    unknown,
    ReturnType<typeof mcpToolsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mcpToolsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mcpToolsRetrieveQueryKey(options)
  })

/**
 * ``POST /mcp/tools/<name>/call/`` — invoke a tool as the bearer-authenticated user.
 *
 * Request body: ``{"args": {...}}`` (or empty). Response shape mirrors MCP:
 * - success: ``{"result": <dict>}``
 * - error:   ``{"error": {"code": <str>, "message": <str>}}``
 *
 * Auth is the same Bearer/Token JWT used everywhere else in Core. ai-service
 * forwards the user's JWT verbatim, so each tool acts as the actual user.
 *
 * For agent-originated (delegated/OBO) tokens, ``AgentUserIntersectionPermission``
 * additionally enforces the agent∩user intersection (Story 2): the call is
 * allowed only when the acting user holds RBAC permissions in the agent
 * client's bound application. Plain user JWTs are unaffected.
 */
export const mcpToolsCallCreateMutation = (
  options?: Partial<Options<McpToolsCallCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<McpToolsCallCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<McpToolsCallCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpToolsCallCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mfaConfigRetrieveQueryKey = (
  options?: Options<MfaConfigRetrieveData>
) => createQueryKey('mfaConfigRetrieve', options)

/**
 * MFA configuration for the authenticated user.
 */
export const mfaConfigRetrieveOptions = (
  options?: Options<MfaConfigRetrieveData>
) =>
  queryOptions<
    MfaConfigRetrieveResponse,
    AxiosError<DefaultError>,
    MfaConfigRetrieveResponse,
    ReturnType<typeof mfaConfigRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mfaConfigRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mfaConfigRetrieveQueryKey(options)
  })

/**
 * MFA configuration for the authenticated user.
 */
export const mfaConfigPartialUpdateMutation = (
  options?: Partial<Options<MfaConfigPartialUpdateData>>
): UseMutationOptions<
  MfaConfigPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<MfaConfigPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaConfigPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<MfaConfigPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaConfigPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * MFA configuration for the authenticated user.
 */
export const mfaConfigUpdateMutation = (
  options?: Partial<Options<MfaConfigUpdateData>>
): UseMutationOptions<
  MfaConfigUpdateResponse,
  AxiosError<DefaultError>,
  Options<MfaConfigUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaConfigUpdateResponse,
    AxiosError<DefaultError>,
    Options<MfaConfigUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaConfigUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Download MFA backup codes as CSV.
 */
export const mfaConfigDownloadBackupCodesCreateMutation = (
  options?: Partial<Options<MfaConfigDownloadBackupCodesCreateData>>
): UseMutationOptions<
  MfaConfigDownloadBackupCodesCreateResponse,
  AxiosError<DefaultError>,
  Options<MfaConfigDownloadBackupCodesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaConfigDownloadBackupCodesCreateResponse,
    AxiosError<DefaultError>,
    Options<MfaConfigDownloadBackupCodesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaConfigDownloadBackupCodesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Generate new backup codes for MFA.
 */
export const mfaConfigGenerateBackupCodesCreateMutation = (
  options?: Partial<Options<MfaConfigGenerateBackupCodesCreateData>>
): UseMutationOptions<
  MfaConfigGenerateBackupCodesCreateResponse,
  AxiosError<DefaultError>,
  Options<MfaConfigGenerateBackupCodesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaConfigGenerateBackupCodesCreateResponse,
    AxiosError<DefaultError>,
    Options<MfaConfigGenerateBackupCodesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaConfigGenerateBackupCodesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mfaInternalAuditLogsListQueryKey = (
  options?: Options<MfaInternalAuditLogsListData>
) => createQueryKey('mfaInternalAuditLogsList', options)

/**
 * Internal endpoint that lists MFA audit events from the shared audit log.
 *
 * Filters, pagination, and serialization reuse :mod:`skalx_audit_log.reader`
 * so this endpoint stays consistent with the primary ``/audit-logs/`` reader.
 *
 * @deprecated
 */
export const mfaInternalAuditLogsListOptions = (
  options?: Options<MfaInternalAuditLogsListData>
) =>
  queryOptions<
    MfaInternalAuditLogsListResponse,
    AxiosError<DefaultError>,
    MfaInternalAuditLogsListResponse,
    ReturnType<typeof mfaInternalAuditLogsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mfaInternalAuditLogsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mfaInternalAuditLogsListQueryKey(options)
  })

export const mfaInternalAuditLogsListInfiniteQueryKey = (
  options?: Options<MfaInternalAuditLogsListData>
): QueryKey<Options<MfaInternalAuditLogsListData>> =>
  createQueryKey('mfaInternalAuditLogsList', options, true)

/**
 * Internal endpoint that lists MFA audit events from the shared audit log.
 *
 * Filters, pagination, and serialization reuse :mod:`skalx_audit_log.reader`
 * so this endpoint stays consistent with the primary ``/audit-logs/`` reader.
 *
 * @deprecated
 */
export const mfaInternalAuditLogsListInfiniteOptions = (
  options?: Options<MfaInternalAuditLogsListData>
) => {
  const opts = infiniteQueryOptions<
    MfaInternalAuditLogsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<MfaInternalAuditLogsListResponse>,
    QueryKey<Options<MfaInternalAuditLogsListData>>,
    | number
    | Pick<
        QueryKey<Options<MfaInternalAuditLogsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MfaInternalAuditLogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await mfaInternalAuditLogsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: mfaInternalAuditLogsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Removed. The legacy CSV/XLSX-to-email export flow was retired when MFA events moved to the shared audit-log feed. This URL is kept only to surface a clear 410 to any remaining consumer — please contact the main-saas team so we can plan a replacement.
 *
 * @deprecated
 */
export const mfaInternalAuditLogsExportCreateMutation = (
  options?: Partial<Options<MfaInternalAuditLogsExportCreateData>>
): UseMutationOptions<
  MfaInternalAuditLogsExportCreateResponse,
  AxiosError<DefaultError>,
  Options<MfaInternalAuditLogsExportCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaInternalAuditLogsExportCreateResponse,
    AxiosError<DefaultError>,
    Options<MfaInternalAuditLogsExportCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaInternalAuditLogsExportCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mfaInternalConfigsListQueryKey = (
  options?: Options<MfaInternalConfigsListData>
) => createQueryKey('mfaInternalConfigsList', options)

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsListOptions = (
  options?: Options<MfaInternalConfigsListData>
) =>
  queryOptions<
    MfaInternalConfigsListResponse,
    AxiosError<DefaultError>,
    MfaInternalConfigsListResponse,
    ReturnType<typeof mfaInternalConfigsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mfaInternalConfigsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mfaInternalConfigsListQueryKey(options)
  })

export const mfaInternalConfigsListInfiniteQueryKey = (
  options?: Options<MfaInternalConfigsListData>
): QueryKey<Options<MfaInternalConfigsListData>> =>
  createQueryKey('mfaInternalConfigsList', options, true)

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsListInfiniteOptions = (
  options?: Options<MfaInternalConfigsListData>
) => {
  const opts = infiniteQueryOptions<
    MfaInternalConfigsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<MfaInternalConfigsListResponse>,
    QueryKey<Options<MfaInternalConfigsListData>>,
    | number
    | Pick<
        QueryKey<Options<MfaInternalConfigsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MfaInternalConfigsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await mfaInternalConfigsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: mfaInternalConfigsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const mfaInternalConfigsRetrieveQueryKey = (
  options: Options<MfaInternalConfigsRetrieveData>
) => createQueryKey('mfaInternalConfigsRetrieve', options)

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsRetrieveOptions = (
  options: Options<MfaInternalConfigsRetrieveData>
) =>
  queryOptions<
    MfaInternalConfigsRetrieveResponse,
    AxiosError<DefaultError>,
    MfaInternalConfigsRetrieveResponse,
    ReturnType<typeof mfaInternalConfigsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mfaInternalConfigsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mfaInternalConfigsRetrieveQueryKey(options)
  })

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsPartialUpdateMutation = (
  options?: Partial<Options<MfaInternalConfigsPartialUpdateData>>
): UseMutationOptions<
  MfaInternalConfigsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<MfaInternalConfigsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaInternalConfigsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<MfaInternalConfigsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaInternalConfigsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Internal endpoint for MFA configurations.
 */
export const mfaInternalConfigsUpdateMutation = (
  options?: Partial<Options<MfaInternalConfigsUpdateData>>
): UseMutationOptions<
  MfaInternalConfigsUpdateResponse,
  AxiosError<DefaultError>,
  Options<MfaInternalConfigsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaInternalConfigsUpdateResponse,
    AxiosError<DefaultError>,
    Options<MfaInternalConfigsUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaInternalConfigsUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mfaInternalLockoutsListQueryKey = (
  options?: Options<MfaInternalLockoutsListData>
) => createQueryKey('mfaInternalLockoutsList', options)

/**
 * Internal endpoint for MFA lockouts.
 */
export const mfaInternalLockoutsListOptions = (
  options?: Options<MfaInternalLockoutsListData>
) =>
  queryOptions<
    MfaInternalLockoutsListResponse,
    AxiosError<DefaultError>,
    MfaInternalLockoutsListResponse,
    ReturnType<typeof mfaInternalLockoutsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mfaInternalLockoutsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mfaInternalLockoutsListQueryKey(options)
  })

export const mfaInternalLockoutsListInfiniteQueryKey = (
  options?: Options<MfaInternalLockoutsListData>
): QueryKey<Options<MfaInternalLockoutsListData>> =>
  createQueryKey('mfaInternalLockoutsList', options, true)

/**
 * Internal endpoint for MFA lockouts.
 */
export const mfaInternalLockoutsListInfiniteOptions = (
  options?: Options<MfaInternalLockoutsListData>
) => {
  const opts = infiniteQueryOptions<
    MfaInternalLockoutsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<MfaInternalLockoutsListResponse>,
    QueryKey<Options<MfaInternalLockoutsListData>>,
    | number
    | Pick<
        QueryKey<Options<MfaInternalLockoutsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MfaInternalLockoutsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await mfaInternalLockoutsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: mfaInternalLockoutsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Internal endpoint for MFA lockouts.
 */
export const mfaInternalLockoutsDestroyMutation = (
  options?: Partial<Options<MfaInternalLockoutsDestroyData>>
): UseMutationOptions<
  MfaInternalLockoutsDestroyResponse,
  AxiosError<DefaultError>,
  Options<MfaInternalLockoutsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaInternalLockoutsDestroyResponse,
    AxiosError<DefaultError>,
    Options<MfaInternalLockoutsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaInternalLockoutsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Send OTP code to the user.
 */
export const mfaSendOtpCreateMutation = (
  options?: Partial<Options<MfaSendOtpCreateData>>
): UseMutationOptions<
  MfaSendOtpCreateResponse,
  AxiosError<DefaultError>,
  Options<MfaSendOtpCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaSendOtpCreateResponse,
    AxiosError<DefaultError>,
    Options<MfaSendOtpCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaSendOtpCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mfaTrustedDevicesListQueryKey = (
  options?: Options<MfaTrustedDevicesListData>
) => createQueryKey('mfaTrustedDevicesList', options)

/**
 * Manage trusted devices.
 */
export const mfaTrustedDevicesListOptions = (
  options?: Options<MfaTrustedDevicesListData>
) =>
  queryOptions<
    MfaTrustedDevicesListResponse,
    AxiosError<DefaultError>,
    MfaTrustedDevicesListResponse,
    ReturnType<typeof mfaTrustedDevicesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mfaTrustedDevicesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mfaTrustedDevicesListQueryKey(options)
  })

export const mfaTrustedDevicesListInfiniteQueryKey = (
  options?: Options<MfaTrustedDevicesListData>
): QueryKey<Options<MfaTrustedDevicesListData>> =>
  createQueryKey('mfaTrustedDevicesList', options, true)

/**
 * Manage trusted devices.
 */
export const mfaTrustedDevicesListInfiniteOptions = (
  options?: Options<MfaTrustedDevicesListData>
) => {
  const opts = infiniteQueryOptions<
    MfaTrustedDevicesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<MfaTrustedDevicesListResponse>,
    QueryKey<Options<MfaTrustedDevicesListData>>,
    | number
    | Pick<
        QueryKey<Options<MfaTrustedDevicesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MfaTrustedDevicesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await mfaTrustedDevicesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: mfaTrustedDevicesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Manage trusted devices.
 */
export const mfaTrustedDevicesDestroyMutation = (
  options?: Partial<Options<MfaTrustedDevicesDestroyData>>
): UseMutationOptions<
  MfaTrustedDevicesDestroyResponse,
  AxiosError<DefaultError>,
  Options<MfaTrustedDevicesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaTrustedDevicesDestroyResponse,
    AxiosError<DefaultError>,
    Options<MfaTrustedDevicesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaTrustedDevicesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Manage trusted devices.
 */
export const mfaTrustedDevicesDeleteAllDestroyMutation = (
  options?: Partial<Options<MfaTrustedDevicesDeleteAllDestroyData>>
): UseMutationOptions<
  MfaTrustedDevicesDeleteAllDestroyResponse,
  AxiosError<DefaultError>,
  Options<MfaTrustedDevicesDeleteAllDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaTrustedDevicesDeleteAllDestroyResponse,
    AxiosError<DefaultError>,
    Options<MfaTrustedDevicesDeleteAllDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaTrustedDevicesDeleteAllDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Verify backup code and issue tokens.
 */
export const mfaVerifyBackupCodeCreateMutation = (
  options?: Partial<Options<MfaVerifyBackupCodeCreateData>>
): UseMutationOptions<
  MfaVerifyBackupCodeCreateResponse,
  AxiosError<DefaultError>,
  Options<MfaVerifyBackupCodeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaVerifyBackupCodeCreateResponse,
    AxiosError<DefaultError>,
    Options<MfaVerifyBackupCodeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaVerifyBackupCodeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Verify OTP code and issue full tokens.
 */
export const mfaVerifyOtpCreateMutation = (
  options?: Partial<Options<MfaVerifyOtpCreateData>>
): UseMutationOptions<
  MfaVerifyOtpCreateResponse,
  AxiosError<DefaultError>,
  Options<MfaVerifyOtpCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MfaVerifyOtpCreateResponse,
    AxiosError<DefaultError>,
    Options<MfaVerifyOtpCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mfaVerifyOtpCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Report a step of the calling application: done, failed, back to todo, or reset for the whole workspace after its data was wiped.
 */
export const onboardingInternalStepsCreateMutation = (
  options?: Partial<Options<OnboardingInternalStepsCreateData>>
): UseMutationOptions<
  OnboardingInternalStepsCreateResponse,
  AxiosError<DefaultError>,
  Options<OnboardingInternalStepsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OnboardingInternalStepsCreateResponse,
    AxiosError<DefaultError>,
    Options<OnboardingInternalStepsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await onboardingInternalStepsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const onboardingJourneysRetrieveQueryKey = (
  options: Options<OnboardingJourneysRetrieveData>
) => createQueryKey('onboardingJourneysRetrieve', options)

/**
 * Current user's journey for a scope: the steps the client has reported, plus cross-links.
 */
export const onboardingJourneysRetrieveOptions = (
  options: Options<OnboardingJourneysRetrieveData>
) =>
  queryOptions<
    OnboardingJourneysRetrieveResponse,
    AxiosError<DefaultError>,
    OnboardingJourneysRetrieveResponse,
    ReturnType<typeof onboardingJourneysRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingJourneysRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: onboardingJourneysRetrieveQueryKey(options)
  })

/**
 * Report a step's status (set_step) or a checklist intent: skip, dismiss, hide, expand, collapse.
 */
export const onboardingJourneysPartialUpdateMutation = (
  options?: Partial<Options<OnboardingJourneysPartialUpdateData>>
): UseMutationOptions<
  OnboardingJourneysPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OnboardingJourneysPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OnboardingJourneysPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OnboardingJourneysPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await onboardingJourneysPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const onboardingProfileRetrieveQueryKey = (
  options?: Options<OnboardingProfileRetrieveData>
) => createQueryKey('onboardingProfileRetrieve', options)

/**
 * The workspace's onboarding profile — the only personalisation input an app may read. Requires workspace permission: `organization.view`.
 */
export const onboardingProfileRetrieveOptions = (
  options?: Options<OnboardingProfileRetrieveData>
) =>
  queryOptions<
    OnboardingProfileRetrieveResponse,
    AxiosError<DefaultError>,
    OnboardingProfileRetrieveResponse,
    ReturnType<typeof onboardingProfileRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await onboardingProfileRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: onboardingProfileRetrieveQueryKey(options)
  })

/**
 * Fill in what the wizard collects after provisioning has started — attribution, in practice. Requires workspace permission: `organization.manage`.
 */
export const onboardingProfilePartialUpdateMutation = (
  options?: Partial<Options<OnboardingProfilePartialUpdateData>>
): UseMutationOptions<
  OnboardingProfilePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OnboardingProfilePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OnboardingProfilePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OnboardingProfilePartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await onboardingProfilePartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Save the workspace intent profile. Requires workspace permission: `organization.manage`; a second call returns the existing profile (BR-14).
 */
export const onboardingProfileCreateMutation = (
  options?: Partial<Options<OnboardingProfileCreateData>>
): UseMutationOptions<
  OnboardingProfileCreateResponse,
  AxiosError<OnboardingProfileCreateError>,
  Options<OnboardingProfileCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OnboardingProfileCreateResponse,
    AxiosError<OnboardingProfileCreateError>,
    Options<OnboardingProfileCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await onboardingProfileCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAuditArchivesListQueryKey = (
  options: Options<OrganizationsAuditArchivesListData>
) => createQueryKey('organizationsAuditArchivesList', options)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditArchivesListOptions = (
  options: Options<OrganizationsAuditArchivesListData>
) =>
  queryOptions<
    OrganizationsAuditArchivesListResponse,
    AxiosError<DefaultError>,
    OrganizationsAuditArchivesListResponse,
    ReturnType<typeof organizationsAuditArchivesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAuditArchivesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAuditArchivesListQueryKey(options)
  })

export const organizationsAuditArchivesListInfiniteQueryKey = (
  options: Options<OrganizationsAuditArchivesListData>
): QueryKey<Options<OrganizationsAuditArchivesListData>> =>
  createQueryKey('organizationsAuditArchivesList', options, true)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditArchivesListInfiniteOptions = (
  options: Options<OrganizationsAuditArchivesListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsAuditArchivesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsAuditArchivesListResponse>,
    QueryKey<Options<OrganizationsAuditArchivesListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsAuditArchivesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsAuditArchivesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsAuditArchivesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsAuditArchivesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesCreateMutation = (
  options?: Partial<Options<OrganizationsAuditArchivesCreateData>>
): UseMutationOptions<
  OrganizationsAuditArchivesCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAuditArchivesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAuditArchivesCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAuditArchivesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAuditArchivesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesDestroyMutation = (
  options?: Partial<Options<OrganizationsAuditArchivesDestroyData>>
): UseMutationOptions<
  OrganizationsAuditArchivesDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAuditArchivesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAuditArchivesDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAuditArchivesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAuditArchivesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAuditArchivesRetrieveQueryKey = (
  options: Options<OrganizationsAuditArchivesRetrieveData>
) => createQueryKey('organizationsAuditArchivesRetrieve', options)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditArchivesRetrieveOptions = (
  options: Options<OrganizationsAuditArchivesRetrieveData>
) =>
  queryOptions<
    OrganizationsAuditArchivesRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsAuditArchivesRetrieveResponse,
    ReturnType<typeof organizationsAuditArchivesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAuditArchivesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAuditArchivesRetrieveQueryKey(options)
  })

export const organizationsAuditArchivesDownloadRetrieveQueryKey = (
  options: Options<OrganizationsAuditArchivesDownloadRetrieveData>
) => createQueryKey('organizationsAuditArchivesDownloadRetrieve', options)

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesDownloadRetrieveOptions = (
  options: Options<OrganizationsAuditArchivesDownloadRetrieveData>
) =>
  queryOptions<
    OrganizationsAuditArchivesDownloadRetrieveResponse,
    AxiosError<OrganizationsAuditArchivesDownloadRetrieveError>,
    OrganizationsAuditArchivesDownloadRetrieveResponse,
    ReturnType<typeof organizationsAuditArchivesDownloadRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAuditArchivesDownloadRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAuditArchivesDownloadRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `audit.export`.
 */
export const organizationsAuditArchivesBulkDeleteDestroyMutation = (
  options?: Partial<Options<OrganizationsAuditArchivesBulkDeleteDestroyData>>
): UseMutationOptions<
  OrganizationsAuditArchivesBulkDeleteDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAuditArchivesBulkDeleteDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAuditArchivesBulkDeleteDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAuditArchivesBulkDeleteDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAuditArchivesBulkDeleteDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAuditLogsListQueryKey = (
  options: Options<OrganizationsAuditLogsListData>
) => createQueryKey('organizationsAuditLogsList', options)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsListOptions = (
  options: Options<OrganizationsAuditLogsListData>
) =>
  queryOptions<
    OrganizationsAuditLogsListResponse,
    AxiosError<DefaultError>,
    OrganizationsAuditLogsListResponse,
    ReturnType<typeof organizationsAuditLogsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAuditLogsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAuditLogsListQueryKey(options)
  })

export const organizationsAuditLogsListInfiniteQueryKey = (
  options: Options<OrganizationsAuditLogsListData>
): QueryKey<Options<OrganizationsAuditLogsListData>> =>
  createQueryKey('organizationsAuditLogsList', options, true)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsListInfiniteOptions = (
  options: Options<OrganizationsAuditLogsListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsAuditLogsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsAuditLogsListResponse>,
    QueryKey<Options<OrganizationsAuditLogsListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsAuditLogsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsAuditLogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsAuditLogsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsAuditLogsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const organizationsAuditLogsRetrieveQueryKey = (
  options: Options<OrganizationsAuditLogsRetrieveData>
) => createQueryKey('organizationsAuditLogsRetrieve', options)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsRetrieveOptions = (
  options: Options<OrganizationsAuditLogsRetrieveData>
) =>
  queryOptions<
    OrganizationsAuditLogsRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsAuditLogsRetrieveResponse,
    ReturnType<typeof organizationsAuditLogsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAuditLogsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAuditLogsRetrieveQueryKey(options)
  })

export const organizationsAuditLogsFiltersRetrieveQueryKey = (
  options: Options<OrganizationsAuditLogsFiltersRetrieveData>
) => createQueryKey('organizationsAuditLogsFiltersRetrieve', options)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsFiltersRetrieveOptions = (
  options: Options<OrganizationsAuditLogsFiltersRetrieveData>
) =>
  queryOptions<
    OrganizationsAuditLogsFiltersRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsAuditLogsFiltersRetrieveResponse,
    ReturnType<typeof organizationsAuditLogsFiltersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAuditLogsFiltersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAuditLogsFiltersRetrieveQueryKey(options)
  })

export const organizationsAuditLogsSignInActivityRetrieveQueryKey = (
  options: Options<OrganizationsAuditLogsSignInActivityRetrieveData>
) => createQueryKey('organizationsAuditLogsSignInActivityRetrieve', options)

/**
 * Requires workspace permission: `audit.view`.
 */
export const organizationsAuditLogsSignInActivityRetrieveOptions = (
  options: Options<OrganizationsAuditLogsSignInActivityRetrieveData>
) =>
  queryOptions<
    OrganizationsAuditLogsSignInActivityRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsAuditLogsSignInActivityRetrieveResponse,
    ReturnType<typeof organizationsAuditLogsSignInActivityRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAuditLogsSignInActivityRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAuditLogsSignInActivityRetrieveQueryKey(options)
  })

export const organizationsJoinRequestsListQueryKey = (
  options: Options<OrganizationsJoinRequestsListData>
) => createQueryKey('organizationsJoinRequestsList', options)

/**
 * Requests to join this workspace. Requires workspace permission: `users.invite`.
 */
export const organizationsJoinRequestsListOptions = (
  options: Options<OrganizationsJoinRequestsListData>
) =>
  queryOptions<
    OrganizationsJoinRequestsListResponse,
    AxiosError<DefaultError>,
    OrganizationsJoinRequestsListResponse,
    ReturnType<typeof organizationsJoinRequestsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsJoinRequestsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsJoinRequestsListQueryKey(options)
  })

export const organizationsJoinRequestsListInfiniteQueryKey = (
  options: Options<OrganizationsJoinRequestsListData>
): QueryKey<Options<OrganizationsJoinRequestsListData>> =>
  createQueryKey('organizationsJoinRequestsList', options, true)

/**
 * Requests to join this workspace. Requires workspace permission: `users.invite`.
 */
export const organizationsJoinRequestsListInfiniteOptions = (
  options: Options<OrganizationsJoinRequestsListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsJoinRequestsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsJoinRequestsListResponse>,
    QueryKey<Options<OrganizationsJoinRequestsListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsJoinRequestsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsJoinRequestsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsJoinRequestsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsJoinRequestsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Ask to join the workspace that uses your email domain (BR-10). Notifies its administrators and never grants membership. Asking twice returns the same request.
 */
export const organizationsJoinRequestsCreateMutation = (
  options?: Partial<Options<OrganizationsJoinRequestsCreateData>>
): UseMutationOptions<
  OrganizationsJoinRequestsCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsJoinRequestsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsJoinRequestsCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsJoinRequestsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsJoinRequestsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Approve a request: grants Member workspace access and tells the person. Requires workspace permission: `users.invite`.
 */
export const organizationsJoinRequestsApproveCreateMutation = (
  options?: Partial<Options<OrganizationsJoinRequestsApproveCreateData>>
): UseMutationOptions<
  OrganizationsJoinRequestsApproveCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsJoinRequestsApproveCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsJoinRequestsApproveCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsJoinRequestsApproveCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsJoinRequestsApproveCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Decline a request. Nothing is granted and the requester is not emailed. Requires workspace permission: `users.invite`.
 */
export const organizationsJoinRequestsRejectCreateMutation = (
  options?: Partial<Options<OrganizationsJoinRequestsRejectCreateData>>
): UseMutationOptions<
  OrganizationsJoinRequestsRejectCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsJoinRequestsRejectCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsJoinRequestsRejectCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsJoinRequestsRejectCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsJoinRequestsRejectCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAccessListQueryKey = (
  options?: Options<OrganizationsAccessListData>
) => createQueryKey('organizationsAccessList', options)

/**
 * Requires `users.view` to list all workspace members; without it, the caller receives only their own membership.
 */
export const organizationsAccessListOptions = (
  options?: Options<OrganizationsAccessListData>
) =>
  queryOptions<
    OrganizationsAccessListResponse,
    AxiosError<DefaultError>,
    OrganizationsAccessListResponse,
    ReturnType<typeof organizationsAccessListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAccessList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAccessListQueryKey(options)
  })

export const organizationsAccessListInfiniteQueryKey = (
  options?: Options<OrganizationsAccessListData>
): QueryKey<Options<OrganizationsAccessListData>> =>
  createQueryKey('organizationsAccessList', options, true)

/**
 * Requires `users.view` to list all workspace members; without it, the caller receives only their own membership.
 */
export const organizationsAccessListInfiniteOptions = (
  options?: Options<OrganizationsAccessListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsAccessListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsAccessListResponse>,
    QueryKey<Options<OrganizationsAccessListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsAccessListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsAccessListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsAccessList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsAccessListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessDestroyMutation = (
  options?: Partial<Options<OrganizationsAccessDestroyData>>
): UseMutationOptions<
  OrganizationsAccessDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAccessRetrieveQueryKey = (
  options: Options<OrganizationsAccessRetrieveData>
) => createQueryKey('organizationsAccessRetrieve', options)

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsAccessRetrieveOptions = (
  options: Options<OrganizationsAccessRetrieveData>
) =>
  queryOptions<
    OrganizationsAccessRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsAccessRetrieveResponse,
    ReturnType<typeof organizationsAccessRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAccessRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAccessRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessPartialUpdateMutation = (
  options?: Partial<Options<OrganizationsAccessPartialUpdateData>>
): UseMutationOptions<
  OrganizationsAccessPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessBlockCreateMutation = (
  options?: Partial<Options<OrganizationsAccessBlockCreateData>>
): UseMutationOptions<
  OrganizationsAccessBlockCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessBlockCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessBlockCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessBlockCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessBlockCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Lift THIS workspace's per-member MFA compulsion (counterpart to require-mfa).
 *
 * Clears the org-scoped ``require_mfa`` override on the member's access record for this organization. It does NOT switch off the member's own MFA enrollment — that is the member's to manage, and an admin recovery for a lost factor is ``reset-mfa`` (which never exposes their codes). A workspace-wide ``Organization.require_mfa`` policy, if set, still applies; this only removes the per-member override.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessDisableMfaCreateMutation = (
  options?: Partial<Options<OrganizationsAccessDisableMfaCreateData>>
): UseMutationOptions<
  OrganizationsAccessDisableMfaCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessDisableMfaCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessDisableMfaCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessDisableMfaCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessDisableMfaCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Issue a session for the target member. Requires workspace permission `users.manage` AND the workspace owner role; superusers are exempt, and impersonating another admin is always refused.
 */
export const organizationsAccessImpersonateCreateMutation = (
  options?: Partial<Options<OrganizationsAccessImpersonateCreateData>>
): UseMutationOptions<
  OrganizationsAccessImpersonateCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessImpersonateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessImpersonateCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessImpersonateCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessImpersonateCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Compel MFA for a member in THIS workspace (org-scoped enforcement).
 *
 * Sets the per-member ``require_mfa`` flag on the member's access record for this organization only — it never touches the member's account-global MFA enrollment, so enforcing MFA here cannot change their security posture in another workspace (fixes the cross-workspace leak, MFA-1). If the member hasn't enrolled a usable method yet, the login gate drives enrollment-at-login rather than locking them out.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessRequireMfaCreateMutation = (
  options?: Partial<Options<OrganizationsAccessRequireMfaCreateData>>
): UseMutationOptions<
  OrganizationsAccessRequireMfaCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessRequireMfaCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessRequireMfaCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessRequireMfaCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessRequireMfaCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Re-issue a pending invite's token and email the member a fresh link. Requires workspace permission: `users.invite`.
 */
export const organizationsAccessResendInviteCreateMutation = (
  options?: Partial<Options<OrganizationsAccessResendInviteCreateData>>
): UseMutationOptions<
  OrganizationsAccessResendInviteCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessResendInviteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessResendInviteCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessResendInviteCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessResendInviteCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Reset a member's MFA to a clean slate (admin recovery — lost or compromised second factor) WITHOUT exposing their recovery codes.
 *
 * Recovery operates on the member's own (account-global) enrollment, since a second factor is per-user: the old backup codes, trusted devices, and lockouts are invalidated so the member re-enrolls cleanly, and the email-OTP fallback is (re)enabled via the shared safe-enablement helper so the reset can never lock them out. It only ever *strengthens* the member's posture — it cannot disable MFA in any workspace. The admin never sees a code.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessResetMfaCreateMutation = (
  options?: Partial<Options<OrganizationsAccessResetMfaCreateData>>
): UseMutationOptions<
  OrganizationsAccessResetMfaCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessResetMfaCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessResetMfaCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessResetMfaCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessResetMfaCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Admin-triggered password reset — emails the member a reset link.
 *
 * Link-based (not a temporary password) to stay consistent with the rest of the auth flows and avoid mailing a plaintext secret.
 *
 * Requires workspace permission: `users.manage`.
 */
export const organizationsAccessResetPasswordCreateMutation = (
  options?: Partial<Options<OrganizationsAccessResetPasswordCreateData>>
): UseMutationOptions<
  OrganizationsAccessResetPasswordCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessResetPasswordCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessResetPasswordCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessResetPasswordCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessResetPasswordCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Cancel a still-pending invite — deletes the token and marks it revoked. Requires workspace permission: `users.invite`.
 */
export const organizationsAccessRevokeInviteCreateMutation = (
  options?: Partial<Options<OrganizationsAccessRevokeInviteCreateData>>
): UseMutationOptions<
  OrganizationsAccessRevokeInviteCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessRevokeInviteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessRevokeInviteCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessRevokeInviteCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessRevokeInviteCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Replace personal roles assigned to a user in an organization.
 *
 * Admin/Member may be changed through the same role-ID list as application and custom workspace roles. Omitting a system role preserves the current Admin/Member assignment. Group-derived grants are always left untouched.
 *
 * Changing application roles requires `applications.access`; changing custom workspace roles requires `roles.manage`; changing system workspace roles requires a workspace administrator.
 */
export const organizationsAccessRolesCreateMutation = (
  options?: Partial<Options<OrganizationsAccessRolesCreateData>>
): UseMutationOptions<
  OrganizationsAccessRolesCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessRolesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessRolesCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessRolesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessRolesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAccessSessionsListQueryKey = (
  options: Options<OrganizationsAccessSessionsListData>
) => createQueryKey('organizationsAccessSessionsList', options)

/**
 * List a member's active sign-in sessions scoped to this workspace. Requires workspace permission: `users.manage`.
 */
export const organizationsAccessSessionsListOptions = (
  options: Options<OrganizationsAccessSessionsListData>
) =>
  queryOptions<
    OrganizationsAccessSessionsListResponse,
    AxiosError<DefaultError>,
    OrganizationsAccessSessionsListResponse,
    ReturnType<typeof organizationsAccessSessionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAccessSessionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAccessSessionsListQueryKey(options)
  })

/**
 * Revoke a single session of a member (scoped to this workspace). Requires workspace permission: `users.manage`.
 */
export const organizationsAccessSessionsDestroyMutation = (
  options?: Partial<Options<OrganizationsAccessSessionsDestroyData>>
): UseMutationOptions<
  OrganizationsAccessSessionsDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessSessionsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessSessionsDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessSessionsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessSessionsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Revoke every active session of a member within this workspace. Requires workspace permission: `users.manage`.
 */
export const organizationsAccessSessionsRevokeAllCreateMutation = (
  options?: Partial<Options<OrganizationsAccessSessionsRevokeAllCreateData>>
): UseMutationOptions<
  OrganizationsAccessSessionsRevokeAllCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessSessionsRevokeAllCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessSessionsRevokeAllCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessSessionsRevokeAllCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessSessionsRevokeAllCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAccessSignInActivityRetrieveQueryKey = (
  options: Options<OrganizationsAccessSignInActivityRetrieveData>
) => createQueryKey('organizationsAccessSignInActivityRetrieve', options)

/**
 * Count a member's successful sign-ins over the trailing 30 days (audit-log backed). Requires workspace permission: `audit.view`.
 */
export const organizationsAccessSignInActivityRetrieveOptions = (
  options: Options<OrganizationsAccessSignInActivityRetrieveData>
) =>
  queryOptions<
    OrganizationsAccessSignInActivityRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsAccessSignInActivityRetrieveResponse,
    ReturnType<typeof organizationsAccessSignInActivityRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAccessSignInActivityRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAccessSignInActivityRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `users.invite`.
 */
export const organizationsAccessAddCreateMutation = (
  options?: Partial<Options<OrganizationsAccessAddCreateData>>
): UseMutationOptions<
  OrganizationsAccessAddCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsAccessAddCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsAccessAddCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsAccessAddCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsAccessAddCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsAccessOrganigramaListQueryKey = (
  options: Options<OrganizationsAccessOrganigramaListData>
) => createQueryKey('organizationsAccessOrganigramaList', options)

/**
 * Returns the organigrama (organization chart) for a given organization and optional head_user. Query params: - organization: int (required) - head_user: int (optional) Requires workspace permission: `users.view`.
 */
export const organizationsAccessOrganigramaListOptions = (
  options: Options<OrganizationsAccessOrganigramaListData>
) =>
  queryOptions<
    OrganizationsAccessOrganigramaListResponse,
    AxiosError<DefaultError>,
    OrganizationsAccessOrganigramaListResponse,
    ReturnType<typeof organizationsAccessOrganigramaListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsAccessOrganigramaList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsAccessOrganigramaListQueryKey(options)
  })

export const organizationsDomainAvailabilityRetrieveQueryKey = (
  options: Options<OrganizationsDomainAvailabilityRetrieveData>
) => createQueryKey('organizationsDomainAvailabilityRetrieve', options)

/**
 * Live, public check of whether a workspace address can be claimed.
 *
 * Mirrors the create path (reserved list, then uniqueness). A reserved slug reads as
 * unavailable — unlike probing ``/organizations/info`` for a 404, which had no record
 * for a reserved slug and so reported it free.
 */
export const organizationsDomainAvailabilityRetrieveOptions = (
  options: Options<OrganizationsDomainAvailabilityRetrieveData>
) =>
  queryOptions<
    OrganizationsDomainAvailabilityRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsDomainAvailabilityRetrieveResponse,
    ReturnType<typeof organizationsDomainAvailabilityRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsDomainAvailabilityRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsDomainAvailabilityRetrieveQueryKey(options)
  })

export const organizationsDomainMatchRetrieveQueryKey = (
  options?: Options<OrganizationsDomainMatchRetrieveData>
) => createQueryKey('organizationsDomainMatchRetrieve', options)

/**
 * Whether an existing workspace uses the caller's email domain, and whether they already asked.
 */
export const organizationsDomainMatchRetrieveOptions = (
  options?: Options<OrganizationsDomainMatchRetrieveData>
) =>
  queryOptions<
    OrganizationsDomainMatchRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsDomainMatchRetrieveResponse,
    ReturnType<typeof organizationsDomainMatchRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsDomainMatchRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsDomainMatchRetrieveQueryKey(options)
  })

export const organizationsInfoRetrieveQueryKey = (
  options: Options<OrganizationsInfoRetrieveData>
) => createQueryKey('organizationsInfoRetrieve', options)

export const organizationsInfoRetrieveOptions = (
  options: Options<OrganizationsInfoRetrieveData>
) =>
  queryOptions<
    OrganizationsInfoRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsInfoRetrieveResponse,
    ReturnType<typeof organizationsInfoRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsInfoRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsInfoRetrieveQueryKey(options)
  })

export const organizationsOrganizationsListQueryKey = (
  options?: Options<OrganizationsOrganizationsListData>
) => createQueryKey('organizationsOrganizationsList', options)

/**
 * Returns workspaces where the caller has `organization.view`.
 */
export const organizationsOrganizationsListOptions = (
  options?: Options<OrganizationsOrganizationsListData>
) =>
  queryOptions<
    OrganizationsOrganizationsListResponse,
    AxiosError<DefaultError>,
    OrganizationsOrganizationsListResponse,
    ReturnType<typeof organizationsOrganizationsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsOrganizationsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsOrganizationsListQueryKey(options)
  })

export const organizationsOrganizationsListInfiniteQueryKey = (
  options?: Options<OrganizationsOrganizationsListData>
): QueryKey<Options<OrganizationsOrganizationsListData>> =>
  createQueryKey('organizationsOrganizationsList', options, true)

/**
 * Returns workspaces where the caller has `organization.view`.
 */
export const organizationsOrganizationsListInfiniteOptions = (
  options?: Options<OrganizationsOrganizationsListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsOrganizationsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsOrganizationsListResponse>,
    QueryKey<Options<OrganizationsOrganizationsListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsOrganizationsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsOrganizationsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsOrganizationsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsOrganizationsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires authentication; no existing workspace permission is required.
 */
export const organizationsOrganizationsCreateMutation = (
  options?: Partial<Options<OrganizationsOrganizationsCreateData>>
): UseMutationOptions<
  OrganizationsOrganizationsCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission `organization.manage` and the workspace owner role.
 */
export const organizationsOrganizationsDestroyMutation = (
  options?: Partial<Options<OrganizationsOrganizationsDestroyData>>
): UseMutationOptions<
  OrganizationsOrganizationsDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsOrganizationsRetrieveQueryKey = (
  options: Options<OrganizationsOrganizationsRetrieveData>
) => createQueryKey('organizationsOrganizationsRetrieve', options)

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsRetrieveOptions = (
  options: Options<OrganizationsOrganizationsRetrieveData>
) =>
  queryOptions<
    OrganizationsOrganizationsRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsOrganizationsRetrieveResponse,
    ReturnType<typeof organizationsOrganizationsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsOrganizationsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsOrganizationsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsPartialUpdateMutation = (
  options?: Partial<Options<OrganizationsOrganizationsPartialUpdateData>>
): UseMutationOptions<
  OrganizationsOrganizationsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsOrganizationsAuthMethodsRetrieveQueryKey = (
  options: Options<OrganizationsOrganizationsAuthMethodsRetrieveData>
) => createQueryKey('organizationsOrganizationsAuthMethodsRetrieve', options)

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsAuthMethodsRetrieveOptions = (
  options: Options<OrganizationsOrganizationsAuthMethodsRetrieveData>
) =>
  queryOptions<
    OrganizationsOrganizationsAuthMethodsRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsOrganizationsAuthMethodsRetrieveResponse,
    ReturnType<typeof organizationsOrganizationsAuthMethodsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsOrganizationsAuthMethodsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsOrganizationsAuthMethodsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsAuthMethodsPartialUpdateMutation = (
  options?: Partial<
    Options<OrganizationsOrganizationsAuthMethodsPartialUpdateData>
  >
): UseMutationOptions<
  OrganizationsOrganizationsAuthMethodsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsAuthMethodsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsAuthMethodsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsAuthMethodsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsAuthMethodsPartialUpdate(
        {
          ...options,
          ...fnOptions,
          throwOnError: true
        }
      )
      return data
    }
  }
  return mutationOptions
}

export const organizationsOrganizationsCustomAuthProvidersListQueryKey = (
  options: Options<OrganizationsOrganizationsCustomAuthProvidersListData>
) =>
  createQueryKey('organizationsOrganizationsCustomAuthProvidersList', options)

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsCustomAuthProvidersListOptions = (
  options: Options<OrganizationsOrganizationsCustomAuthProvidersListData>
) =>
  queryOptions<
    OrganizationsOrganizationsCustomAuthProvidersListResponse,
    AxiosError<DefaultError>,
    OrganizationsOrganizationsCustomAuthProvidersListResponse,
    ReturnType<typeof organizationsOrganizationsCustomAuthProvidersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsOrganizationsCustomAuthProvidersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsOrganizationsCustomAuthProvidersListQueryKey(options)
  })

export const organizationsOrganizationsCustomAuthProvidersListInfiniteQueryKey =
  (
    options: Options<OrganizationsOrganizationsCustomAuthProvidersListData>
  ): QueryKey<Options<OrganizationsOrganizationsCustomAuthProvidersListData>> =>
    createQueryKey(
      'organizationsOrganizationsCustomAuthProvidersList',
      options,
      true
    )

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsCustomAuthProvidersListInfiniteOptions =
  (options: Options<OrganizationsOrganizationsCustomAuthProvidersListData>) => {
    const opts = infiniteQueryOptions<
      OrganizationsOrganizationsCustomAuthProvidersListResponse,
      AxiosError<DefaultError>,
      InfiniteData<OrganizationsOrganizationsCustomAuthProvidersListResponse>,
      QueryKey<Options<OrganizationsOrganizationsCustomAuthProvidersListData>>,
      | number
      | Pick<
          QueryKey<
            Options<OrganizationsOrganizationsCustomAuthProvidersListData>
          >[0],
          'body' | 'headers' | 'path' | 'query'
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<OrganizationsOrganizationsCustomAuthProvidersListData>
            >[0],
            'body' | 'headers' | 'path' | 'query'
          > =
            typeof pageParam === 'object'
              ? pageParam
              : {
                  query: {
                    page: pageParam
                  }
                }
          const params = createInfiniteParams(queryKey, page)
          const { data } =
            await organizationsOrganizationsCustomAuthProvidersList({
              ...options,
              ...params,
              signal,
              throwOnError: true
            })
          return data
        },
        queryKey:
          organizationsOrganizationsCustomAuthProvidersListInfiniteQueryKey(
            options
          )
      }
    )
    return opts as Omit<typeof opts, 'initialData'>
  }

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsCustomAuthProvidersCreateMutation = (
  options?: Partial<
    Options<OrganizationsOrganizationsCustomAuthProvidersCreateData>
  >
): UseMutationOptions<
  OrganizationsOrganizationsCustomAuthProvidersCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsCustomAuthProvidersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsCustomAuthProvidersCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsCustomAuthProvidersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await organizationsOrganizationsCustomAuthProvidersCreate({
          ...options,
          ...fnOptions,
          throwOnError: true
        })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsCustomAuthProvidersDestroyMutation = (
  options?: Partial<
    Options<OrganizationsOrganizationsCustomAuthProvidersDestroyData>
  >
): UseMutationOptions<
  OrganizationsOrganizationsCustomAuthProvidersDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsCustomAuthProvidersDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsCustomAuthProvidersDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsCustomAuthProvidersDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await organizationsOrganizationsCustomAuthProvidersDestroy({
          ...options,
          ...fnOptions,
          throwOnError: true
        })
      return data
    }
  }
  return mutationOptions
}

export const organizationsOrganizationsCustomAuthProvidersRetrieveQueryKey = (
  options: Options<OrganizationsOrganizationsCustomAuthProvidersRetrieveData>
) =>
  createQueryKey(
    'organizationsOrganizationsCustomAuthProvidersRetrieve',
    options
  )

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsCustomAuthProvidersRetrieveOptions = (
  options: Options<OrganizationsOrganizationsCustomAuthProvidersRetrieveData>
) =>
  queryOptions<
    OrganizationsOrganizationsCustomAuthProvidersRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsOrganizationsCustomAuthProvidersRetrieveResponse,
    ReturnType<
      typeof organizationsOrganizationsCustomAuthProvidersRetrieveQueryKey
    >
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await organizationsOrganizationsCustomAuthProvidersRetrieve({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true
        })
      return data
    },
    queryKey:
      organizationsOrganizationsCustomAuthProvidersRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsCustomAuthProvidersPartialUpdateMutation =
  (
    options?: Partial<
      Options<OrganizationsOrganizationsCustomAuthProvidersPartialUpdateData>
    >
  ): UseMutationOptions<
    OrganizationsOrganizationsCustomAuthProvidersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsCustomAuthProvidersPartialUpdateData>
  > => {
    const mutationOptions: UseMutationOptions<
      OrganizationsOrganizationsCustomAuthProvidersPartialUpdateResponse,
      AxiosError<DefaultError>,
      Options<OrganizationsOrganizationsCustomAuthProvidersPartialUpdateData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await organizationsOrganizationsCustomAuthProvidersPartialUpdate({
            ...options,
            ...fnOptions,
            throwOnError: true
          })
        return data
      }
    }
    return mutationOptions
  }

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsDemoDisableCreateMutation = (
  options?: Partial<Options<OrganizationsOrganizationsDemoDisableCreateData>>
): UseMutationOptions<
  OrganizationsOrganizationsDemoDisableCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsDemoDisableCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsDemoDisableCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsDemoDisableCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsDemoDisableCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsDemoEnableCreateMutation = (
  options?: Partial<Options<OrganizationsOrganizationsDemoEnableCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsDemoEnableCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsDemoEnableCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsDemoEnableCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsEnvironmentBuildCreateMutation = (
  options?: Partial<
    Options<OrganizationsOrganizationsEnvironmentBuildCreateData>
  >
): UseMutationOptions<
  OrganizationsOrganizationsEnvironmentBuildCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsEnvironmentBuildCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsEnvironmentBuildCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsEnvironmentBuildCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsEnvironmentBuildCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsEnvironmentClearCreateMutation = (
  options?: Partial<
    Options<OrganizationsOrganizationsEnvironmentClearCreateData>
  >
): UseMutationOptions<
  OrganizationsOrganizationsEnvironmentClearCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsEnvironmentClearCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsEnvironmentClearCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsEnvironmentClearCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsEnvironmentClearCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsOrganizationsMemberAuthMethodsListQueryKey = (
  options: Options<OrganizationsOrganizationsMemberAuthMethodsListData>
) => createQueryKey('organizationsOrganizationsMemberAuthMethodsList', options)

/**
 * Return enabled auth methods for the organization (member-accessible, no secrets). Requires an active membership in the workspace; no workspace permission is required.
 */
export const organizationsOrganizationsMemberAuthMethodsListOptions = (
  options: Options<OrganizationsOrganizationsMemberAuthMethodsListData>
) =>
  queryOptions<
    OrganizationsOrganizationsMemberAuthMethodsListResponse,
    AxiosError<DefaultError>,
    OrganizationsOrganizationsMemberAuthMethodsListResponse,
    ReturnType<typeof organizationsOrganizationsMemberAuthMethodsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsOrganizationsMemberAuthMethodsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsOrganizationsMemberAuthMethodsListQueryKey(options)
  })

export const organizationsOrganizationsMemberAuthMethodsListInfiniteQueryKey = (
  options: Options<OrganizationsOrganizationsMemberAuthMethodsListData>
): QueryKey<Options<OrganizationsOrganizationsMemberAuthMethodsListData>> =>
  createQueryKey(
    'organizationsOrganizationsMemberAuthMethodsList',
    options,
    true
  )

/**
 * Return enabled auth methods for the organization (member-accessible, no secrets). Requires an active membership in the workspace; no workspace permission is required.
 */
export const organizationsOrganizationsMemberAuthMethodsListInfiniteOptions = (
  options: Options<OrganizationsOrganizationsMemberAuthMethodsListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsOrganizationsMemberAuthMethodsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsOrganizationsMemberAuthMethodsListResponse>,
    QueryKey<Options<OrganizationsOrganizationsMemberAuthMethodsListData>>,
    | number
    | Pick<
        QueryKey<
          Options<OrganizationsOrganizationsMemberAuthMethodsListData>
        >[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<
            Options<OrganizationsOrganizationsMemberAuthMethodsListData>
          >[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsOrganizationsMemberAuthMethodsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey:
        organizationsOrganizationsMemberAuthMethodsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const organizationsOrganizationsMicrosoftAppRegistrationRetrieveQueryKey =
  (
    options: Options<OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveData>
  ) =>
    createQueryKey(
      'organizationsOrganizationsMicrosoftAppRegistrationRetrieve',
      options
    )

/**
 * Requires workspace permission: `organization.view`.
 */
export const organizationsOrganizationsMicrosoftAppRegistrationRetrieveOptions =
  (
    options: Options<OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveData>
  ) =>
    queryOptions<
      OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveResponse,
      AxiosError<DefaultError>,
      OrganizationsOrganizationsMicrosoftAppRegistrationRetrieveResponse,
      ReturnType<
        typeof organizationsOrganizationsMicrosoftAppRegistrationRetrieveQueryKey
      >
    >({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await organizationsOrganizationsMicrosoftAppRegistrationRetrieve({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
          })
        return data
      },
      queryKey:
        organizationsOrganizationsMicrosoftAppRegistrationRetrieveQueryKey(
          options
        )
    })

/**
 * Requires workspace permission: `organization.manage`.
 */
export const organizationsOrganizationsMicrosoftAppRegistrationPartialUpdateMutation =
  (
    options?: Partial<
      Options<OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateData>
    >
  ): UseMutationOptions<
    OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateData>
  > => {
    const mutationOptions: UseMutationOptions<
      OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateResponse,
      AxiosError<DefaultError>,
      Options<OrganizationsOrganizationsMicrosoftAppRegistrationPartialUpdateData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await organizationsOrganizationsMicrosoftAppRegistrationPartialUpdate(
            {
              ...options,
              ...fnOptions,
              throwOnError: true
            }
          )
        return data
      }
    }
    return mutationOptions
  }

/**
 * Requires workspace permission `organization.manage` and the current workspace owner role.
 */
export const organizationsOrganizationsTransferOwnershipCreateMutation = (
  options?: Partial<
    Options<OrganizationsOrganizationsTransferOwnershipCreateData>
  >
): UseMutationOptions<
  OrganizationsOrganizationsTransferOwnershipCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsOrganizationsTransferOwnershipCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsOrganizationsTransferOwnershipCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsOrganizationsTransferOwnershipCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsOrganizationsTransferOwnershipCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const permissionsListQueryKey = (
  options?: Options<PermissionsListData>
) => createQueryKey('permissionsList', options)

/**
 * Requires authentication; no workspace permission is required.
 */
export const permissionsListOptions = (
  options?: Options<PermissionsListData>
) =>
  queryOptions<
    PermissionsListResponse,
    AxiosError<DefaultError>,
    PermissionsListResponse,
    ReturnType<typeof permissionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await permissionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: permissionsListQueryKey(options)
  })

export const permissionsListInfiniteQueryKey = (
  options?: Options<PermissionsListData>
): QueryKey<Options<PermissionsListData>> =>
  createQueryKey('permissionsList', options, true)

/**
 * Requires authentication; no workspace permission is required.
 */
export const permissionsListInfiniteOptions = (
  options?: Options<PermissionsListData>
) => {
  const opts = infiniteQueryOptions<
    PermissionsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<PermissionsListResponse>,
    QueryKey<Options<PermissionsListData>>,
    | number
    | Pick<
        QueryKey<Options<PermissionsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PermissionsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await permissionsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: permissionsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires a workspace administrator.
 */
export const permissionsCreateMutation = (
  options?: Partial<Options<PermissionsCreateData>>
): UseMutationOptions<
  PermissionsCreateResponse,
  AxiosError<DefaultError>,
  Options<PermissionsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    PermissionsCreateResponse,
    AxiosError<DefaultError>,
    Options<PermissionsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await permissionsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires a workspace administrator.
 */
export const permissionsDestroyMutation = (
  options?: Partial<Options<PermissionsDestroyData>>
): UseMutationOptions<
  PermissionsDestroyResponse,
  AxiosError<DefaultError>,
  Options<PermissionsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    PermissionsDestroyResponse,
    AxiosError<DefaultError>,
    Options<PermissionsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await permissionsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const permissionsRetrieveQueryKey = (
  options: Options<PermissionsRetrieveData>
) => createQueryKey('permissionsRetrieve', options)

/**
 * Requires authentication; no workspace permission is required.
 */
export const permissionsRetrieveOptions = (
  options: Options<PermissionsRetrieveData>
) =>
  queryOptions<
    PermissionsRetrieveResponse,
    AxiosError<DefaultError>,
    PermissionsRetrieveResponse,
    ReturnType<typeof permissionsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await permissionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: permissionsRetrieveQueryKey(options)
  })

/**
 * Requires a workspace administrator.
 */
export const permissionsPartialUpdateMutation = (
  options?: Partial<Options<PermissionsPartialUpdateData>>
): UseMutationOptions<
  PermissionsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<PermissionsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PermissionsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<PermissionsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await permissionsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsPermissionsUserListQueryKey = (
  options: Options<OrganizationsPermissionsUserListData>
) => createQueryKey('organizationsPermissionsUserList', options)

/**
 * Returns the list of permissions for the authenticated user in the specified organization.
 *
 * Permission resolution: - Admin roles (is_admin=True): Grant ALL permissions for their application scope * role.application set → ALL permissions for that application * role.application null → ALL organization-level permissions - Regular roles: Only explicitly assigned permissions - Multiple roles: Union of all permissions (deduplicated)
 *
 * Respects application_repository query filter if provided.
 *
 * Requires authentication; no workspace permission is required.
 */
export const organizationsPermissionsUserListOptions = (
  options: Options<OrganizationsPermissionsUserListData>
) =>
  queryOptions<
    OrganizationsPermissionsUserListResponse,
    AxiosError<DefaultError>,
    OrganizationsPermissionsUserListResponse,
    ReturnType<typeof organizationsPermissionsUserListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsPermissionsUserList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsPermissionsUserListQueryKey(options)
  })

export const organizationsRolesListQueryKey = (
  options?: Options<OrganizationsRolesListData>
) => createQueryKey('organizationsRolesList', options)

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesListOptions = (
  options?: Options<OrganizationsRolesListData>
) =>
  queryOptions<
    OrganizationsRolesListResponse,
    AxiosError<DefaultError>,
    OrganizationsRolesListResponse,
    ReturnType<typeof organizationsRolesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsRolesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsRolesListQueryKey(options)
  })

export const organizationsRolesListInfiniteQueryKey = (
  options?: Options<OrganizationsRolesListData>
): QueryKey<Options<OrganizationsRolesListData>> =>
  createQueryKey('organizationsRolesList', options, true)

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesListInfiniteOptions = (
  options?: Options<OrganizationsRolesListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsRolesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsRolesListResponse>,
    QueryKey<Options<OrganizationsRolesListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsRolesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsRolesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsRolesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsRolesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesCreateMutation = (
  options?: Partial<Options<OrganizationsRolesCreateData>>
): UseMutationOptions<
  OrganizationsRolesCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsRolesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRolesCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsRolesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsRolesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesDestroyMutation = (
  options?: Partial<Options<OrganizationsRolesDestroyData>>
): UseMutationOptions<
  OrganizationsRolesDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsRolesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRolesDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsRolesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsRolesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsRolesRetrieveQueryKey = (
  options: Options<OrganizationsRolesRetrieveData>
) => createQueryKey('organizationsRolesRetrieve', options)

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesRetrieveOptions = (
  options: Options<OrganizationsRolesRetrieveData>
) =>
  queryOptions<
    OrganizationsRolesRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsRolesRetrieveResponse,
    ReturnType<typeof organizationsRolesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsRolesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsRolesRetrieveQueryKey(options)
  })

/**
 * Organization roles CRUD and replacement. Requires a workspace administrator.
 */
export const organizationsRolesPartialUpdateMutation = (
  options?: Partial<Options<OrganizationsRolesPartialUpdateData>>
): UseMutationOptions<
  OrganizationsRolesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsRolesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRolesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsRolesPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsRolesPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Replace all users with this role to another role in the same organization. Requires a workspace administrator.
 */
export const organizationsRolesReplaceCreateMutation = (
  options?: Partial<Options<OrganizationsRolesReplaceCreateData>>
): UseMutationOptions<
  OrganizationsRolesReplaceCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsRolesReplaceCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsRolesReplaceCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsRolesReplaceCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsRolesReplaceCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsTeamUsersListQueryKey = (
  options?: Options<OrganizationsTeamUsersListData>
) => createQueryKey('organizationsTeamUsersList', options)

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.view`.
 */
export const organizationsTeamUsersListOptions = (
  options?: Options<OrganizationsTeamUsersListData>
) =>
  queryOptions<
    OrganizationsTeamUsersListResponse,
    AxiosError<DefaultError>,
    OrganizationsTeamUsersListResponse,
    ReturnType<typeof organizationsTeamUsersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsTeamUsersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsTeamUsersListQueryKey(options)
  })

export const organizationsTeamUsersListInfiniteQueryKey = (
  options?: Options<OrganizationsTeamUsersListData>
): QueryKey<Options<OrganizationsTeamUsersListData>> =>
  createQueryKey('organizationsTeamUsersList', options, true)

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.view`.
 */
export const organizationsTeamUsersListInfiniteOptions = (
  options?: Options<OrganizationsTeamUsersListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsTeamUsersListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsTeamUsersListResponse>,
    QueryKey<Options<OrganizationsTeamUsersListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsTeamUsersListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsTeamUsersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsTeamUsersList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsTeamUsersListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.manage`.
 */
export const organizationsTeamUsersCreateMutation = (
  options?: Partial<Options<OrganizationsTeamUsersCreateData>>
): UseMutationOptions<
  OrganizationsTeamUsersCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsTeamUsersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsTeamUsersCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsTeamUsersCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsTeamUsersCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.manage`.
 */
export const organizationsTeamUsersDestroyMutation = (
  options?: Partial<Options<OrganizationsTeamUsersDestroyData>>
): UseMutationOptions<
  OrganizationsTeamUsersDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsTeamUsersDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsTeamUsersDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsTeamUsersDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsTeamUsersDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsTeamUsersRetrieveQueryKey = (
  options: Options<OrganizationsTeamUsersRetrieveData>
) => createQueryKey('organizationsTeamUsersRetrieve', options)

/**
 * Team membership. The roles field is a legacy org-chart job-title list. Requires workspace permission: `users.view`.
 */
export const organizationsTeamUsersRetrieveOptions = (
  options: Options<OrganizationsTeamUsersRetrieveData>
) =>
  queryOptions<
    OrganizationsTeamUsersRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsTeamUsersRetrieveResponse,
    ReturnType<typeof organizationsTeamUsersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsTeamUsersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsTeamUsersRetrieveQueryKey(options)
  })

export const organizationsTeamsListQueryKey = (
  options?: Options<OrganizationsTeamsListData>
) => createQueryKey('organizationsTeamsList', options)

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsTeamsListOptions = (
  options?: Options<OrganizationsTeamsListData>
) =>
  queryOptions<
    OrganizationsTeamsListResponse,
    AxiosError<DefaultError>,
    OrganizationsTeamsListResponse,
    ReturnType<typeof organizationsTeamsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsTeamsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsTeamsListQueryKey(options)
  })

export const organizationsTeamsListInfiniteQueryKey = (
  options?: Options<OrganizationsTeamsListData>
): QueryKey<Options<OrganizationsTeamsListData>> =>
  createQueryKey('organizationsTeamsList', options, true)

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsTeamsListInfiniteOptions = (
  options?: Options<OrganizationsTeamsListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsTeamsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsTeamsListResponse>,
    QueryKey<Options<OrganizationsTeamsListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsTeamsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsTeamsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsTeamsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsTeamsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsTeamsCreateMutation = (
  options?: Partial<Options<OrganizationsTeamsCreateData>>
): UseMutationOptions<
  OrganizationsTeamsCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsTeamsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsTeamsCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsTeamsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsTeamsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsTeamsDestroyMutation = (
  options?: Partial<Options<OrganizationsTeamsDestroyData>>
): UseMutationOptions<
  OrganizationsTeamsDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsTeamsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsTeamsDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsTeamsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsTeamsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsTeamsRetrieveQueryKey = (
  options: Options<OrganizationsTeamsRetrieveData>
) => createQueryKey('organizationsTeamsRetrieve', options)

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsTeamsRetrieveOptions = (
  options: Options<OrganizationsTeamsRetrieveData>
) =>
  queryOptions<
    OrganizationsTeamsRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsTeamsRetrieveResponse,
    ReturnType<typeof organizationsTeamsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsTeamsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsTeamsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const organizationsTeamsPartialUpdateMutation = (
  options?: Partial<Options<OrganizationsTeamsPartialUpdateData>>
): UseMutationOptions<
  OrganizationsTeamsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsTeamsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsTeamsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsTeamsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsTeamsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsTeamsOrganigramListQueryKey = (
  options: Options<OrganizationsTeamsOrganigramListData>
) => createQueryKey('organizationsTeamsOrganigramList', options)

/**
 * Requires workspace permission: `users.view`.
 */
export const organizationsTeamsOrganigramListOptions = (
  options: Options<OrganizationsTeamsOrganigramListData>
) =>
  queryOptions<
    OrganizationsTeamsOrganigramListResponse,
    AxiosError<DefaultError>,
    OrganizationsTeamsOrganigramListResponse,
    ReturnType<typeof organizationsTeamsOrganigramListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsTeamsOrganigramList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsTeamsOrganigramListQueryKey(options)
  })

export const organizationsUserGroupsListQueryKey = (
  options?: Options<OrganizationsUserGroupsListData>
) => createQueryKey('organizationsUserGroupsList', options)

/**
 * Requires workspace permission: `groups.view`.
 */
export const organizationsUserGroupsListOptions = (
  options?: Options<OrganizationsUserGroupsListData>
) =>
  queryOptions<
    OrganizationsUserGroupsListResponse,
    AxiosError<DefaultError>,
    OrganizationsUserGroupsListResponse,
    ReturnType<typeof organizationsUserGroupsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsUserGroupsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsUserGroupsListQueryKey(options)
  })

export const organizationsUserGroupsListInfiniteQueryKey = (
  options?: Options<OrganizationsUserGroupsListData>
): QueryKey<Options<OrganizationsUserGroupsListData>> =>
  createQueryKey('organizationsUserGroupsList', options, true)

/**
 * Requires workspace permission: `groups.view`.
 */
export const organizationsUserGroupsListInfiniteOptions = (
  options?: Options<OrganizationsUserGroupsListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsUserGroupsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsUserGroupsListResponse>,
    QueryKey<Options<OrganizationsUserGroupsListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsUserGroupsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsUserGroupsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsUserGroupsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsUserGroupsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsCreateMutation = (
  options?: Partial<Options<OrganizationsUserGroupsCreateData>>
): UseMutationOptions<
  OrganizationsUserGroupsCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsUserGroupsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUserGroupsCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsUserGroupsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsUserGroupsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsDestroyMutation = (
  options?: Partial<Options<OrganizationsUserGroupsDestroyData>>
): UseMutationOptions<
  OrganizationsUserGroupsDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsUserGroupsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUserGroupsDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsUserGroupsDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsUserGroupsDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsUserGroupsRetrieveQueryKey = (
  options: Options<OrganizationsUserGroupsRetrieveData>
) => createQueryKey('organizationsUserGroupsRetrieve', options)

/**
 * Requires workspace permission: `groups.view`.
 */
export const organizationsUserGroupsRetrieveOptions = (
  options: Options<OrganizationsUserGroupsRetrieveData>
) =>
  queryOptions<
    OrganizationsUserGroupsRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsUserGroupsRetrieveResponse,
    ReturnType<typeof organizationsUserGroupsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsUserGroupsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsUserGroupsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsPartialUpdateMutation = (
  options?: Partial<Options<OrganizationsUserGroupsPartialUpdateData>>
): UseMutationOptions<
  OrganizationsUserGroupsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsUserGroupsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUserGroupsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsUserGroupsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsUserGroupsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Replace the roles this group grants within one application.
 *
 * People → Groups inside an app only shows that app's roles, so replacing the whole-group set from there would drop the roles of every other app.
 *
 * Requires workspace permission: `groups.manage`.
 */
export const organizationsUserGroupsApplicationsRolesPartialUpdateMutation = (
  options?: Partial<
    Options<OrganizationsUserGroupsApplicationsRolesPartialUpdateData>
  >
): UseMutationOptions<
  OrganizationsUserGroupsApplicationsRolesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsUserGroupsApplicationsRolesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsUserGroupsApplicationsRolesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsUserGroupsApplicationsRolesPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await organizationsUserGroupsApplicationsRolesPartialUpdate({
          ...options,
          ...fnOptions,
          throwOnError: true
        })
      return data
    }
  }
  return mutationOptions
}

export const organizationsValidateRetrieveQueryKey = (
  options: Options<OrganizationsValidateRetrieveData>
) => createQueryKey('organizationsValidateRetrieve', options)

export const organizationsValidateRetrieveOptions = (
  options: Options<OrganizationsValidateRetrieveData>
) =>
  queryOptions<
    OrganizationsValidateRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsValidateRetrieveResponse,
    ReturnType<typeof organizationsValidateRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsValidateRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsValidateRetrieveQueryKey(options)
  })

export const organizationsWorkspacePermissionsListQueryKey = (
  options: Options<OrganizationsWorkspacePermissionsListData>
) => createQueryKey('organizationsWorkspacePermissionsList', options)

/**
 * Requires workspace permission: `roles.view`.
 */
export const organizationsWorkspacePermissionsListOptions = (
  options: Options<OrganizationsWorkspacePermissionsListData>
) =>
  queryOptions<
    OrganizationsWorkspacePermissionsListResponse,
    AxiosError<DefaultError>,
    OrganizationsWorkspacePermissionsListResponse,
    ReturnType<typeof organizationsWorkspacePermissionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsWorkspacePermissionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsWorkspacePermissionsListQueryKey(options)
  })

export const organizationsWorkspaceRolesListQueryKey = (
  options: Options<OrganizationsWorkspaceRolesListData>
) => createQueryKey('organizationsWorkspaceRolesList', options)

/**
 * Requires workspace permission: `roles.view`.
 */
export const organizationsWorkspaceRolesListOptions = (
  options: Options<OrganizationsWorkspaceRolesListData>
) =>
  queryOptions<
    OrganizationsWorkspaceRolesListResponse,
    AxiosError<DefaultError>,
    OrganizationsWorkspaceRolesListResponse,
    ReturnType<typeof organizationsWorkspaceRolesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsWorkspaceRolesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsWorkspaceRolesListQueryKey(options)
  })

export const organizationsWorkspaceRolesListInfiniteQueryKey = (
  options: Options<OrganizationsWorkspaceRolesListData>
): QueryKey<Options<OrganizationsWorkspaceRolesListData>> =>
  createQueryKey('organizationsWorkspaceRolesList', options, true)

/**
 * Requires workspace permission: `roles.view`.
 */
export const organizationsWorkspaceRolesListInfiniteOptions = (
  options: Options<OrganizationsWorkspaceRolesListData>
) => {
  const opts = infiniteQueryOptions<
    OrganizationsWorkspaceRolesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OrganizationsWorkspaceRolesListResponse>,
    QueryKey<Options<OrganizationsWorkspaceRolesListData>>,
    | number
    | Pick<
        QueryKey<Options<OrganizationsWorkspaceRolesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OrganizationsWorkspaceRolesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await organizationsWorkspaceRolesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: organizationsWorkspaceRolesListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.manage`.
 */
export const organizationsWorkspaceRolesCreateMutation = (
  options?: Partial<Options<OrganizationsWorkspaceRolesCreateData>>
): UseMutationOptions<
  OrganizationsWorkspaceRolesCreateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsWorkspaceRolesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsWorkspaceRolesCreateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsWorkspaceRolesCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsWorkspaceRolesCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.manage`.
 */
export const organizationsWorkspaceRolesDestroyMutation = (
  options?: Partial<Options<OrganizationsWorkspaceRolesDestroyData>>
): UseMutationOptions<
  OrganizationsWorkspaceRolesDestroyResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsWorkspaceRolesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsWorkspaceRolesDestroyResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsWorkspaceRolesDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsWorkspaceRolesDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const organizationsWorkspaceRolesRetrieveQueryKey = (
  options: Options<OrganizationsWorkspaceRolesRetrieveData>
) => createQueryKey('organizationsWorkspaceRolesRetrieve', options)

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.view`.
 */
export const organizationsWorkspaceRolesRetrieveOptions = (
  options: Options<OrganizationsWorkspaceRolesRetrieveData>
) =>
  queryOptions<
    OrganizationsWorkspaceRolesRetrieveResponse,
    AxiosError<DefaultError>,
    OrganizationsWorkspaceRolesRetrieveResponse,
    ReturnType<typeof organizationsWorkspaceRolesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationsWorkspaceRolesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: organizationsWorkspaceRolesRetrieveQueryKey(options)
  })

/**
 * Workspace-only roles; application roles are deliberately excluded. Requires workspace permission: `roles.manage`.
 */
export const organizationsWorkspaceRolesPartialUpdateMutation = (
  options?: Partial<Options<OrganizationsWorkspaceRolesPartialUpdateData>>
): UseMutationOptions<
  OrganizationsWorkspaceRolesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OrganizationsWorkspaceRolesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OrganizationsWorkspaceRolesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OrganizationsWorkspaceRolesPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await organizationsWorkspaceRolesPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const schemaRetrieveQueryKey = (options?: Options<SchemaRetrieveData>) =>
  createQueryKey('schemaRetrieve', options)

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieveOptions = (options?: Options<SchemaRetrieveData>) =>
  queryOptions<
    SchemaRetrieveResponse,
    AxiosError<DefaultError>,
    SchemaRetrieveResponse,
    ReturnType<typeof schemaRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: schemaRetrieveQueryKey(options)
  })

export const mcpConnectionsListQueryKey = (
  options: Options<McpConnectionsListData>
) => createQueryKey('mcpConnectionsList', options)

/**
 * Requires workspace permission: `applications.view`. Connections of every status, newest first.
 */
export const mcpConnectionsListOptions = (
  options: Options<McpConnectionsListData>
) =>
  queryOptions<
    McpConnectionsListResponse,
    AxiosError<DefaultError>,
    McpConnectionsListResponse,
    ReturnType<typeof mcpConnectionsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mcpConnectionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mcpConnectionsListQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const mcpConnectionsRevokeMutation = (
  options?: Partial<Options<McpConnectionsRevokeData>>
): UseMutationOptions<
  McpConnectionsRevokeResponse,
  AxiosError<DefaultError>,
  Options<McpConnectionsRevokeData>
> => {
  const mutationOptions: UseMutationOptions<
    McpConnectionsRevokeResponse,
    AxiosError<DefaultError>,
    Options<McpConnectionsRevokeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpConnectionsRevoke({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`. Replaces an active connection's scopes.
 */
export const mcpConnectionsScopesUpdateMutation = (
  options?: Partial<Options<McpConnectionsScopesUpdateData>>
): UseMutationOptions<
  McpConnectionsScopesUpdateResponse,
  AxiosError<DefaultError>,
  Options<McpConnectionsScopesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    McpConnectionsScopesUpdateResponse,
    AxiosError<DefaultError>,
    Options<McpConnectionsScopesUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpConnectionsScopesUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const mcpPoliciesListQueryKey = (
  options: Options<McpPoliciesListData>
) => createQueryKey('mcpPoliciesList', options)

/**
 * Requires workspace permission: `applications.view`.
 */
export const mcpPoliciesListOptions = (options: Options<McpPoliciesListData>) =>
  queryOptions<
    McpPoliciesListResponse,
    AxiosError<DefaultError>,
    McpPoliciesListResponse,
    ReturnType<typeof mcpPoliciesListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mcpPoliciesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: mcpPoliciesListQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`. Disabling the service revokes every connection of it.
 */
export const mcpPoliciesPartialUpdateMutation = (
  options?: Partial<Options<McpPoliciesPartialUpdateData>>
): UseMutationOptions<
  McpPoliciesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<McpPoliciesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    McpPoliciesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<McpPoliciesPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await mcpPoliciesPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const settingsOutboundWebhooksWebhooksListQueryKey = (
  options: Options<SettingsOutboundWebhooksWebhooksListData>
) => createQueryKey('settingsOutboundWebhooksWebhooksList', options)

/**
 * Filter with `managed_by` / `managed_ref` (exact match) to find the webhook another service manages, e.g. `?managed_by=squad&managed_ref=agent:<uuid>`.
 *
 * Requires workspace permission: `applications.view`.
 */
export const settingsOutboundWebhooksWebhooksListOptions = (
  options: Options<SettingsOutboundWebhooksWebhooksListData>
) =>
  queryOptions<
    SettingsOutboundWebhooksWebhooksListResponse,
    AxiosError<DefaultError>,
    SettingsOutboundWebhooksWebhooksListResponse,
    ReturnType<typeof settingsOutboundWebhooksWebhooksListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingsOutboundWebhooksWebhooksList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: settingsOutboundWebhooksWebhooksListQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksCreateMutation = (
  options?: Partial<Options<SettingsOutboundWebhooksWebhooksCreateData>>
): UseMutationOptions<
  SettingsOutboundWebhooksWebhooksCreateResponse,
  AxiosError<DefaultError>,
  Options<SettingsOutboundWebhooksWebhooksCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsOutboundWebhooksWebhooksCreateResponse,
    AxiosError<DefaultError>,
    Options<SettingsOutboundWebhooksWebhooksCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsOutboundWebhooksWebhooksCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Settings CRUD for outbound webhooks.
 *
 * Saving or deleting here pushes the change to the organization's CRM instance through ``apps/integration/outbound_webhook_sync.py`` -- the viewset itself does not call CRM.
 *
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksDestroyMutation = (
  options?: Partial<Options<SettingsOutboundWebhooksWebhooksDestroyData>>
): UseMutationOptions<
  SettingsOutboundWebhooksWebhooksDestroyResponse,
  AxiosError<DefaultError>,
  Options<SettingsOutboundWebhooksWebhooksDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsOutboundWebhooksWebhooksDestroyResponse,
    AxiosError<DefaultError>,
    Options<SettingsOutboundWebhooksWebhooksDestroyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsOutboundWebhooksWebhooksDestroy({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const settingsOutboundWebhooksWebhooksRetrieveQueryKey = (
  options: Options<SettingsOutboundWebhooksWebhooksRetrieveData>
) => createQueryKey('settingsOutboundWebhooksWebhooksRetrieve', options)

/**
 * Settings CRUD for outbound webhooks.
 *
 * Saving or deleting here pushes the change to the organization's CRM instance through ``apps/integration/outbound_webhook_sync.py`` -- the viewset itself does not call CRM.
 *
 * Requires workspace permission: `applications.view`.
 */
export const settingsOutboundWebhooksWebhooksRetrieveOptions = (
  options: Options<SettingsOutboundWebhooksWebhooksRetrieveData>
) =>
  queryOptions<
    SettingsOutboundWebhooksWebhooksRetrieveResponse,
    AxiosError<DefaultError>,
    SettingsOutboundWebhooksWebhooksRetrieveResponse,
    ReturnType<typeof settingsOutboundWebhooksWebhooksRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingsOutboundWebhooksWebhooksRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: settingsOutboundWebhooksWebhooksRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksPartialUpdateMutation = (
  options?: Partial<Options<SettingsOutboundWebhooksWebhooksPartialUpdateData>>
): UseMutationOptions<
  SettingsOutboundWebhooksWebhooksPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<SettingsOutboundWebhooksWebhooksPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsOutboundWebhooksWebhooksPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<SettingsOutboundWebhooksWebhooksPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsOutboundWebhooksWebhooksPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * POST, not GET, deliberately.
 *
 * It writes an audit record, and a GET would put a secret-bearing URL into access logs, browser history and any intermediate proxy cache.
 *
 * Not rate limited: an organization holds at most a handful of webhooks, so a cap on how often the endpoint may be called would not stop anyone from collecting the whole set anyway. The audit record is what answers "who had access" after a leak.
 *
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksRevealSecretCreateMutation = (
  options?: Partial<
    Options<SettingsOutboundWebhooksWebhooksRevealSecretCreateData>
  >
): UseMutationOptions<
  SettingsOutboundWebhooksWebhooksRevealSecretCreateResponse,
  AxiosError<DefaultError>,
  Options<SettingsOutboundWebhooksWebhooksRevealSecretCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsOutboundWebhooksWebhooksRevealSecretCreateResponse,
    AxiosError<DefaultError>,
    Options<SettingsOutboundWebhooksWebhooksRevealSecretCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsOutboundWebhooksWebhooksRevealSecretCreate(
        {
          ...options,
          ...fnOptions,
          throwOnError: true
        }
      )
      return data
    }
  }
  return mutationOptions
}

/**
 * Send one signed test delivery to the configured URL and report what came back.
 *
 * Rate limited, unlike reveal-secret: this one makes the server issue an outbound request to an address the caller controls, so without a cap it is a scanner with our egress.
 *
 * Always 200. The interesting outcomes -- refused URL, timeout, the consumer's own 4xx -- are the answer, not an error in this API, and the UI renders them from one shape.
 *
 * Requires workspace permission: `applications.manage`.
 */
export const settingsOutboundWebhooksWebhooksTestCreateMutation = (
  options?: Partial<Options<SettingsOutboundWebhooksWebhooksTestCreateData>>
): UseMutationOptions<
  SettingsOutboundWebhooksWebhooksTestCreateResponse,
  AxiosError<DefaultError>,
  Options<SettingsOutboundWebhooksWebhooksTestCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsOutboundWebhooksWebhooksTestCreateResponse,
    AxiosError<DefaultError>,
    Options<SettingsOutboundWebhooksWebhooksTestCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsOutboundWebhooksWebhooksTestCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const settingsPublicAccessCredentialsListQueryKey = (
  options: Options<SettingsPublicAccessCredentialsListData>
) => createQueryKey('settingsPublicAccessCredentialsList', options)

/**
 * Requires workspace permission: `applications.view`.
 */
export const settingsPublicAccessCredentialsListOptions = (
  options: Options<SettingsPublicAccessCredentialsListData>
) =>
  queryOptions<
    SettingsPublicAccessCredentialsListResponse,
    AxiosError<DefaultError>,
    SettingsPublicAccessCredentialsListResponse,
    ReturnType<typeof settingsPublicAccessCredentialsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingsPublicAccessCredentialsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: settingsPublicAccessCredentialsListQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsCreateMutation = (
  options?: Partial<Options<SettingsPublicAccessCredentialsCreateData>>
): UseMutationOptions<
  SettingsPublicAccessCredentialsCreateResponse,
  AxiosError<DefaultError>,
  Options<SettingsPublicAccessCredentialsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsPublicAccessCredentialsCreateResponse,
    AxiosError<DefaultError>,
    Options<SettingsPublicAccessCredentialsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsPublicAccessCredentialsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const settingsPublicAccessCredentialsRetrieveQueryKey = (
  options: Options<SettingsPublicAccessCredentialsRetrieveData>
) => createQueryKey('settingsPublicAccessCredentialsRetrieve', options)

/**
 * Requires workspace permission: `applications.view`.
 */
export const settingsPublicAccessCredentialsRetrieveOptions = (
  options: Options<SettingsPublicAccessCredentialsRetrieveData>
) =>
  queryOptions<
    SettingsPublicAccessCredentialsRetrieveResponse,
    AxiosError<DefaultError>,
    SettingsPublicAccessCredentialsRetrieveResponse,
    ReturnType<typeof settingsPublicAccessCredentialsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingsPublicAccessCredentialsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: settingsPublicAccessCredentialsRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsPartialUpdateMutation = (
  options?: Partial<Options<SettingsPublicAccessCredentialsPartialUpdateData>>
): UseMutationOptions<
  SettingsPublicAccessCredentialsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<SettingsPublicAccessCredentialsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsPublicAccessCredentialsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<SettingsPublicAccessCredentialsPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsPublicAccessCredentialsPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsRevokeCreateMutation = (
  options?: Partial<Options<SettingsPublicAccessCredentialsRevokeCreateData>>
): UseMutationOptions<
  SettingsPublicAccessCredentialsRevokeCreateResponse,
  AxiosError<DefaultError>,
  Options<SettingsPublicAccessCredentialsRevokeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsPublicAccessCredentialsRevokeCreateResponse,
    AxiosError<DefaultError>,
    Options<SettingsPublicAccessCredentialsRevokeCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsPublicAccessCredentialsRevokeCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `applications.manage`.
 */
export const settingsPublicAccessCredentialsRotateCreateMutation = (
  options?: Partial<Options<SettingsPublicAccessCredentialsRotateCreateData>>
): UseMutationOptions<
  SettingsPublicAccessCredentialsRotateCreateResponse,
  AxiosError<DefaultError>,
  Options<SettingsPublicAccessCredentialsRotateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsPublicAccessCredentialsRotateCreateResponse,
    AxiosError<DefaultError>,
    Options<SettingsPublicAccessCredentialsRotateCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await settingsPublicAccessCredentialsRotateCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const staticRetrieveQueryKey = (options: Options<StaticRetrieveData>) =>
  createQueryKey('staticRetrieve', options)

export const staticRetrieveOptions = (options: Options<StaticRetrieveData>) =>
  queryOptions<
    StaticRetrieveResponse,
    AxiosError<DefaultError>,
    StaticRetrieveResponse,
    ReturnType<typeof staticRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await staticRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: staticRetrieveQueryKey(options)
  })

export const supportReportCreateMutation = (
  options?: Partial<Options<SupportReportCreateData>>
): UseMutationOptions<
  SupportReportCreateResponse,
  AxiosError<DefaultError>,
  Options<SupportReportCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SupportReportCreateResponse,
    AxiosError<DefaultError>,
    Options<SupportReportCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await supportReportCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const supportTicketsListQueryKey = (
  options?: Options<SupportTicketsListData>
) => createQueryKey('supportTicketsList', options)

/**
 * Tickets filed by the caller in the caller's current organization.
 */
export const supportTicketsListOptions = (
  options?: Options<SupportTicketsListData>
) =>
  queryOptions<
    SupportTicketsListResponse,
    AxiosError<DefaultError>,
    SupportTicketsListResponse,
    ReturnType<typeof supportTicketsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await supportTicketsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: supportTicketsListQueryKey(options)
  })

export const supportTicketsListInfiniteQueryKey = (
  options?: Options<SupportTicketsListData>
): QueryKey<Options<SupportTicketsListData>> =>
  createQueryKey('supportTicketsList', options, true)

/**
 * Tickets filed by the caller in the caller's current organization.
 */
export const supportTicketsListInfiniteOptions = (
  options?: Options<SupportTicketsListData>
) => {
  const opts = infiniteQueryOptions<
    SupportTicketsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SupportTicketsListResponse>,
    QueryKey<Options<SupportTicketsListData>>,
    | number
    | Pick<
        QueryKey<Options<SupportTicketsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SupportTicketsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await supportTicketsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: supportTicketsListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

/**
 * Files a ticket. Reporter, organization and environment are taken from the session, not the body.
 */
export const supportTicketsCreateMutation = (
  options?: Partial<Options<SupportTicketsCreateData>>
): UseMutationOptions<
  SupportTicketsCreateResponse,
  AxiosError<DefaultError>,
  Options<SupportTicketsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SupportTicketsCreateResponse,
    AxiosError<DefaultError>,
    Options<SupportTicketsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await supportTicketsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const supportTicketsRetrieveQueryKey = (
  options: Options<SupportTicketsRetrieveData>
) => createQueryKey('supportTicketsRetrieve', options)

export const supportTicketsRetrieveOptions = (
  options: Options<SupportTicketsRetrieveData>
) =>
  queryOptions<
    SupportTicketsRetrieveResponse,
    AxiosError<DefaultError>,
    SupportTicketsRetrieveResponse,
    ReturnType<typeof supportTicketsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await supportTicketsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: supportTicketsRetrieveQueryKey(options)
  })

export const supportTicketsCommentsListQueryKey = (
  options: Options<SupportTicketsCommentsListData>
) => createQueryKey('supportTicketsCommentsList', options)

export const supportTicketsCommentsListOptions = (
  options: Options<SupportTicketsCommentsListData>
) =>
  queryOptions<
    SupportTicketsCommentsListResponse,
    AxiosError<DefaultError>,
    SupportTicketsCommentsListResponse,
    ReturnType<typeof supportTicketsCommentsListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await supportTicketsCommentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: supportTicketsCommentsListQueryKey(options)
  })

export const supportTicketsCommentsCreateMutation = (
  options?: Partial<Options<SupportTicketsCommentsCreateData>>
): UseMutationOptions<
  SupportTicketsCommentsCreateResponse,
  AxiosError<DefaultError>,
  Options<SupportTicketsCommentsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SupportTicketsCommentsCreateResponse,
    AxiosError<DefaultError>,
    Options<SupportTicketsCommentsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await supportTicketsCommentsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const supportTicketsUnseenCountRetrieveQueryKey = (
  options?: Options<SupportTicketsUnseenCountRetrieveData>
) => createQueryKey('supportTicketsUnseenCountRetrieve', options)

/**
 * How many of the caller's tickets changed in ClickUp since the caller last opened them.
 */
export const supportTicketsUnseenCountRetrieveOptions = (
  options?: Options<SupportTicketsUnseenCountRetrieveData>
) =>
  queryOptions<
    SupportTicketsUnseenCountRetrieveResponse,
    AxiosError<DefaultError>,
    SupportTicketsUnseenCountRetrieveResponse,
    ReturnType<typeof supportTicketsUnseenCountRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await supportTicketsUnseenCountRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: supportTicketsUnseenCountRetrieveQueryKey(options)
  })

/**
 * Mints a presigned PUT the browser uploads a ticket attachment to directly, returning the id to pass back in attachment_ids when filing the ticket. The PUT must send `Content-Type` equal to the returned `content_type`: it is part of the signature, so a different or missing header is rejected by the storage.
 */
export const supportTicketsUploadsCreateMutation = (
  options?: Partial<Options<SupportTicketsUploadsCreateData>>
): UseMutationOptions<
  SupportTicketsUploadsCreateResponse,
  AxiosError<DefaultError>,
  Options<SupportTicketsUploadsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SupportTicketsUploadsCreateResponse,
    AxiosError<DefaultError>,
    Options<SupportTicketsUploadsCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await supportTicketsUploadsCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const usersListQueryKey = (options?: Options<UsersListData>) =>
  createQueryKey('usersList', options)

/**
 * Returns users who share a workspace with the caller; no workspace permission is required.
 */
export const usersListOptions = (options?: Options<UsersListData>) =>
  queryOptions<
    UsersListResponse,
    AxiosError<DefaultError>,
    UsersListResponse,
    ReturnType<typeof usersListQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: usersListQueryKey(options)
  })

export const usersListInfiniteQueryKey = (
  options?: Options<UsersListData>
): QueryKey<Options<UsersListData>> =>
  createQueryKey('usersList', options, true)

/**
 * Returns users who share a workspace with the caller; no workspace permission is required.
 */
export const usersListInfiniteOptions = (options?: Options<UsersListData>) => {
  const opts = infiniteQueryOptions<
    UsersListResponse,
    AxiosError<DefaultError>,
    InfiniteData<UsersListResponse>,
    QueryKey<Options<UsersListData>>,
    | number
    | Pick<
        QueryKey<Options<UsersListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<UsersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await usersList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })
        return data
      },
      queryKey: usersListInfiniteQueryKey(options)
    }
  )
  return opts as Omit<typeof opts, 'initialData'>
}

export const usersRetrieveQueryKey = (options: Options<UsersRetrieveData>) =>
  createQueryKey('usersRetrieve', options)

/**
 * Requires a shared workspace with the requested user; no workspace permission is required.
 */
export const usersRetrieveOptions = (options: Options<UsersRetrieveData>) =>
  queryOptions<
    UsersRetrieveResponse,
    AxiosError<DefaultError>,
    UsersRetrieveResponse,
    ReturnType<typeof usersRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: usersRetrieveQueryKey(options)
  })

/**
 * Requires the caller to be the requested user or a workspace administrator.
 */
export const usersPartialUpdateMutation = (
  options?: Partial<Options<UsersPartialUpdateData>>
): UseMutationOptions<
  UsersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<UsersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<UsersPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires a workspace administrator.
 */
export const usersAddInOrganizationCreateMutation = (
  options?: Partial<Options<UsersAddInOrganizationCreateData>>
): UseMutationOptions<
  UsersAddInOrganizationCreateResponse,
  AxiosError<DefaultError>,
  Options<UsersAddInOrganizationCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersAddInOrganizationCreateResponse,
    AxiosError<DefaultError>,
    Options<UsersAddInOrganizationCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersAddInOrganizationCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveCreateMutation = (
  options?: Partial<Options<UsersArchiveCreateData>>
): UseMutationOptions<
  UsersArchiveCreateResponse,
  AxiosError<UsersArchiveCreateError>,
  Options<UsersArchiveCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersArchiveCreateResponse,
    AxiosError<UsersArchiveCreateError>,
    Options<UsersArchiveCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersArchiveCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const usersArchiveDependenciesRetrieveQueryKey = (
  options: Options<UsersArchiveDependenciesRetrieveData>
) => createQueryKey('usersArchiveDependenciesRetrieve', options)

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveDependenciesRetrieveOptions = (
  options: Options<UsersArchiveDependenciesRetrieveData>
) =>
  queryOptions<
    UsersArchiveDependenciesRetrieveResponse,
    AxiosError<UsersArchiveDependenciesRetrieveError>,
    UsersArchiveDependenciesRetrieveResponse,
    ReturnType<typeof usersArchiveDependenciesRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersArchiveDependenciesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: usersArchiveDependenciesRetrieveQueryKey(options)
  })

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveReplaceAndArchiveCreateMutation = (
  options?: Partial<Options<UsersArchiveReplaceAndArchiveCreateData>>
): UseMutationOptions<
  UsersArchiveReplaceAndArchiveCreateResponse,
  AxiosError<UsersArchiveReplaceAndArchiveCreateError>,
  Options<UsersArchiveReplaceAndArchiveCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersArchiveReplaceAndArchiveCreateResponse,
    AxiosError<UsersArchiveReplaceAndArchiveCreateError>,
    Options<UsersArchiveReplaceAndArchiveCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersArchiveReplaceAndArchiveCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const usersArchiveJobsRetrieveQueryKey = (
  options: Options<UsersArchiveJobsRetrieveData>
) => createQueryKey('usersArchiveJobsRetrieve', options)

/**
 * Requires workspace permission: `users.manage`.
 */
export const usersArchiveJobsRetrieveOptions = (
  options: Options<UsersArchiveJobsRetrieveData>
) =>
  queryOptions<
    UsersArchiveJobsRetrieveResponse,
    AxiosError<DefaultError>,
    UsersArchiveJobsRetrieveResponse,
    ReturnType<typeof usersArchiveJobsRetrieveQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersArchiveJobsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })
      return data
    },
    queryKey: usersArchiveJobsRetrieveQueryKey(options)
  })

/**
 * Edits the caller's own user record. No workspace permission is required.
 */
export const usersEditPartialUpdateMutation = (
  options?: Partial<Options<UsersEditPartialUpdateData>>
): UseMutationOptions<
  UsersEditPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<UsersEditPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersEditPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<UsersEditPartialUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersEditPartialUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Edits the caller's own user record. No workspace permission is required.
 *
 * @deprecated
 */
export const usersEditUpdateMutation = (
  options?: Partial<Options<UsersEditUpdateData>>
): UseMutationOptions<
  UsersEditUpdateResponse,
  AxiosError<DefaultError>,
  Options<UsersEditUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersEditUpdateResponse,
    AxiosError<DefaultError>,
    Options<UsersEditUpdateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersEditUpdate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const usersLoginAdminCreateMutation = (
  options?: Partial<Options<UsersLoginAdminCreateData>>
): UseMutationOptions<
  UsersLoginAdminCreateResponse,
  AxiosError<DefaultError>,
  Options<UsersLoginAdminCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersLoginAdminCreateResponse,
    AxiosError<DefaultError>,
    Options<UsersLoginAdminCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersLoginAdminCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const usersLoginUserCreateMutation = (
  options?: Partial<Options<UsersLoginUserCreateData>>
): UseMutationOptions<
  UsersLoginUserCreateResponse,
  AxiosError<DefaultError>,
  Options<UsersLoginUserCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersLoginUserCreateResponse,
    AxiosError<DefaultError>,
    Options<UsersLoginUserCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersLoginUserCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

export const usersNotificationServiceSyncCreateMutation = (
  options?: Partial<Options<UsersNotificationServiceSyncCreateData>>
): UseMutationOptions<
  UsersNotificationServiceSyncCreateResponse,
  AxiosError<DefaultError>,
  Options<UsersNotificationServiceSyncCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersNotificationServiceSyncCreateResponse,
    AxiosError<DefaultError>,
    Options<UsersNotificationServiceSyncCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersNotificationServiceSyncCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}

/**
 * Requires a workspace administrator.
 */
export const usersSyncActiveDirectoryCreateMutation = (
  options?: Partial<Options<UsersSyncActiveDirectoryCreateData>>
): UseMutationOptions<
  UsersSyncActiveDirectoryCreateResponse,
  AxiosError<DefaultError>,
  Options<UsersSyncActiveDirectoryCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersSyncActiveDirectoryCreateResponse,
    AxiosError<DefaultError>,
    Options<UsersSyncActiveDirectoryCreateData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await usersSyncActiveDirectoryCreate({
        ...options,
        ...fnOptions,
        throwOnError: true
      })
      return data
    }
  }
  return mutationOptions
}
